/* tslint:disable */
/* eslint-disable */
/**
 * Yubico Enterprise Delivery Service Admin Private API
 * This is the Yubico Enterprise Delivery Service Admin Private API Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface APIResponse
 */
export interface APIResponse {
    /**
     * 
     * @type {string}
     * @memberof APIResponse
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof APIResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'country_code_2': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'recipient'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'recipient_telephone': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street_line1': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     * @deprecated
     */
    'street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'city': string;
    /**
     * Required if `country_code_2` is either \"US\" or \"CA\"
     * @type {string}
     * @memberof Address
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'postal_code': string;
}
/**
 * 
 * @export
 * @interface AddressOverride
 */
export interface AddressOverride {
    /**
     * 
     * @type {string}
     * @memberof AddressOverride
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface AdminCreateInventoryAllocationRequest
 */
export interface AdminCreateInventoryAllocationRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminCreateInventoryAllocationRequest
     */
    'organization_id': string;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateInventoryAllocationRequest
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateInventoryAllocationRequest
     */
    'customization_id': string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateInventoryAllocationRequest
     */
    'delta': number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateInventoryAllocationRequest
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface AdminFeatureToggleCollectionResponse
 */
export interface AdminFeatureToggleCollectionResponse {
    /**
     * 
     * @type {Array<AdminFeatureToggleResponse>}
     * @memberof AdminFeatureToggleCollectionResponse
     */
    'toggles': Array<AdminFeatureToggleResponse>;
}
/**
 * 
 * @export
 * @interface AdminFeatureToggleResponse
 */
export interface AdminFeatureToggleResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminFeatureToggleResponse
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminFeatureToggleResponse
     */
    'enabled': boolean;
}
/**
 * @type AdminGetDistributorsSearchParameter
 * @export
 */
export type AdminGetDistributorsSearchParameter = Array<string> | string;

/**
 * 
 * @export
 * @interface AdminHigherTierOrganizationResponse
 */
export interface AdminHigherTierOrganizationResponse {
    /**
     * 
     * @type {OrganizationIdAndName}
     * @memberof AdminHigherTierOrganizationResponse
     */
    'higher_tier_organization': OrganizationIdAndName;
    /**
     * 
     * @type {number}
     * @memberof AdminHigherTierOrganizationResponse
     */
    'lower_tier_count': number;
}
/**
 * 
 * @export
 * @interface AdminHigherTierOrganizationResponseSet
 */
export interface AdminHigherTierOrganizationResponseSet {
    /**
     * 
     * @type {number}
     * @memberof AdminHigherTierOrganizationResponseSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminHigherTierOrganizationResponseSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<AdminHigherTierOrganizationResponse>}
     * @memberof AdminHigherTierOrganizationResponseSet
     */
    'organizations': Array<AdminHigherTierOrganizationResponse>;
}
/**
 * 
 * @export
 * @interface AdminHigherTierOrganizationResponseSetAllOf
 */
export interface AdminHigherTierOrganizationResponseSetAllOf {
    /**
     * 
     * @type {Array<AdminHigherTierOrganizationResponse>}
     * @memberof AdminHigherTierOrganizationResponseSetAllOf
     */
    'organizations': Array<AdminHigherTierOrganizationResponse>;
}
/**
 * 
 * @export
 * @interface AdminInventoryAllocationCollectionResponse
 */
export interface AdminInventoryAllocationCollectionResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminInventoryAllocationCollectionResponse
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminInventoryAllocationCollectionResponse
     */
    'total_count': number;
    /**
     * 
     * @type {Array<AdminInventoryAllocationResponse>}
     * @memberof AdminInventoryAllocationCollectionResponse
     */
    'allocations': Array<AdminInventoryAllocationResponse>;
}
/**
 * 
 * @export
 * @interface AdminInventoryAllocationCollectionResponseAllOf
 */
export interface AdminInventoryAllocationCollectionResponseAllOf {
    /**
     * 
     * @type {Array<AdminInventoryAllocationResponse>}
     * @memberof AdminInventoryAllocationCollectionResponseAllOf
     */
    'allocations': Array<AdminInventoryAllocationResponse>;
}
/**
 * 
 * @export
 * @interface AdminInventoryAllocationHistoryCollectionResponse
 */
export interface AdminInventoryAllocationHistoryCollectionResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminInventoryAllocationHistoryCollectionResponse
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminInventoryAllocationHistoryCollectionResponse
     */
    'total_count': number;
    /**
     * 
     * @type {Array<AdminInventoryAllocationHistoryResponse>}
     * @memberof AdminInventoryAllocationHistoryCollectionResponse
     */
    'allocation_histories': Array<AdminInventoryAllocationHistoryResponse>;
}
/**
 * 
 * @export
 * @interface AdminInventoryAllocationHistoryCollectionResponseAllOf
 */
export interface AdminInventoryAllocationHistoryCollectionResponseAllOf {
    /**
     * 
     * @type {Array<AdminInventoryAllocationHistoryResponse>}
     * @memberof AdminInventoryAllocationHistoryCollectionResponseAllOf
     */
    'allocation_histories': Array<AdminInventoryAllocationHistoryResponse>;
}
/**
 * 
 * @export
 * @interface AdminInventoryAllocationHistoryResponse
 */
export interface AdminInventoryAllocationHistoryResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminInventoryAllocationHistoryResponse
     */
    'inventory_allocation_history_id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminInventoryAllocationHistoryResponse
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminInventoryAllocationHistoryResponse
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminInventoryAllocationHistoryResponse
     */
    'customization_id': string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminInventoryAllocationHistoryResponse
     */
    'delta': number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminInventoryAllocationHistoryResponse
     */
    'total_allocated': number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminInventoryAllocationHistoryResponse
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof AdminInventoryAllocationHistoryResponse
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof AdminInventoryAllocationHistoryResponse
     */
    'created_at': string;
}
/**
 * 
 * @export
 * @interface AdminInventoryAllocationResponse
 */
export interface AdminInventoryAllocationResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminInventoryAllocationResponse
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminInventoryAllocationResponse
     */
    'organization_name': string;
    /**
     * 
     * @type {number}
     * @memberof AdminInventoryAllocationResponse
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminInventoryAllocationResponse
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminInventoryAllocationResponse
     */
    'customization_id': string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminInventoryAllocationResponse
     */
    'total_inventory': number;
    /**
     * 
     * @type {number}
     * @memberof AdminInventoryAllocationResponse
     */
    'remaining_inventory': number;
    /**
     * 
     * @type {number}
     * @memberof AdminInventoryAllocationResponse
     */
    'total_allocated_inventory': number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminInventoryAllocationResponse
     */
    'remaining_allocated_inventory': number | null;
}
/**
 * 
 * @export
 * @interface AdminOrgRelationshipCreateRequest
 */
export interface AdminOrgRelationshipCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminOrgRelationshipCreateRequest
     */
    'lower_tier_organization_id': string;
}
/**
 * 
 * @export
 * @interface AdminOrgRelationshipsCreateResponse
 */
export interface AdminOrgRelationshipsCreateResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminOrgRelationshipsCreateResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrgRelationshipsCreateResponse
     */
    'higher_tier_organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrgRelationshipsCreateResponse
     */
    'lower_tier_organization_id': string;
}
/**
 * 
 * @export
 * @interface AdminOrgRelationshipsResponse
 */
export interface AdminOrgRelationshipsResponse {
    /**
     * 
     * @type {OrganizationIdAndName}
     * @memberof AdminOrgRelationshipsResponse
     */
    'lower_tier_organization': OrganizationIdAndName;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrgRelationshipsResponse
     */
    'is_allowed': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminOrgRelationshipsResponse
     */
    'updated_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminOrgRelationshipsResponse
     */
    'updated_by': string;
}
/**
 * 
 * @export
 * @interface AdminOrgRelationshipsResponseSet
 */
export interface AdminOrgRelationshipsResponseSet {
    /**
     * 
     * @type {number}
     * @memberof AdminOrgRelationshipsResponseSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrgRelationshipsResponseSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<AdminOrgRelationshipsResponse>}
     * @memberof AdminOrgRelationshipsResponseSet
     */
    'relationships': Array<AdminOrgRelationshipsResponse>;
}
/**
 * 
 * @export
 * @interface AdminOrgRelationshipsResponseSetAllOf
 */
export interface AdminOrgRelationshipsResponseSetAllOf {
    /**
     * 
     * @type {Array<AdminOrgRelationshipsResponse>}
     * @memberof AdminOrgRelationshipsResponseSetAllOf
     */
    'relationships': Array<AdminOrgRelationshipsResponse>;
}
/**
 * 
 * @export
 * @interface AdminOrganizationPurchaseordersResponse
 */
export interface AdminOrganizationPurchaseordersResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationPurchaseordersResponse
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationPurchaseordersResponse
     */
    'total_count'?: number;
    /**
     * 
     * @type {Array<PurchaseOrder>}
     * @memberof AdminOrganizationPurchaseordersResponse
     */
    'purchaseorders': Array<PurchaseOrder>;
}
/**
 * 
 * @export
 * @interface AdminProduct
 */
export interface AdminProduct {
    /**
     * 
     * @type {number}
     * @memberof AdminProduct
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProduct
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProduct
     */
    'product_code': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProduct
     */
    'product_sku': string;
    /**
     * 
     * @type {number}
     * @memberof AdminProduct
     */
    'product_tier': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProduct
     */
    'product_image': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProduct
     */
    'product_is_active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProduct
     */
    'product_is_available': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminProduct
     * @deprecated
     */
    'product_availability_message': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProduct
     */
    'ro_stock_number': string;
    /**
     * 
     * @type {InventoryTypeEnum}
     * @memberof AdminProduct
     */
    'inventory_type': InventoryTypeEnum;
    /**
     * 
     * @type {SubscriptionTypeEnum}
     * @memberof AdminProduct
     */
    'subscription_type': SubscriptionTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProduct
     */
    'is_subscription_product': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProduct
     */
    'is_virtual_product': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProduct
     */
    'is_default': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminProduct
     */
    'customization_id': string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminProduct
     */
    'product_mapping': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProduct
     */
    'is_customizable': boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminProduct
     */
    'netsuite_id_standard'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminProduct
     */
    'netsuite_id_custom'?: number | null;
    /**
     * 
     * @type {ProductTypeEnum}
     * @memberof AdminProduct
     */
    'product_type': ProductTypeEnum;
}


/**
 * 
 * @export
 * @interface AdminProductAllOf
 */
export interface AdminProductAllOf {
    /**
     * 
     * @type {string}
     * @memberof AdminProductAllOf
     */
    'customization_id': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProductAllOf
     */
    'is_customizable': boolean;
    /**
     * 
     * @type {ProductTypeEnum}
     * @memberof AdminProductAllOf
     */
    'product_type': ProductTypeEnum;
}


/**
 * 
 * @export
 * @interface AdminProductRefundResponse
 */
export interface AdminProductRefundResponse {
    /**
     * 
     * @type {RefundReasonResponse}
     * @memberof AdminProductRefundResponse
     */
    'refund_reason': RefundReasonResponse;
    /**
     * 
     * @type {string}
     * @memberof AdminProductRefundResponse
     */
    'product_refund_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductRefundResponse
     */
    'inventory_allocation_id': string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductRefundResponse
     */
    'inventory_product_id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductRefundResponse
     */
    'product_id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductRefundResponse
     */
    'refund_quantity': number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductRefundResponse
     */
    'product_cost': number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductRefundResponse
     */
    'product_tax': number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductRefundResponse
     */
    'product_vat': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductRefundResponse
     */
    'purchaseorder_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductRefundResponse
     */
    'purchaseorder_number': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductRefundResponse
     */
    'refund_date': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductRefundResponse
     */
    'customization_id': string | null;
}


/**
 * 
 * @export
 * @interface AdminRefundResponse
 */
export interface AdminRefundResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminRefundResponse
     */
    'refund_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminRefundResponse
     */
    'shipment_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminRefundResponse
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminRefundResponse
     */
    'organization_name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminRefundResponse
     */
    'reseller_organization_name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminRefundResponse
     */
    'reseller_netsuite_customer_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminRefundResponse
     */
    'external_order_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminRefundResponse
     */
    'country_code_2': string;
    /**
     * 
     * @type {number}
     * @memberof AdminRefundResponse
     */
    'inventory_product_id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminRefundResponse
     */
    'purchaseorder_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminRefundResponse
     */
    'purchaseorder_number': string;
    /**
     * 
     * @type {number}
     * @memberof AdminRefundResponse
     */
    'product_id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminRefundResponse
     */
    'product_cost': number;
    /**
     * 
     * @type {number}
     * @memberof AdminRefundResponse
     */
    'product_tax': number;
    /**
     * 
     * @type {number}
     * @memberof AdminRefundResponse
     */
    'product_vat': number;
    /**
     * 
     * @type {number}
     * @memberof AdminRefundResponse
     */
    'shipping_fee_refunded': number;
    /**
     * 
     * @type {number}
     * @memberof AdminRefundResponse
     */
    'shipping_tax_refunded': number;
    /**
     * 
     * @type {number}
     * @memberof AdminRefundResponse
     */
    'shipping_vat_refunded': number;
    /**
     * 
     * @type {string}
     * @memberof AdminRefundResponse
     */
    'shipped_date': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminRefundResponse
     */
    'refund_date': string;
    /**
     * 
     * @type {number}
     * @memberof AdminRefundResponse
     */
    'refund_quantity': number;
    /**
     * 
     * @type {number}
     * @memberof AdminRefundResponse
     */
    'total_refund_amount': number;
    /**
     * 
     * @type {string}
     * @memberof AdminRefundResponse
     */
    'refund_type': string;
}
/**
 * 
 * @export
 * @interface AdminRefundResultSet
 */
export interface AdminRefundResultSet {
    /**
     * 
     * @type {number}
     * @memberof AdminRefundResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminRefundResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<AdminRefundResponse>}
     * @memberof AdminRefundResultSet
     */
    'refunds': Array<AdminRefundResponse>;
}
/**
 * 
 * @export
 * @interface AdminRefundResultSetAllOf
 */
export interface AdminRefundResultSetAllOf {
    /**
     * 
     * @type {Array<AdminRefundResponse>}
     * @memberof AdminRefundResultSetAllOf
     */
    'refunds': Array<AdminRefundResponse>;
}
/**
 * 
 * @export
 * @interface AdminShipmentDebitAllocationResponse
 */
export interface AdminShipmentDebitAllocationResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminShipmentDebitAllocationResponse
     */
    'product_id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminShipmentDebitAllocationResponse
     */
    'inventory_product_id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentDebitAllocationResponse
     */
    'inventory_allocation_id': string;
    /**
     * 
     * @type {number}
     * @memberof AdminShipmentDebitAllocationResponse
     */
    'inventory_allocation_amount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminShipmentDebitAllocationResponse
     */
    'per_unit_product_cost': number;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentDebitAllocationResponse
     */
    'purchaseorder_number': string;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentDebitAllocationResponse
     */
    'purchaseorder_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentDebitAllocationResponse
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentDebitAllocationResponse
     */
    'inventory_product_name': string;
    /**
     * 
     * @type {number}
     * @memberof AdminShipmentDebitAllocationResponse
     */
    'product_tax': number;
    /**
     * 
     * @type {number}
     * @memberof AdminShipmentDebitAllocationResponse
     */
    'product_vat': number;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentDebitAllocationResponse
     */
    'customization_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentDebitAllocationResponse
     */
    'shipment_product_id': string;
}
/**
 * 
 * @export
 * @interface AdminShipmentDebitAllocationResultSet
 */
export interface AdminShipmentDebitAllocationResultSet {
    /**
     * 
     * @type {number}
     * @memberof AdminShipmentDebitAllocationResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminShipmentDebitAllocationResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<AdminShipmentDebitAllocationResponse>}
     * @memberof AdminShipmentDebitAllocationResultSet
     */
    'shipment_allocations': Array<AdminShipmentDebitAllocationResponse>;
}
/**
 * 
 * @export
 * @interface AdminShipmentDebitAllocationResultSetAllOf
 */
export interface AdminShipmentDebitAllocationResultSetAllOf {
    /**
     * 
     * @type {Array<AdminShipmentDebitAllocationResponse>}
     * @memberof AdminShipmentDebitAllocationResultSetAllOf
     */
    'shipment_allocations': Array<AdminShipmentDebitAllocationResponse>;
}
/**
 * 
 * @export
 * @interface AdminShipmentRefundResponse
 */
export interface AdminShipmentRefundResponse {
    /**
     * 
     * @type {Array<AdminShippingRefundResponse>}
     * @memberof AdminShipmentRefundResponse
     */
    'shipping_refund': Array<AdminShippingRefundResponse>;
    /**
     * 
     * @type {Array<AdminProductRefundResponse>}
     * @memberof AdminShipmentRefundResponse
     */
    'product_refund': Array<AdminProductRefundResponse>;
}
/**
 * 
 * @export
 * @interface AdminShipmentRequest
 */
export interface AdminShipmentRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentRequest
     */
    'organization_id': string;
    /**
     * 
     * @type {number}
     * @memberof AdminShipmentRequest
     */
    'channelpartner_id'?: number;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof AdminShipmentRequest
     */
    'delivery_type'?: ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentRequest
     */
    'country_code_2': string;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentRequest
     */
    'recipient': string;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentRequest
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentRequest
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentRequest
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentRequest
     */
    'recipient_telephone': string;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentRequest
     */
    'street_line1': string;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentRequest
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentRequest
     * @deprecated
     */
    'street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentRequest
     */
    'city': string;
    /**
     * Required if `country_code_2` is either \"US\" or \"CA\"
     * @type {string}
     * @memberof AdminShipmentRequest
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentRequest
     */
    'postal_code': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminShipmentRequest
     */
    'address_validation_bypass'?: boolean;
    /**
     * 
     * @type {Array<ShipmentExactRequestProduct>}
     * @memberof AdminShipmentRequest
     */
    'shipment_items': Array<ShipmentExactRequestProduct>;
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentRequest
     */
    'comment': string;
}


/**
 * 
 * @export
 * @interface AdminShipmentUpdateParams
 */
export interface AdminShipmentUpdateParams {
    /**
     * 
     * @type {string}
     * @memberof AdminShipmentUpdateParams
     */
    'comment': string;
    /**
     * 
     * @type {ShipmentUpdateParams}
     * @memberof AdminShipmentUpdateParams
     */
    'shipment_update_params': ShipmentUpdateParams;
}
/**
 * 
 * @export
 * @interface AdminShippingRefundResponse
 */
export interface AdminShippingRefundResponse {
    /**
     * 
     * @type {RefundReasonResponse}
     * @memberof AdminShippingRefundResponse
     */
    'refund_reason': RefundReasonResponse;
    /**
     * 
     * @type {string}
     * @memberof AdminShippingRefundResponse
     */
    'shipping_refund_id': string;
    /**
     * 
     * @type {number}
     * @memberof AdminShippingRefundResponse
     */
    'shipping_fee_refunded': number;
    /**
     * 
     * @type {number}
     * @memberof AdminShippingRefundResponse
     */
    'shipping_tax_refunded': number;
    /**
     * 
     * @type {number}
     * @memberof AdminShippingRefundResponse
     */
    'shipping_vat_refunded': number;
    /**
     * 
     * @type {string}
     * @memberof AdminShippingRefundResponse
     */
    'refund_date': string;
}


/**
 * 
 * @export
 * @interface AllCustomProductRedeemTiersResponse
 */
export interface AllCustomProductRedeemTiersResponse {
    /**
     * 
     * @type {number}
     * @memberof AllCustomProductRedeemTiersResponse
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AllCustomProductRedeemTiersResponse
     */
    'total_count': number;
    /**
     * 
     * @type {Array<CustomProductRedeemTierResponse>}
     * @memberof AllCustomProductRedeemTiersResponse
     */
    'tiers': Array<CustomProductRedeemTierResponse>;
}
/**
 * 
 * @export
 * @interface AllCustomProductRedeemTiersResponseAllOf
 */
export interface AllCustomProductRedeemTiersResponseAllOf {
    /**
     * 
     * @type {Array<CustomProductRedeemTierResponse>}
     * @memberof AllCustomProductRedeemTiersResponseAllOf
     */
    'tiers': Array<CustomProductRedeemTierResponse>;
}
/**
 * 
 * @export
 * @interface AmountsPerCustomization
 */
export interface AmountsPerCustomization {
    /**
     * The customization ID. Null indicates a standard configuration (i.e. no customization). There might be more than one customization to choose from for the same product ID. 
     * @type {string}
     * @memberof AmountsPerCustomization
     */
    'customization_id': string | null;
    /**
     * Total number of keys purchased with this customization ID
     * @type {number}
     * @memberof AmountsPerCustomization
     */
    'amount_total': number;
    /**
     * Number of keys remaining with this customization ID
     * @type {number}
     * @memberof AmountsPerCustomization
     */
    'amount_remaining': number;
    /**
     * Number of keys possible to ship out right now with this customization ID
     * @type {number}
     * @memberof AmountsPerCustomization
     */
    'amount_shippable': number;
}
/**
 * 
 * @export
 * @interface Banner
 */
export interface Banner {
    /**
     * 
     * @type {Array<BannerAudience>}
     * @memberof Banner
     */
    'audiences': Array<BannerAudience>;
    /**
     * Priority of the banner. Used as a way to control the ordering of rendered banners. A lower number means a higher priority. Can be negative. 
     * @type {number}
     * @memberof Banner
     */
    'priority': number;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    'end': string | null;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    'deletedAt': string | null;
    /**
     * 
     * @type {BannerMessage}
     * @memberof Banner
     */
    'banner': BannerMessage;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum BannerAudience {
    Console = 'console',
    Serviceconsole = 'serviceconsole'
}


/**
 * 
 * @export
 * @interface BannerMessage
 */
export interface BannerMessage {
    /**
     * 
     * @type {BannerType}
     * @memberof BannerMessage
     */
    'type': BannerType;
    /**
     * 
     * @type {string}
     * @memberof BannerMessage
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof BannerMessage
     */
    'message': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum BannerType {
    Info = 'info',
    Warning = 'warning',
    Urgent = 'urgent',
    Success = 'success'
}


/**
 * 
 * @export
 * @interface BannerWithID
 */
export interface BannerWithID {
    /**
     * 
     * @type {Array<BannerAudience>}
     * @memberof BannerWithID
     */
    'audiences': Array<BannerAudience>;
    /**
     * Priority of the banner. Used as a way to control the ordering of rendered banners. A lower number means a higher priority. Can be negative. 
     * @type {number}
     * @memberof BannerWithID
     */
    'priority': number;
    /**
     * 
     * @type {string}
     * @memberof BannerWithID
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof BannerWithID
     */
    'end': string | null;
    /**
     * 
     * @type {string}
     * @memberof BannerWithID
     */
    'deletedAt': string | null;
    /**
     * 
     * @type {BannerMessage}
     * @memberof BannerWithID
     */
    'banner': BannerMessage;
    /**
     * 
     * @type {string}
     * @memberof BannerWithID
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface BulkAddressOverride
 */
export interface BulkAddressOverride {
    /**
     * 
     * @type {string}
     * @memberof BulkAddressOverride
     */
    'comment': string;
    /**
     * A non-empty JSON list of shipment Ids to override
     * @type {Array<string>}
     * @memberof BulkAddressOverride
     */
    'shipments': Array<string>;
}
/**
 * The carrier used to deliver a shipment
 * @export
 * @enum {string}
 */

export enum CarrierIdentifierEnum {
    BlueDart = 'bluedart',
    DPD = 'dpd',
    FedEx = 'fedex',
    FedExSameDay = 'fedex same day',
    Others = 'others',
    TecEx = 'tecex',
    IndiaPost = 'india-post',
    PitneyBowes = 'pitney bowes',
    RoyalMail = 'royal mail',
    Transnet = 'transnet',
    UPS = 'ups',
    USPS = 'usps',
    Unknown = 'coming soon'
}


/**
 * 
 * @export
 * @interface ChannelPartner
 */
export interface ChannelPartner {
    /**
     * 
     * @type {number}
     * @memberof ChannelPartner
     */
    'channelpartner_id': number;
    /**
     * 
     * @type {string}
     * @memberof ChannelPartner
     */
    'channelpartner_name': string;
    /**
     * 
     * @type {string}
     * @memberof ChannelPartner
     */
    'netsuite_customer_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof ChannelPartner
     */
    'is_direct_sale': boolean;
    /**
     * 
     * @type {string}
     * @memberof ChannelPartner
     */
    'organization_id': string;
}
/**
 * 
 * @export
 * @interface ChannelPartnerProductInventory
 */
export interface ChannelPartnerProductInventory {
    /**
     * 
     * @type {number}
     * @memberof ChannelPartnerProductInventory
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof ChannelPartnerProductInventory
     */
    'product_name': string;
    /**
     * 
     * @type {number}
     * @memberof ChannelPartnerProductInventory
     */
    'remaining_quantity': number;
    /**
     * 
     * @type {InventoryTypeEnum}
     * @memberof ChannelPartnerProductInventory
     */
    'inventory_type': InventoryTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChannelPartnerProductInventory
     */
    'customizations'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ChannelPartnerProductInventory
     */
    'amount_total'?: number;
    /**
     * 
     * @type {Array<AmountsPerCustomization>}
     * @memberof ChannelPartnerProductInventory
     */
    'amounts_per_customization': Array<AmountsPerCustomization>;
}


/**
 * 
 * @export
 * @interface ChannelPartnerProductInventoryResponse
 */
export interface ChannelPartnerProductInventoryResponse {
    /**
     * 
     * @type {string}
     * @memberof ChannelPartnerProductInventoryResponse
     * @deprecated
     */
    'organization_id': string;
    /**
     * channelpartner_id is the key
     * @type {{ [key: string]: Array<ChannelPartnerProductInventory>; }}
     * @memberof ChannelPartnerProductInventoryResponse
     */
    'channelpartner_product_inventory': { [key: string]: Array<ChannelPartnerProductInventory>; };
}
/**
 * 
 * @export
 * @interface ChannelPartnerResultSet
 */
export interface ChannelPartnerResultSet {
    /**
     * 
     * @type {number}
     * @memberof ChannelPartnerResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof ChannelPartnerResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<ChannelPartner>}
     * @memberof ChannelPartnerResultSet
     */
    'channelpartners': Array<ChannelPartner>;
}
/**
 * 
 * @export
 * @interface Comment
 */
export interface Comment {
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface Configurations
 */
export interface Configurations {
    /**
     * 
     * @type {boolean}
     * @memberof Configurations
     */
    'supports_fido2_preregistration': boolean;
}
/**
 * 
 * @export
 * @interface CoreProductInfo
 */
export interface CoreProductInfo {
    /**
     * 
     * @type {number}
     * @memberof CoreProductInfo
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CoreProductInfo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CoreProductInfo
     */
    'code': string;
    /**
     * 
     * @type {ProductState}
     * @memberof CoreProductInfo
     */
    'state': ProductState;
    /**
     * 
     * @type {ProductType}
     * @memberof CoreProductInfo
     */
    'type': ProductType;
    /**
     * 
     * @type {string}
     * @memberof CoreProductInfo
     */
    'image': string;
}


/**
 * 
 * @export
 * @interface CountryResponseServiceAdmin
 */
export interface CountryResponseServiceAdmin {
    /**
     * 
     * @type {number}
     * @memberof CountryResponseServiceAdmin
     */
    'country_id': number;
    /**
     * 
     * @type {string}
     * @memberof CountryResponseServiceAdmin
     */
    'country_name': string;
    /**
     * 
     * @type {string}
     * @memberof CountryResponseServiceAdmin
     */
    'country_code_2': string;
    /**
     * 
     * @type {string}
     * @memberof CountryResponseServiceAdmin
     */
    'country_code_3': string;
    /**
     * 
     * @type {number}
     * @memberof CountryResponseServiceAdmin
     */
    'country_vat_rate': number;
    /**
     * 
     * @type {boolean}
     * @memberof CountryResponseServiceAdmin
     */
    'is_default': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CountryResponseServiceAdmin
     */
    'is_manual': boolean;
    /**
     * 
     * @type {Array<DeliveryTypeResponse>}
     * @memberof CountryResponseServiceAdmin
     */
    'delivery_types': Array<DeliveryTypeResponse>;
}
/**
 * 
 * @export
 * @interface CountryResultSetServiceAdmin
 */
export interface CountryResultSetServiceAdmin {
    /**
     * 
     * @type {number}
     * @memberof CountryResultSetServiceAdmin
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof CountryResultSetServiceAdmin
     */
    'total_count': number;
    /**
     * 
     * @type {Array<CountryResponseServiceAdmin>}
     * @memberof CountryResultSetServiceAdmin
     */
    'countries': Array<CountryResponseServiceAdmin>;
}
/**
 * 
 * @export
 * @interface CountryResultSetServiceAdminAllOf
 */
export interface CountryResultSetServiceAdminAllOf {
    /**
     * 
     * @type {Array<CountryResponseServiceAdmin>}
     * @memberof CountryResultSetServiceAdminAllOf
     */
    'countries': Array<CountryResponseServiceAdmin>;
}
/**
 * 
 * @export
 * @interface CreateCustomizationRelationship
 */
export interface CreateCustomizationRelationship {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCustomizationRelationship
     */
    'organizations': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomizationRelationship
     */
    'comment'?: string;
}
/**
 * 
 * @export
 * @interface CreateReplacementShipmentRequest
 */
export interface CreateReplacementShipmentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateReplacementShipmentRequest
     */
    'city': string;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof CreateReplacementShipmentRequest
     */
    'delivery_type'?: ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateReplacementShipmentRequest
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof CreateReplacementShipmentRequest
     */
    'country_code_2': string;
    /**
     * 
     * @type {string}
     * @memberof CreateReplacementShipmentRequest
     */
    'postal_code': string;
    /**
     * 
     * @type {string}
     * @memberof CreateReplacementShipmentRequest
     */
    'recipient'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReplacementShipmentRequest
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReplacementShipmentRequest
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReplacementShipmentRequest
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReplacementShipmentRequest
     */
    'recipient_telephone': string;
    /**
     * Required if `country_code_2` is either \"US\" or \"CA\"
     * @type {string}
     * @memberof CreateReplacementShipmentRequest
     */
    'region'?: string;
    /**
     * 
     * @type {Array<ShipmentExactRequestProduct>}
     * @memberof CreateReplacementShipmentRequest
     */
    'shipment_items': Array<ShipmentExactRequestProduct>;
    /**
     * 
     * @type {string}
     * @memberof CreateReplacementShipmentRequest
     */
    'street_line1': string;
    /**
     * 
     * @type {string}
     * @memberof CreateReplacementShipmentRequest
     */
    'street_line2'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateReplacementShipmentRequest
     */
    'address_validation_bypass'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateReplacementShipmentRequest
     */
    'free_shipping_override'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateReplacementShipmentRequest
     */
    'notification_email': string;
}


/**
 * Defines how the shipment was created.
 * @export
 * @enum {string}
 */

export enum CreationTypeEnum {
    ServiceConsoleSingle = 'create-serviceconsole-single',
    ServiceConsoleSingleManual = 'create-serviceconsole-single-manual',
    ConsoleSingle = 'create-console-single',
    ConsoleBulk = 'create-console-bulk',
    API = 'create-api',
    FPRAPI = 'create-fpr-api',
    RivendellAPI = 'create-rivendell-api',
    Unknown = 'create-unknown'
}


/**
 * 
 * @export
 * @interface CustomProductRedeemTier
 */
export interface CustomProductRedeemTier {
    /**
     * 
     * @type {number}
     * @memberof CustomProductRedeemTier
     */
    'product_tier'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CustomProductRedeemTier
     */
    'redeem_product_ids'?: Array<number>;
}
/**
 * 
 * @export
 * @interface CustomProductRedeemTierRequest
 */
export interface CustomProductRedeemTierRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomProductRedeemTierRequest
     */
    'product_tier': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CustomProductRedeemTierRequest
     */
    'redeem_product_ids': Array<number>;
}
/**
 * 
 * @export
 * @interface CustomProductRedeemTierResponse
 */
export interface CustomProductRedeemTierResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomProductRedeemTierResponse
     */
    'product_tier': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CustomProductRedeemTierResponse
     */
    'redeem_product_ids': Array<number>;
}
/**
 * 
 * @export
 * @interface CustomProductRedeemVirtualProduct
 */
export interface CustomProductRedeemVirtualProduct {
    /**
     * 
     * @type {number}
     * @memberof CustomProductRedeemVirtualProduct
     */
    'virtual_product_id': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CustomProductRedeemVirtualProduct
     */
    'redeem_product_ids': Array<number>;
}
/**
 * 
 * @export
 * @interface CustomizationHistoryResponseInner
 */
export interface CustomizationHistoryResponseInner {
    /**
     * 
     * @type {string}
     * @memberof CustomizationHistoryResponseInner
     */
    'customization_id': string;
    /**
     * 
     * @type {string}
     * @memberof CustomizationHistoryResponseInner
     */
    'customization_name': string;
    /**
     * 
     * @type {string}
     * @memberof CustomizationHistoryResponseInner
     */
    'date': string;
    /**
     * Email address of user who made last change will displayed if the user is in the same organization as the caller. 
     * @type {string}
     * @memberof CustomizationHistoryResponseInner
     */
    'user_email': string;
}
/**
 * 
 * @export
 * @interface CustomizationResponse
 */
export interface CustomizationResponse {
    /**
     * 
     * @type {string}
     * @memberof CustomizationResponse
     */
    'customization_id': string;
    /**
     * 
     * @type {string}
     * @memberof CustomizationResponse
     */
    'name': string | null;
    /**
     * 
     * @type {CustomizationStatus}
     * @memberof CustomizationResponse
     */
    'status': CustomizationStatus;
    /**
     * 
     * @type {Array<OrganizationIdAndName>}
     * @memberof CustomizationResponse
     */
    'organizations': Array<OrganizationIdAndName>;
    /**
     * 
     * @type {Configurations}
     * @memberof CustomizationResponse
     */
    'configurations': Configurations;
}


/**
 * 
 * @export
 * @interface CustomizationResponseSet
 */
export interface CustomizationResponseSet {
    /**
     * 
     * @type {number}
     * @memberof CustomizationResponseSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof CustomizationResponseSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<CustomizationResponse>}
     * @memberof CustomizationResponseSet
     */
    'customizations': Array<CustomizationResponse>;
}
/**
 * 
 * @export
 * @interface CustomizationResponseSetAllOf
 */
export interface CustomizationResponseSetAllOf {
    /**
     * 
     * @type {Array<CustomizationResponse>}
     * @memberof CustomizationResponseSetAllOf
     */
    'customizations': Array<CustomizationResponse>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CustomizationStatus {
    Active = 'active',
    Decommissioned = 'decommissioned'
}


/**
 * 
 * @export
 * @interface DPLEntryMatch
 */
export interface DPLEntryMatch {
    /**
     * Source list of the matched entry
     * @type {string}
     * @memberof DPLEntryMatch
     */
    'source'?: string;
    /**
     * The url of the list
     * @type {string}
     * @memberof DPLEntryMatch
     */
    'source_list_url'?: string;
    /**
     * Recipient of the matched entry
     * @type {string}
     * @memberof DPLEntryMatch
     */
    'recipient'?: string;
    /**
     * The address line of the matched entry
     * @type {string}
     * @memberof DPLEntryMatch
     */
    'address'?: string;
}
/**
 * 
 * @export
 * @interface DPLOverride
 */
export interface DPLOverride {
    /**
     * 
     * @type {boolean}
     * @memberof DPLOverride
     */
    'override'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DPLOverride
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface DashboardResponse
 */
export interface DashboardResponse {
    /**
     * Ordered by tier, higher tiers first. Within the same tier, ordered by subscription type (primary 1.0 first, then backup 1.0, primary 2.0, backup 2.0). 
     * @type {Array<SubscriptionSummary>}
     * @memberof DashboardResponse
     */
    'subscriptions': Array<SubscriptionSummary>;
    /**
     * Ordered by product ID, lowest first 
     * @type {Array<ProductSummary>}
     * @memberof DashboardResponse
     */
    'perpetuals': Array<ProductSummary>;
}
/**
 * 
 * @export
 * @interface DeliveryTypeResponse
 */
export interface DeliveryTypeResponse {
    /**
     * 
     * @type {number}
     * @memberof DeliveryTypeResponse
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryTypeResponse
     */
    'name': string;
}
/**
 * Deprecated: To be replaced by \'#/components/schemas/StandardErrorResult\'
 * @export
 * @interface ErrorResult
 */
export interface ErrorResult {
    /**
     * 
     * @type {string}
     * @memberof ErrorResult
     */
    'code': string;
    /**
     * The error message in text
     * @type {string}
     * @memberof ErrorResult
     */
    'message'?: string;
    /**
     * A list of details of each distinct problem encountered. Omitted when empty
     * @type {Array<StandardErrorDetail>}
     * @memberof ErrorResult
     */
    'errors'?: Array<StandardErrorDetail>;
    /**
     * 
     * @type {string}
     * @memberof ErrorResult
     * @deprecated
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResult
     * @deprecated
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof ErrorResult
     * @deprecated
     */
    'errorCauses'?: Array<object>;
}
/**
 * 
 * @export
 * @interface ErrorResultAllOf
 */
export interface ErrorResultAllOf {
    /**
     * 
     * @type {string}
     * @memberof ErrorResultAllOf
     * @deprecated
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResultAllOf
     * @deprecated
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof ErrorResultAllOf
     * @deprecated
     */
    'errorCauses'?: Array<object>;
}
/**
 * 
 * @export
 * @interface FPRShipmentAddressRequest
 */
export interface FPRShipmentAddressRequest {
    /**
     * 
     * @type {FPRShipmentAddressRequestMailingAddress}
     * @memberof FPRShipmentAddressRequest
     */
    'mailing_address': FPRShipmentAddressRequestMailingAddress;
    /**
     * 
     * @type {FPRShipmentAddressRequestRecipient}
     * @memberof FPRShipmentAddressRequest
     */
    'recipient': FPRShipmentAddressRequestRecipient;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof FPRShipmentAddressRequest
     */
    'delivery_type': ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentAddressRequest
     */
    'comment': string;
    /**
     * 
     * @type {boolean}
     * @memberof FPRShipmentAddressRequest
     */
    'address_validation_bypass'?: boolean;
}


/**
 * 
 * @export
 * @interface FPRShipmentAddressRequestMailingAddress
 */
export interface FPRShipmentAddressRequestMailingAddress {
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentAddressRequestMailingAddress
     */
    'street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentAddressRequestMailingAddress
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentAddressRequestMailingAddress
     * @deprecated
     */
    'street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentAddressRequestMailingAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentAddressRequestMailingAddress
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentAddressRequestMailingAddress
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentAddressRequestMailingAddress
     */
    'country_code_2'?: string;
}
/**
 * 
 * @export
 * @interface FPRShipmentAddressRequestRecipient
 */
export interface FPRShipmentAddressRequestRecipient {
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentAddressRequestRecipient
     */
    'recipient_company'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentAddressRequestRecipient
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentAddressRequestRecipient
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentAddressRequestRecipient
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentAddressRequestRecipient
     */
    'recipient_telephone'?: string;
}
/**
 * 
 * @export
 * @interface FeatureToggleOverridesResponse
 */
export interface FeatureToggleOverridesResponse {
    /**
     * 
     * @type {string}
     * @memberof FeatureToggleOverridesResponse
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureToggleOverridesResponse
     */
    'enabled': boolean;
    /**
     * 
     * @type {Array<OrganizationOverrides>}
     * @memberof FeatureToggleOverridesResponse
     */
    'organization_overrides': Array<OrganizationOverrides>;
}
/**
 * 
 * @export
 * @interface FeatureTogglePutResponse
 */
export interface FeatureTogglePutResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FeatureTogglePutResponse
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface FeatureToggleRequest
 */
export interface FeatureToggleRequest {
    /**
     * 
     * @type {boolean}
     * @memberof FeatureToggleRequest
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface GetBannersResponse
 */
export interface GetBannersResponse {
    /**
     * 
     * @type {number}
     * @memberof GetBannersResponse
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetBannersResponse
     */
    'total_count': number;
    /**
     * 
     * @type {Array<BannerWithID>}
     * @memberof GetBannersResponse
     */
    'banners': Array<BannerWithID>;
}
/**
 * 
 * @export
 * @interface GetBannersResponseAllOf
 */
export interface GetBannersResponseAllOf {
    /**
     * 
     * @type {Array<BannerWithID>}
     * @memberof GetBannersResponseAllOf
     */
    'banners': Array<BannerWithID>;
}
/**
 * 
 * @export
 * @interface GetDPLMatches200Response
 */
export interface GetDPLMatches200Response {
    /**
     * 
     * @type {Array<DPLEntryMatch>}
     * @memberof GetDPLMatches200Response
     */
    'addresses'?: Array<DPLEntryMatch>;
    /**
     * 
     * @type {Array<DPLEntryMatch>}
     * @memberof GetDPLMatches200Response
     */
    'names'?: Array<DPLEntryMatch>;
}
/**
 * @type GetNetsuiteRecord200Response
 * @export
 */
export type GetNetsuiteRecord200Response = NetsuiteCustomer | NetsuiteCustomization | NetsuiteItem;

/**
 * 
 * @export
 * @interface GrantDetailResponse
 */
export interface GrantDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof GrantDetailResponse
     */
    'grant_id': string;
    /**
     * 
     * @type {string}
     * @memberof GrantDetailResponse
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof GrantDetailResponse
     */
    'organization_name': string;
    /**
     * 
     * @type {string}
     * @memberof GrantDetailResponse
     */
    'recipient': string;
    /**
     * 
     * @type {GrantStatusEnum}
     * @memberof GrantDetailResponse
     */
    'status': GrantStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GrantDetailResponse
     */
    'expiration_date': string;
    /**
     * 
     * @type {string}
     * @memberof GrantDetailResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof GrantDetailResponse
     */
    'shipment_id': string | null;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof GrantDetailResponse
     */
    'delivery_type': ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GrantDetailResponse
     */
    'created_by': string;
    /**
     * 
     * @type {Array<GrantProduct>}
     * @memberof GrantDetailResponse
     */
    'grant_products': Array<GrantProduct>;
}


/**
 * 
 * @export
 * @interface GrantDetailResponseAllOf
 */
export interface GrantDetailResponseAllOf {
    /**
     * 
     * @type {Array<GrantProduct>}
     * @memberof GrantDetailResponseAllOf
     */
    'grant_products': Array<GrantProduct>;
}
/**
 * 
 * @export
 * @interface GrantProduct
 */
export interface GrantProduct {
    /**
     * 
     * @type {number}
     * @memberof GrantProduct
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof GrantProduct
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof GrantProduct
     */
    'customization_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GrantProduct
     */
    'customization_label': string | null;
    /**
     * 
     * @type {number}
     * @memberof GrantProduct
     */
    'quantity': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof GrantProduct
     */
    'redeemable_products': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof GrantProduct
     */
    'is_eligible': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum GrantStatusEnum {
    Invited = 'Invited',
    Claimed = 'Claimed',
    Expired = 'Expired',
    NeedsAttention = 'Needs Attention',
    Failed = 'Failed'
}


/**
 * 
 * @export
 * @interface GrantsResponse
 */
export interface GrantsResponse {
    /**
     * 
     * @type {string}
     * @memberof GrantsResponse
     */
    'grant_id': string;
    /**
     * 
     * @type {string}
     * @memberof GrantsResponse
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof GrantsResponse
     */
    'organization_name': string;
    /**
     * 
     * @type {string}
     * @memberof GrantsResponse
     */
    'recipient': string;
    /**
     * 
     * @type {GrantStatusEnum}
     * @memberof GrantsResponse
     */
    'status': GrantStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GrantsResponse
     */
    'expiration_date': string;
    /**
     * 
     * @type {string}
     * @memberof GrantsResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof GrantsResponse
     */
    'shipment_id': string | null;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof GrantsResponse
     */
    'delivery_type': ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GrantsResponse
     */
    'created_by': string;
}


/**
 * 
 * @export
 * @interface GrantsResultSet
 */
export interface GrantsResultSet {
    /**
     * 
     * @type {number}
     * @memberof GrantsResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GrantsResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<GrantsResponse>}
     * @memberof GrantsResultSet
     */
    'grants': Array<GrantsResponse>;
}
/**
 * 
 * @export
 * @interface GrantsResultSetAllOf
 */
export interface GrantsResultSetAllOf {
    /**
     * 
     * @type {Array<GrantsResponse>}
     * @memberof GrantsResultSetAllOf
     */
    'grants': Array<GrantsResponse>;
}
/**
 * 1 = YubiKey Shipment (outright purchase) 2 = YubiKey Tier SKU Shipment (purchase of virtual keys) 3 = Subscription - Initial Shipment (Subscription) 4 = Subscription - Buffer Stock Shipment (Subscription) 5 = Subscription - Replacement YubiKey Shipment (Subscription) 
 * @export
 * @enum {string}
 */

export enum InventoryTypeEnum {
    YubiKeyShipment = 1,
    YubiKeyTierSKUShipment = 2,
    SubscriptionInitialShipment = 3,
    SubscriptionBufferStockShipment = 4,
    SubscriptionReplacementShipment = 5
}


/**
 * 
 * @export
 * @interface InviteUserParams
 */
export interface InviteUserParams {
    /**
     * 
     * @type {string}
     * @memberof InviteUserParams
     */
    'email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InviteUserParams
     */
    'roles': Array<string>;
}
/**
 * 
 * @export
 * @interface Item
 */
export interface Item {
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof Item
     */
    'netsuite_id': number;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'article_number': string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'state': string;
    /**
     * 
     * @type {ProductTypeEnum}
     * @memberof Item
     */
    'type': ProductTypeEnum;
}


/**
 * 
 * @export
 * @interface ItemInfo
 */
export interface ItemInfo {
    /**
     * 
     * @type {number}
     * @memberof ItemInfo
     */
    'netsuite_id': number;
    /**
     * 
     * @type {string}
     * @memberof ItemInfo
     */
    'part_number': string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ItemTypeEnum {
    Physical = 'Physical',
    Subscription = 'Subscription'
}


/**
 * 
 * @export
 * @interface LegacyCustomProductRequest
 */
export interface LegacyCustomProductRequest {
    /**
     * 
     * @type {number}
     * @memberof LegacyCustomProductRequest
     */
    'base_product_id': number;
    /**
     * 
     * @type {string}
     * @memberof LegacyCustomProductRequest
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof LegacyCustomProductRequest
     */
    'customization_id': string;
    /**
     * 
     * @type {string}
     * @memberof LegacyCustomProductRequest
     */
    'product_code': string;
    /**
     * 
     * @type {string}
     * @memberof LegacyCustomProductRequest
     */
    'product_sku': string;
    /**
     * 
     * @type {number}
     * @memberof LegacyCustomProductRequest
     */
    'product_tier': number | null;
    /**
     * 
     * @type {string}
     * @memberof LegacyCustomProductRequest
     */
    'ro_stock_number': string;
    /**
     * 
     * @type {boolean}
     * @memberof LegacyCustomProductRequest
     */
    'product_is_active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LegacyCustomProductRequest
     */
    'product_is_available': boolean;
}
/**
 * 
 * @export
 * @interface MachineToken
 */
export interface MachineToken {
    /**
     * 
     * @type {string}
     * @memberof MachineToken
     */
    'token_id': string;
    /**
     * 
     * @type {string}
     * @memberof MachineToken
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof MachineToken
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof MachineToken
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof MachineToken
     */
    'organization_name': string;
    /**
     * 
     * @type {string}
     * @memberof MachineToken
     */
    'create_time': string;
    /**
     * 
     * @type {string}
     * @memberof MachineToken
     */
    'expire_time': string;
    /**
     * 
     * @type {string}
     * @memberof MachineToken
     */
    'last_used': string;
}
/**
 * 
 * @export
 * @interface MachineTokenResultSet
 */
export interface MachineTokenResultSet {
    /**
     * 
     * @type {number}
     * @memberof MachineTokenResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof MachineTokenResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<MachineToken>}
     * @memberof MachineTokenResultSet
     */
    'machine_tokens': Array<MachineToken>;
}
/**
 * See more details at https://console.yubico.com/help/single-req.html#shipment-request-field-limitations
 * @export
 * @interface MailingAddress
 */
export interface MailingAddress {
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     * @deprecated
     */
    'street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'country_code_2'?: string;
}
/**
 * 
 * @export
 * @interface ManualShipmentDeliveryUpdateRequest
 */
export interface ManualShipmentDeliveryUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof ManualShipmentDeliveryUpdateRequest
     */
    'shipment_state_id': number;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentDeliveryUpdateRequest
     */
    'comment': string;
    /**
     * Required if overriding to delivered (104), forbidden if overriding to requested (12) or shipped (103), and ignored otherwise.
     * @type {string}
     * @memberof ManualShipmentDeliveryUpdateRequest
     */
    'delivered_date'?: string;
    /**
     * Required if overriding to shipped (103).
     * @type {string}
     * @memberof ManualShipmentDeliveryUpdateRequest
     */
    'tracking_number'?: string;
    /**
     * 
     * @type {CarrierIdentifierEnum}
     * @memberof ManualShipmentDeliveryUpdateRequest
     */
    'carrier'?: CarrierIdentifierEnum;
    /**
     * Required if overriding to any status other than requested (12) or cancelled (108), forbidden if overriding to requested (12).
     * @type {string}
     * @memberof ManualShipmentDeliveryUpdateRequest
     */
    'shipped_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof ManualShipmentDeliveryUpdateRequest
     */
    'shipping_service_cost'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ManualShipmentDeliveryUpdateRequest
     */
    'shipping_service_vat'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ManualShipmentDeliveryUpdateRequest
     */
    'shipping_service_taxes'?: number | null;
    /**
     * 
     * @type {Array<SupportTicket>}
     * @memberof ManualShipmentDeliveryUpdateRequest
     */
    'shipment_support_tickets'?: Array<SupportTicket>;
}


/**
 * 
 * @export
 * @interface ManualShipmentItemRequest
 */
export interface ManualShipmentItemRequest {
    /**
     * 
     * @type {number}
     * @memberof ManualShipmentItemRequest
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentItemRequest
     */
    'purchaseorder_product_id': string;
    /**
     * 
     * @type {number}
     * @memberof ManualShipmentItemRequest
     */
    'shipment_product_quantity': number;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentItemRequest
     */
    'customization_id'?: string | null;
}
/**
 * 
 * @export
 * @interface ManualShipmentRequest
 */
export interface ManualShipmentRequest {
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     */
    'country_code_2': string;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     */
    'recipient'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     */
    'recipient_telephone': string;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     */
    'street_line1': string;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     * @deprecated
     */
    'street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     */
    'postal_code': string;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof ManualShipmentRequest
     */
    'delivery_type': ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ManualShipmentRequest
     */
    'shipment_state_id': number;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     */
    'shipped_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     */
    'delivered_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     */
    'fulfillment_partner_name': string;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     */
    'tracking_number'?: string;
    /**
     * 
     * @type {CarrierIdentifierEnum}
     * @memberof ManualShipmentRequest
     */
    'carrier'?: CarrierIdentifierEnum;
    /**
     * 
     * @type {number}
     * @memberof ManualShipmentRequest
     */
    'shipping_service_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ManualShipmentRequest
     */
    'shipping_service_taxes'?: number;
    /**
     * 
     * @type {number}
     * @memberof ManualShipmentRequest
     */
    'shipping_service_vat'?: number;
    /**
     * 
     * @type {string}
     * @memberof ManualShipmentRequest
     */
    'comment'?: string;
    /**
     * 
     * @type {Array<ManualShipmentItemRequest>}
     * @memberof ManualShipmentRequest
     */
    'shipment_items': Array<ManualShipmentItemRequest>;
}


/**
 * 
 * @export
 * @interface NetsuiteCustomer
 */
export interface NetsuiteCustomer {
    /**
     * 
     * @type {string}
     * @memberof NetsuiteCustomer
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NetsuiteCustomer
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface NetsuiteCustomization
 */
export interface NetsuiteCustomization {
    /**
     * 
     * @type {number}
     * @memberof NetsuiteCustomization
     */
    'netsuite_id': number;
    /**
     * 
     * @type {string}
     * @memberof NetsuiteCustomization
     */
    'customization_id': string;
    /**
     * 
     * @type {number}
     * @memberof NetsuiteCustomization
     */
    'netsuite_customer_id': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof NetsuiteCustomization
     */
    'fido2_preregistration': boolean;
    /**
     * 
     * @type {string}
     * @memberof NetsuiteCustomization
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface NetsuiteItem
 */
export interface NetsuiteItem {
    /**
     * 
     * @type {number}
     * @memberof NetsuiteItem
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof NetsuiteItem
     */
    'name': string;
    /**
     * 
     * @type {ItemTypeEnum}
     * @memberof NetsuiteItem
     */
    'type': ItemTypeEnum;
    /**
     * 
     * @type {YEDClassification}
     * @memberof NetsuiteItem
     */
    'yed_classification': YEDClassification;
    /**
     * 
     * @type {boolean}
     * @memberof NetsuiteItem
     */
    'active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NetsuiteItem
     */
    'available_on_sales_transaction': boolean;
    /**
     * 
     * @type {string}
     * @memberof NetsuiteItem
     */
    'article_number': string;
    /**
     * 
     * @type {boolean}
     * @memberof NetsuiteItem
     */
    'fulfillable': boolean;
    /**
     * 
     * @type {PhysicalAttributes}
     * @memberof NetsuiteItem
     */
    'physical_attributes': PhysicalAttributes | null;
    /**
     * 
     * @type {SubscriptionAttributes}
     * @memberof NetsuiteItem
     */
    'subscription_attributes': SubscriptionAttributes | null;
}


/**
 * Netsuite order type (either \"Subscription plus YED\", \"Subscription 1.5 or 2.0\" or \"Physical or Perpetual\").
 * @export
 * @enum {string}
 */

export enum NetsuiteOrderType {
    SubscriptionPlusYED = 'Subscription plus YED',
    Subscription15Or20 = 'Subscription 1.5 or 2.0',
    PhysicalOrPerpetual = 'Physical or Perpetual'
}


/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'notification_id': string;
    /**
     * 
     * @type {NotificationStatus}
     * @memberof Notification
     */
    'status': NotificationStatus;
    /**
     * 
     * @type {NotificationType}
     * @memberof Notification
     */
    'type': NotificationType;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'message': string;
    /**
     * 
     * @type {Array<NotificationAudience>}
     * @memberof Notification
     */
    'audiences': Array<NotificationAudience>;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'expires_at': string;
    /**
     * 
     * @type {Array<NotificationLink>}
     * @memberof Notification
     */
    'links': Array<NotificationLink>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationAction {
    Read = 'read',
    Archive = 'archive',
    Unarchive = 'unarchive',
    Unread = 'unread'
}


/**
 * 
 * @export
 * @interface NotificationActionRequest
 */
export interface NotificationActionRequest {
    /**
     * 
     * @type {Array<NotificationActionRequestActionsInner>}
     * @memberof NotificationActionRequest
     */
    'actions'?: Array<NotificationActionRequestActionsInner>;
}
/**
 * 
 * @export
 * @interface NotificationActionRequestActionsInner
 */
export interface NotificationActionRequestActionsInner {
    /**
     * 
     * @type {string}
     * @memberof NotificationActionRequestActionsInner
     */
    'notification_id': string;
    /**
     * 
     * @type {NotificationAction}
     * @memberof NotificationActionRequestActionsInner
     */
    'action': NotificationAction;
}


/**
 * 
 * @export
 * @interface NotificationAudience
 */
export interface NotificationAudience {
    /**
     * 
     * @type {NotificationAudienceType}
     * @memberof NotificationAudience
     */
    'audience': NotificationAudienceType;
    /**
     * 
     * @type {string}
     * @memberof NotificationAudience
     */
    'organization_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationAudience
     */
    'user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationAudience
     */
    'email'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationAudienceType {
    YedAll = 'yed-all',
    YedEnterprise = 'yed-enterprise',
    YedService = 'yed-service',
    YedOrg = 'yed-org',
    YedOrgUser = 'yed-org-user',
    YedUser = 'yed-user',
    Email = 'email'
}


/**
 * 
 * @export
 * @interface NotificationLink
 */
export interface NotificationLink {
    /**
     * 
     * @type {string}
     * @memberof NotificationLink
     */
    'display_text': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationLink
     */
    'link': string;
    /**
     * 
     * @type {NotificationLinkType}
     * @memberof NotificationLink
     */
    'type': NotificationLinkType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationLinkType {
    Link = 'link',
    Download = 'download'
}


/**
 * 
 * @export
 * @interface NotificationResultSet
 */
export interface NotificationResultSet {
    /**
     * 
     * @type {number}
     * @memberof NotificationResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof NotificationResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {number}
     * @memberof NotificationResultSet
     */
    'unread'?: number;
    /**
     * 
     * @type {Array<Notification>}
     * @memberof NotificationResultSet
     */
    'notifications': Array<Notification>;
}
/**
 * 
 * @export
 * @interface NotificationResultSetAllOf
 */
export interface NotificationResultSetAllOf {
    /**
     * 
     * @type {number}
     * @memberof NotificationResultSetAllOf
     */
    'unread'?: number;
    /**
     * 
     * @type {Array<Notification>}
     * @memberof NotificationResultSetAllOf
     */
    'notifications': Array<Notification>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationStatus {
    Unread = 'unread',
    Read = 'read',
    Archived = 'archived'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationType {
    Urgent = 'urgent',
    Error = 'error',
    Warning = 'warning',
    Info = 'info',
    Success = 'success'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationView {
    Nonarchived = 'nonarchived',
    UnreadOnly = 'unread-only',
    ReadOnly = 'read-only',
    ArchivedOnly = 'archived-only'
}


/**
 * 
 * @export
 * @interface OrgCustomizationRelationshipResponse
 */
export interface OrgCustomizationRelationshipResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof OrgCustomizationRelationshipResponse
     */
    'organizations': Array<string>;
}
/**
 * 
 * @export
 * @interface OrgNameAndNetsuiteID
 */
export interface OrgNameAndNetsuiteID {
    /**
     * 
     * @type {string}
     * @memberof OrgNameAndNetsuiteID
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrgNameAndNetsuiteID
     */
    'netsuite_id': string;
}
/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'customer_id'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Organization
     */
    'settings'?: { [key: string]: string; };
    /**
     * 
     * @type {Array<OrganizationOwnersInner>}
     * @memberof Organization
     */
    'owners'?: Array<OrganizationOwnersInner>;
    /**
     * 
     * @type {OrganizationSSOSummary}
     * @memberof Organization
     */
    'sso_summary'?: OrganizationSSOSummary | null;
    /**
     * 
     * @type {boolean}
     * @memberof Organization
     */
    'netsuite_synced': boolean;
}
/**
 * 
 * @export
 * @interface OrganizationCountryRequestBulk
 */
export interface OrganizationCountryRequestBulk {
    /**
     * 
     * @type {Array<number>}
     * @memberof OrganizationCountryRequestBulk
     */
    'country_ids': Array<number>;
}
/**
 * 
 * @export
 * @interface OrganizationCountryResponse
 */
export interface OrganizationCountryResponse {
    /**
     * 
     * @type {number}
     * @memberof OrganizationCountryResponse
     */
    'country_id': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCountryResponse
     */
    'country_name': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCountryResponse
     */
    'country_code_2': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCountryResponse
     */
    'country_code_3': string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationCountryResponse
     */
    'country_vat_rate': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCountryResponse
     * @deprecated
     */
    'organization_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationCountryResponse
     */
    'is_allowed'?: boolean;
    /**
     * 
     * @type {Array<DeliveryTypeResponse>}
     * @memberof OrganizationCountryResponse
     */
    'delivery_types': Array<DeliveryTypeResponse>;
}
/**
 * 
 * @export
 * @interface OrganizationCountryResultSet
 */
export interface OrganizationCountryResultSet {
    /**
     * 
     * @type {number}
     * @memberof OrganizationCountryResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationCountryResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<OrganizationCountryResponse>}
     * @memberof OrganizationCountryResultSet
     */
    'organization_countries': Array<OrganizationCountryResponse>;
}
/**
 * 
 * @export
 * @interface OrganizationCountryResultSetAllOf
 */
export interface OrganizationCountryResultSetAllOf {
    /**
     * 
     * @type {Array<OrganizationCountryResponse>}
     * @memberof OrganizationCountryResultSetAllOf
     */
    'organization_countries': Array<OrganizationCountryResponse>;
}
/**
 * 
 * @export
 * @interface OrganizationCreateParams
 */
export interface OrganizationCreateParams {
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreateParams
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreateParams
     */
    'customer_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationCreateParams
     */
    'netsuite_synced': boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreateParams
     */
    'owner_email'?: string | null;
}
/**
 * 
 * @export
 * @interface OrganizationIdAndName
 */
export interface OrganizationIdAndName {
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdAndName
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdAndName
     */
    'organization_name': string;
}
/**
 * 
 * @export
 * @interface OrganizationOverrides
 */
export interface OrganizationOverrides {
    /**
     * 
     * @type {string}
     * @memberof OrganizationOverrides
     */
    'organization_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationOverrides
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface OrganizationOwnersInner
 */
export interface OrganizationOwnersInner {
    /**
     * 
     * @type {string}
     * @memberof OrganizationOwnersInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationOwnersInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationOwnersInner
     */
    'state': string;
}
/**
 * 
 * @export
 * @interface OrganizationProductInventory
 */
export interface OrganizationProductInventory {
    /**
     * 
     * @type {string}
     * @memberof OrganizationProductInventory
     * @deprecated
     */
    'organization_product_inventory_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProductInventory
     */
    'organization_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationProductInventory
     */
    'product_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProductInventory
     */
    'product_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationProductInventory
     */
    'organization_product_quantity'?: number;
    /**
     * 
     * @type {InventoryTypeEnum}
     * @memberof OrganizationProductInventory
     */
    'inventory_type'?: InventoryTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationProductInventory
     */
    'is_subscription_product'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationProductInventory
     */
    'is_virtual_product'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof OrganizationProductInventory
     */
    'product_mapping'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationProductInventory
     */
    'customizations'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof OrganizationProductInventory
     */
    'amount_total'?: number;
    /**
     * 
     * @type {Array<AmountsPerCustomization>}
     * @memberof OrganizationProductInventory
     */
    'amounts_per_customization'?: Array<AmountsPerCustomization>;
}


/**
 * 
 * @export
 * @interface OrganizationProductInventorySet
 */
export interface OrganizationProductInventorySet {
    /**
     * 
     * @type {number}
     * @memberof OrganizationProductInventorySet
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationProductInventorySet
     */
    'total_count'?: number;
    /**
     * 
     * @type {Array<OrganizationProductInventory>}
     * @memberof OrganizationProductInventorySet
     */
    'organization_product_inventory'?: Array<OrganizationProductInventory>;
}
/**
 * 
 * @export
 * @interface OrganizationProductRequest
 */
export interface OrganizationProductRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof OrganizationProductRequest
     */
    'product_ids': Array<number>;
}
/**
 * 
 * @export
 * @interface OrganizationProductResult
 */
export interface OrganizationProductResult {
    /**
     * 
     * @type {string}
     * @memberof OrganizationProductResult
     */
    'organization_id'?: string;
    /**
     * 
     * @type {Product}
     * @memberof OrganizationProductResult
     */
    'product'?: Product;
    /**
     * 
     * @type {number}
     * @memberof OrganizationProductResult
     */
    'product_id'?: number;
}
/**
 * 
 * @export
 * @interface OrganizationProductResultSet
 */
export interface OrganizationProductResultSet {
    /**
     * 
     * @type {number}
     * @memberof OrganizationProductResultSet
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationProductResultSet
     */
    'total_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProductResultSet
     */
    'organization_id'?: string;
    /**
     * 
     * @type {Array<OrganizationProductResult>}
     * @memberof OrganizationProductResultSet
     */
    'organization_products'?: Array<OrganizationProductResult>;
}
/**
 * 
 * @export
 * @interface OrganizationSSOSummary
 */
export interface OrganizationSSOSummary {
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSSOSummary
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSSOSummary
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSSOSummary
     */
    'modified_at': string | null;
}
/**
 * 
 * @export
 * @interface OrganizationUpdateParams
 */
export interface OrganizationUpdateParams {
    /**
     * 
     * @type {string}
     * @memberof OrganizationUpdateParams
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUpdateParams
     */
    'customer_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationUpdateParams
     */
    'netsuite_synced': boolean;
}
/**
 * 
 * @export
 * @interface OrganizationsResultSet
 */
export interface OrganizationsResultSet {
    /**
     * 
     * @type {number}
     * @memberof OrganizationsResultSet
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationsResultSet
     */
    'total_count'?: number;
    /**
     * 
     * @type {Array<Organization>}
     * @memberof OrganizationsResultSet
     */
    'organizations'?: Array<Organization>;
}
/**
 * 
 * @export
 * @interface PaginationFields
 */
export interface PaginationFields {
    /**
     * 
     * @type {number}
     * @memberof PaginationFields
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationFields
     */
    'total_count': number;
}
/**
 * Passkey security compliance level. Default=3
 * @export
 * @enum {string}
 */

export enum PasskeyComplianceLevel {
    None = 0,
    Level1 = 1,
    Level2 = 2
}


/**
 * Passkey security compliance status. Default=NotApplicable
 * @export
 * @enum {string}
 */

export enum PasskeyComplianceStatus {
    NotApplicable = 1,
    Compliant = 2,
    Noncompliant = 3
}


/**
 * 
 * @export
 * @interface PhysicalAttributes
 */
export interface PhysicalAttributes {
    /**
     * 
     * @type {string}
     * @memberof PhysicalAttributes
     */
    'part_number': string | null;
    /**
     * 
     * @type {string}
     * @memberof PhysicalAttributes
     */
    'packaging_type': string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalAttributes
     */
    'form_factor': string;
    /**
     * 
     * @type {boolean}
     * @memberof PhysicalAttributes
     */
    'is_custom': boolean;
}
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'product_code': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'product_sku': string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'product_tier': number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'product_image': string;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'product_is_active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'product_is_available': boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     * @deprecated
     */
    'product_availability_message': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'ro_stock_number': string;
    /**
     * 
     * @type {InventoryTypeEnum}
     * @memberof Product
     */
    'inventory_type': InventoryTypeEnum;
    /**
     * 
     * @type {SubscriptionTypeEnum}
     * @memberof Product
     */
    'subscription_type': SubscriptionTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'is_subscription_product': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'is_virtual_product': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'is_default': boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'customization_id': string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof Product
     */
    'product_mapping': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'is_customizable': boolean;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'netsuite_id_standard'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'netsuite_id_custom'?: number | null;
}


/**
 * 
 * @export
 * @interface ProductCreateParams
 */
export interface ProductCreateParams {
    /**
     * 
     * @type {string}
     * @memberof ProductCreateParams
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateParams
     */
    'product_code': string;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateParams
     */
    'product_sku': string;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateParams
     */
    'product_image': string;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateParams
     */
    'ro_stock_number': string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCreateParams
     */
    'product_is_active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCreateParams
     */
    'product_is_available': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateParams
     * @deprecated
     */
    'product_availability_message': string;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateParams
     */
    'product_tier': number;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateParams
     */
    'inventory_type': number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCreateParams
     */
    'is_subscription_product': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCreateParams
     */
    'is_virtual_product': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCreateParams
     */
    'is_default': boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductCreateParams
     */
    'product_mapping'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateParams
     */
    'netsuite_id_standard'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateParams
     */
    'netsuite_id_custom'?: number;
}
/**
 * 
 * @export
 * @interface ProductCreateResult
 */
export interface ProductCreateResult {
    /**
     * 
     * @type {number}
     * @memberof ProductCreateResult
     */
    'product_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateResult
     */
    'product_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateResult
     */
    'product_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateResult
     */
    'product_sku'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateResult
     */
    'product_image'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateResult
     */
    'ro_stock_number'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCreateResult
     */
    'product_is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCreateResult
     */
    'product_is_available'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateResult
     * @deprecated
     */
    'product_availability_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateResult
     */
    'product_tier'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateResult
     */
    'inventory_type'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCreateResult
     */
    'is_subscription_product'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCreateResult
     */
    'is_virtual_product'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCreateResult
     */
    'is_default'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateResult
     */
    'customization_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateResult
     */
    'netsuite_id_standard'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateResult
     */
    'netsuite_id_custom'?: number;
}
/**
 * 
 * @export
 * @interface ProductCustomizationSummary
 */
export interface ProductCustomizationSummary {
    /**
     * A null customization_id represents a standard product (non-customized)
     * @type {string}
     * @memberof ProductCustomizationSummary
     */
    'customization_id': string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductCustomizationSummary
     */
    'quantity_total': number;
    /**
     * Amount remaining of this product with this customization_id
     * @type {number}
     * @memberof ProductCustomizationSummary
     */
    'quantity_remaining': number;
}
/**
 * 
 * @export
 * @interface ProductDetails
 */
export interface ProductDetails {
    /**
     * 
     * @type {number}
     * @memberof ProductDetails
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof ProductDetails
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetails
     */
    'product_code': string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetails
     */
    'product_sku': string;
    /**
     * 
     * @type {number}
     * @memberof ProductDetails
     */
    'product_tier': number;
    /**
     * 
     * @type {string}
     * @memberof ProductDetails
     */
    'product_image': string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetails
     */
    'product_is_active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetails
     */
    'product_is_available': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductDetails
     * @deprecated
     */
    'product_availability_message': string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetails
     */
    'ro_stock_number': string;
    /**
     * 
     * @type {InventoryTypeEnum}
     * @memberof ProductDetails
     */
    'inventory_type': InventoryTypeEnum;
    /**
     * 
     * @type {SubscriptionTypeEnum}
     * @memberof ProductDetails
     */
    'subscription_type': SubscriptionTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetails
     */
    'is_subscription_product': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetails
     */
    'is_virtual_product': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetails
     */
    'is_default': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductDetails
     */
    'customization_id': string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductDetails
     */
    'product_mapping': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetails
     */
    'is_customizable': boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductDetails
     */
    'netsuite_id_standard'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductDetails
     */
    'netsuite_id_custom'?: number | null;
    /**
     * 
     * @type {ProductTypeEnum}
     * @memberof ProductDetails
     */
    'product_type': ProductTypeEnum;
    /**
     * 
     * @type {ProductItemInfo}
     * @memberof ProductDetails
     */
    'standard_item_info': ProductItemInfo;
    /**
     * 
     * @type {ProductItemInfo}
     * @memberof ProductDetails
     */
    'custom_item_info': ProductItemInfo;
}


/**
 * 
 * @export
 * @interface ProductDetailsAllOf
 */
export interface ProductDetailsAllOf {
    /**
     * 
     * @type {ProductItemInfo}
     * @memberof ProductDetailsAllOf
     */
    'standard_item_info': ProductItemInfo;
    /**
     * 
     * @type {ProductItemInfo}
     * @memberof ProductDetailsAllOf
     */
    'custom_item_info': ProductItemInfo;
}
/**
 * 
 * @export
 * @interface ProductItemInfo
 */
export interface ProductItemInfo {
    /**
     * 
     * @type {string}
     * @memberof ProductItemInfo
     */
    'part_number': string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductItemInfo
     */
    'netsuite_id': number | null;
}
/**
 * 
 * @export
 * @interface ProductRefundRequest
 */
export interface ProductRefundRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductRefundRequest
     */
    'inventory_allocation_id': string;
    /**
     * 
     * @type {number}
     * @memberof ProductRefundRequest
     */
    'refund_quantity': number;
}
/**
 * 
 * @export
 * @interface ProductRefundResponse
 */
export interface ProductRefundResponse {
    /**
     * 
     * @type {string}
     * @memberof ProductRefundResponse
     */
    'product_refund_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductRefundResponse
     */
    'inventory_allocation_id': string;
    /**
     * 
     * @type {number}
     * @memberof ProductRefundResponse
     */
    'inventory_product_id': number;
    /**
     * 
     * @type {number}
     * @memberof ProductRefundResponse
     */
    'product_id': number;
    /**
     * 
     * @type {number}
     * @memberof ProductRefundResponse
     */
    'refund_quantity': number;
    /**
     * 
     * @type {number}
     * @memberof ProductRefundResponse
     */
    'product_cost': number;
    /**
     * 
     * @type {number}
     * @memberof ProductRefundResponse
     */
    'product_tax': number;
    /**
     * 
     * @type {number}
     * @memberof ProductRefundResponse
     */
    'product_vat': number;
    /**
     * 
     * @type {string}
     * @memberof ProductRefundResponse
     */
    'purchaseorder_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductRefundResponse
     */
    'purchaseorder_number': string;
    /**
     * 
     * @type {string}
     * @memberof ProductRefundResponse
     */
    'refund_date': string;
    /**
     * 
     * @type {string}
     * @memberof ProductRefundResponse
     */
    'customization_id': string | null;
}
/**
 * 
 * @export
 * @interface ProductResultSet
 */
export interface ProductResultSet {
    /**
     * 
     * @type {number}
     * @memberof ProductResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof ProductResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<AdminProduct>}
     * @memberof ProductResultSet
     */
    'products': Array<AdminProduct>;
}
/**
 * 
 * @export
 * @interface ProductResultSetAllOf
 */
export interface ProductResultSetAllOf {
    /**
     * 
     * @type {Array<AdminProduct>}
     * @memberof ProductResultSetAllOf
     */
    'products': Array<AdminProduct>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ProductState {
    Active = 'active',
    Available = 'available',
    Decomissioned = 'decomissioned'
}


/**
 * 
 * @export
 * @interface ProductSummary
 */
export interface ProductSummary {
    /**
     * 
     * @type {number}
     * @memberof ProductSummary
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof ProductSummary
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductSummary
     */
    'product_image': string;
    /**
     * 
     * @type {InventoryTypeEnum}
     * @memberof ProductSummary
     */
    'inventory_type': InventoryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ProductSummary
     */
    'quantity_total': number;
    /**
     * Avoid relying on this number; it is not very helpful if the product comes with multiple customizations. In those cases, this value represents the minimum remaining amount, that is the amount remaining of the customization with the least amount of inventory left. 
     * @type {number}
     * @memberof ProductSummary
     */
    'quantity_remaining': number;
    /**
     * 
     * @type {Array<ProductCustomizationSummary>}
     * @memberof ProductSummary
     */
    'customizations'?: Array<ProductCustomizationSummary>;
}


/**
 * 0: No tier 1: Base tier 2: Advanced tier 3: Premium tier 4: FIPS tier 5: Base tier (subscription 2.0) 6: Base/Bio tier (subscription 2.0) 7: Advanced tier (subscription 2.0) 8: Advanced/Bio tier (subscription 2.0) 9: Compliance tier (subscription 2.0) 
 * @export
 * @enum {string}
 */

export enum ProductTierEnum {
    NoTier = 0,
    BaseTier = 1,
    AdvancedTier = 2,
    PremiumTier = 3,
    FIPSTier = 4,
    Sub2BaseTier = 5,
    Sub2BaseBioTier = 6,
    Sub2AdvancedTier = 7,
    Sub2AdvancedBioTier = 8,
    Sub2ComplianceTier = 9
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum ProductType {
    Physical = 'physical',
    Subscription = 'subscription',
    UniversalSku = 'universal_sku'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum ProductTypeEnum {
    Subscription = 'Subscription',
    YubiKey = 'YubiKey',
    Accessory = 'Accessory'
}


/**
 * 
 * @export
 * @interface ProductUpdateParams
 */
export interface ProductUpdateParams {
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateParams
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateParams
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateParams
     */
    'product_code': string;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateParams
     */
    'product_sku': string;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateParams
     */
    'product_image': string;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateParams
     */
    'ro_stock_number': string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductUpdateParams
     */
    'product_is_active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductUpdateParams
     */
    'product_is_available': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateParams
     * @deprecated
     */
    'product_availability_message': string;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateParams
     */
    'product_tier': number;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateParams
     */
    'inventory_type': number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductUpdateParams
     */
    'is_subscription_product': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductUpdateParams
     */
    'is_virtual_product': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductUpdateParams
     */
    'is_default': boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductUpdateParams
     */
    'product_mapping'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateParams
     */
    'netsuite_id_custom'?: number;
}
/**
 * @type ProductV2
 * @export
 */
export type ProductV2 = ShippableProduct | VirtualProduct;

/**
 * 
 * @export
 * @interface ProductV2ResultSet
 */
export interface ProductV2ResultSet {
    /**
     * 
     * @type {number}
     * @memberof ProductV2ResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof ProductV2ResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<ProductV2>}
     * @memberof ProductV2ResultSet
     */
    'products': Array<ProductV2>;
}
/**
 * 
 * @export
 * @interface ProductV2ResultSetAllOf
 */
export interface ProductV2ResultSetAllOf {
    /**
     * 
     * @type {Array<ProductV2>}
     * @memberof ProductV2ResultSetAllOf
     */
    'products': Array<ProductV2>;
}
/**
 * 
 * @export
 * @interface PurchaseOrder
 */
export interface PurchaseOrder {
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrder
     */
    'channelpartner_id': number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'channelpartner_name': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'channelpartner_netsuite_customer_id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'purchaseorder_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'organization_name': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrder
     */
    'shipping_credit_purchased': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrder
     */
    'shipping_credit_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrder
     */
    'tax_credit_purchased': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrder
     */
    'tax_credit_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrder
     */
    'vat_credit_purchased': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrder
     */
    'vat_credit_remaining'?: number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'order_date': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'key_contact'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'key_contact_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'key_contact_phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'purchaseorder_number': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'yubicoorder_number': string;
    /**
     * 
     * @type {YubicoSubsidiaryEnum}
     * @memberof PurchaseOrder
     */
    'yubico_subsidiary': YubicoSubsidiaryEnum;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'closing_street_line1': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'closing_street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     * @deprecated
     */
    'closing_street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'closing_city': string;
    /**
     * Required if `closing_country_code_2` is either \"US\" or \"CA\"
     * @type {string}
     * @memberof PurchaseOrder
     */
    'closing_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'closing_country_code_2': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'closing_postal_code': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'purchaseorder_state_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrder
     */
    'purchaseorder_state_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'purchaseorder_state_description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrder
     */
    'is_closed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrder
     */
    'is_override_shipping'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrder
     */
    'is_post_pay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrder
     */
    'is_tax_exempt'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrder
     */
    'is_vat_valid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrder
     */
    'vat_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrder
     */
    'override_shipping_charge'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrder
     */
    'override_shipping_key_limit'?: number;
    /**
     * 
     * @type {PurchaseOrderReseller}
     * @memberof PurchaseOrder
     */
    'reseller': PurchaseOrderReseller | null;
    /**
     * 
     * @type {PurchaseOrderReseller}
     * @memberof PurchaseOrder
     */
    'distributor': PurchaseOrderReseller | null;
    /**
     * 
     * @type {Array<PurchaseOrderProduct>}
     * @memberof PurchaseOrder
     */
    'order_items': Array<PurchaseOrderProduct>;
    /**
     * 
     * @type {Array<PurchaseOrderHistoryServiceAdmin>}
     * @memberof PurchaseOrder
     */
    'purchaseorder_history': Array<PurchaseOrderHistoryServiceAdmin>;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrder
     */
    'allow_automated_shipments': boolean;
}


/**
 * 
 * @export
 * @interface PurchaseOrderCreateRequest
 */
export interface PurchaseOrderCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequest
     */
    'purchaseorder_id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequest
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequest
     */
    'order_date': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequest
     */
    'purchaseorder_number': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequest
     */
    'yubicoorder_number': string;
    /**
     * 
     * @type {YubicoSubsidiaryEnum}
     * @memberof PurchaseOrderCreateRequest
     */
    'yubico_subsidiary': YubicoSubsidiaryEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderCreateRequest
     */
    'is_override_shipping'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderCreateRequest
     */
    'override_shipping_charge'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderCreateRequest
     */
    'override_shipping_key_limit'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderCreateRequest
     */
    'is_post_pay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderCreateRequest
     */
    'is_tax_exempt'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequest
     */
    'key_contact'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequest
     */
    'key_contact_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequest
     */
    'key_contact_phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequest
     */
    'closing_street_line1': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequest
     */
    'closing_street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequest
     * @deprecated
     */
    'closing_street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequest
     */
    'closing_city': string;
    /**
     * Required if `closing_country_code_2` is either \"US\" or \"CA\"
     * @type {string}
     * @memberof PurchaseOrderCreateRequest
     */
    'closing_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequest
     */
    'closing_country_code_2': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequest
     */
    'closing_postal_code': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderCreateRequest
     */
    'shipping_credit_purchased': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderCreateRequest
     */
    'tax_credit_purchased': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderCreateRequest
     */
    'vat_credit_purchased': number;
    /**
     * 
     * @type {Array<PurchaseOrderProductRequest>}
     * @memberof PurchaseOrderCreateRequest
     */
    'order_items': Array<PurchaseOrderProductRequest>;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderCreateRequest
     */
    'allow_automated_shipments'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequest
     */
    'reseller_organization_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequest
     */
    'distributor_organization_id'?: string | null;
}


/**
 * 
 * @export
 * @interface PurchaseOrderCreateRequestAllOf
 */
export interface PurchaseOrderCreateRequestAllOf {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequestAllOf
     */
    'reseller_organization_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderCreateRequestAllOf
     */
    'distributor_organization_id'?: string | null;
}
/**
 * 
 * @export
 * @interface PurchaseOrderHistoryServiceAdmin
 */
export interface PurchaseOrderHistoryServiceAdmin {
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderHistoryServiceAdmin
     */
    'purchaseorder_history_id': number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderHistoryServiceAdmin
     */
    'purchaseorder_action_name': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderHistoryServiceAdmin
     */
    'user_email': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderHistoryServiceAdmin
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderHistoryServiceAdmin
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderHistoryServiceAdmin
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderHistoryServiceAdmin
     */
    'reseller_organization_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderHistoryServiceAdmin
     */
    'distributor_organization_id': string | null;
}
/**
 * 
 * @export
 * @interface PurchaseOrderProduct
 */
export interface PurchaseOrderProduct {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderProduct
     */
    'purchaseorder_product_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderProduct
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderProduct
     */
    'purchaseorder_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderProduct
     */
    'purchaseorder_product_quantity': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderProduct
     */
    'purchaseorder_product_quantity_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderProduct
     */
    'purchaseorder_product_cost': number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderProduct
     */
    'purchaseorder_product_created_at'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PurchaseOrderProduct
     */
    'customizations'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderProduct
     */
    'subscription_start_date': string | null;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderProduct
     */
    'subscription_end_date': string | null;
    /**
     * 
     * @type {NetsuiteOrderType}
     * @memberof PurchaseOrderProduct
     */
    'netsuite_order_type': NetsuiteOrderType | null;
}


/**
 * 
 * @export
 * @interface PurchaseOrderProductRequest
 */
export interface PurchaseOrderProductRequest {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderProductRequest
     */
    'purchaseorder_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderProductRequest
     */
    'purchaseorder_product_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderProductRequest
     */
    'product_id': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderProductRequest
     */
    'purchaseorder_product_quantity': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderProductRequest
     */
    'purchaseorder_product_cost': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PurchaseOrderProductRequest
     */
    'customizations'?: Array<string>;
    /**
     * 
     * @type {NetsuiteOrderType}
     * @memberof PurchaseOrderProductRequest
     */
    'netsuite_order_type': NetsuiteOrderType | null;
}


/**
 * 
 * @export
 * @interface PurchaseOrderRequest
 */
export interface PurchaseOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderRequest
     */
    'purchaseorder_id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderRequest
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderRequest
     */
    'order_date': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderRequest
     */
    'purchaseorder_number': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderRequest
     */
    'yubicoorder_number': string;
    /**
     * 
     * @type {YubicoSubsidiaryEnum}
     * @memberof PurchaseOrderRequest
     */
    'yubico_subsidiary': YubicoSubsidiaryEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderRequest
     */
    'is_override_shipping'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderRequest
     */
    'override_shipping_charge'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderRequest
     */
    'override_shipping_key_limit'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderRequest
     */
    'is_post_pay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderRequest
     */
    'is_tax_exempt'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderRequest
     */
    'key_contact'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderRequest
     */
    'key_contact_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderRequest
     */
    'key_contact_phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderRequest
     */
    'closing_street_line1': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderRequest
     */
    'closing_street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderRequest
     * @deprecated
     */
    'closing_street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderRequest
     */
    'closing_city': string;
    /**
     * Required if `closing_country_code_2` is either \"US\" or \"CA\"
     * @type {string}
     * @memberof PurchaseOrderRequest
     */
    'closing_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderRequest
     */
    'closing_country_code_2': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderRequest
     */
    'closing_postal_code': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderRequest
     */
    'shipping_credit_purchased': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderRequest
     */
    'tax_credit_purchased': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderRequest
     */
    'vat_credit_purchased': number;
    /**
     * 
     * @type {Array<PurchaseOrderProductRequest>}
     * @memberof PurchaseOrderRequest
     */
    'order_items': Array<PurchaseOrderProductRequest>;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderRequest
     */
    'allow_automated_shipments'?: boolean | null;
}


/**
 * 
 * @export
 * @interface PurchaseOrderReseller
 */
export interface PurchaseOrderReseller {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderReseller
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderReseller
     */
    'organization_name': string;
}
/**
 * 
 * @export
 * @interface PurchaseOrderResultSet
 */
export interface PurchaseOrderResultSet {
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<PurchaseOrder>}
     * @memberof PurchaseOrderResultSet
     */
    'purchaseorders': Array<PurchaseOrder>;
}
/**
 * 
 * @export
 * @interface PurchaseOrderResultSetAllOf
 */
export interface PurchaseOrderResultSetAllOf {
    /**
     * 
     * @type {Array<PurchaseOrder>}
     * @memberof PurchaseOrderResultSetAllOf
     */
    'purchaseorders': Array<PurchaseOrder>;
}
/**
 * 
 * @export
 * @interface PurchaseOrderUpdateRequest
 */
export interface PurchaseOrderUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderUpdateRequest
     */
    'purchaseorder_id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderUpdateRequest
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderUpdateRequest
     */
    'order_date': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderUpdateRequest
     */
    'purchaseorder_number': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderUpdateRequest
     */
    'yubicoorder_number': string;
    /**
     * 
     * @type {YubicoSubsidiaryEnum}
     * @memberof PurchaseOrderUpdateRequest
     */
    'yubico_subsidiary': YubicoSubsidiaryEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderUpdateRequest
     */
    'is_override_shipping'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderUpdateRequest
     */
    'override_shipping_charge'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderUpdateRequest
     */
    'override_shipping_key_limit'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderUpdateRequest
     */
    'is_post_pay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderUpdateRequest
     */
    'is_tax_exempt'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderUpdateRequest
     */
    'key_contact'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderUpdateRequest
     */
    'key_contact_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderUpdateRequest
     */
    'key_contact_phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderUpdateRequest
     */
    'closing_street_line1': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderUpdateRequest
     */
    'closing_street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderUpdateRequest
     * @deprecated
     */
    'closing_street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderUpdateRequest
     */
    'closing_city': string;
    /**
     * Required if `closing_country_code_2` is either \"US\" or \"CA\"
     * @type {string}
     * @memberof PurchaseOrderUpdateRequest
     */
    'closing_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderUpdateRequest
     */
    'closing_country_code_2': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderUpdateRequest
     */
    'closing_postal_code': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderUpdateRequest
     */
    'shipping_credit_purchased': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderUpdateRequest
     */
    'tax_credit_purchased': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderUpdateRequest
     */
    'vat_credit_purchased': number;
    /**
     * 
     * @type {Array<PurchaseOrderProductRequest>}
     * @memberof PurchaseOrderUpdateRequest
     */
    'order_items': Array<PurchaseOrderProductRequest>;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderUpdateRequest
     */
    'allow_automated_shipments'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderUpdateRequest
     */
    'comment'?: string;
}


/**
 * 
 * @export
 * @interface PurchaseOrderUpdateRequestAllOf
 */
export interface PurchaseOrderUpdateRequestAllOf {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderUpdateRequestAllOf
     */
    'comment'?: string;
}
/**
 * See more details at https://console.yubico.com/help/single-req.html#shipment-request-field-limitations
 * @export
 * @interface Recipient
 */
export interface Recipient {
    /**
     * 
     * @type {string}
     * @memberof Recipient
     */
    'recipient_company'?: string;
    /**
     * 
     * @type {string}
     * @memberof Recipient
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Recipient
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof Recipient
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof Recipient
     */
    'recipient_telephone'?: string;
}
/**
 * Netsuite record type (either \"item\", \"customer\" or \"customization\").
 * @export
 * @enum {string}
 */

export enum RecordTypeEnum {
    Item = 'item',
    Customer = 'customer',
    Customization = 'customization'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum RefundReasonRequest {
    LostInTransit = 'lost-in-transit',
    UndeliverableRefusedReturned = 'undeliverable-refused-returned',
    ShippingHandlingIssues = 'shipping-handling-issues',
    WarrantyReplacement = 'warranty-replacement',
    ExceptionRefundedProduct = 'exception-refunded-product',
    ExceptionRefundedProductShipping = 'exception-refunded-product-shipping',
    Cancelled = 'cancelled'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum RefundReasonResponse {
    LostInTransit = 'lost-in-transit',
    UndeliverableRefusedReturned = 'undeliverable-refused-returned',
    ShippingHandlingIssues = 'shipping-handling-issues',
    WarrantyReplacement = 'warranty-replacement',
    ExceptionRefundedProduct = 'exception-refunded-product',
    ExceptionRefundedProductShipping = 'exception-refunded-product-shipping',
    Cancelled = 'cancelled',
    Empty = ''
}


/**
 * 
 * @export
 * @interface ReplacementShipmentLink
 */
export interface ReplacementShipmentLink {
    /**
     * 
     * @type {string}
     * @memberof ReplacementShipmentLink
     */
    'shipment_id': string;
}
/**
 * 
 * @export
 * @interface ResetTermsAndConditionsRequest
 */
export interface ResetTermsAndConditionsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ResetTermsAndConditionsRequest
     */
    'confirm_destructive_operation': boolean;
}
/**
 * 
 * @export
 * @interface Role
 */
export interface Role {
    /**
     * 
     * @type {number}
     * @memberof Role
     */
    'role_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'role_name'?: string;
}
/**
 * 
 * @export
 * @interface SearchDescription
 */
export interface SearchDescription {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDescription
     */
    'basic': Array<string>;
    /**
     * 
     * @type {Array<SearchDescriptionAdvanced>}
     * @memberof SearchDescription
     */
    'advanced': Array<SearchDescriptionAdvanced>;
}
/**
 * 
 * @export
 * @interface SearchDescriptionAdvanced
 */
export interface SearchDescriptionAdvanced {
    /**
     * 
     * @type {string}
     * @memberof SearchDescriptionAdvanced
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDescriptionAdvanced
     */
    'type': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDescriptionAdvanced
     */
    'operations': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDescriptionAdvanced
     */
    'select_values'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ShipmentAddressBulkOverrideResponse
 */
export interface ShipmentAddressBulkOverrideResponse {
    /**
     * 
     * @type {string}
     * @memberof ShipmentAddressBulkOverrideResponse
     */
    'message': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShipmentAddressBulkOverrideResponse
     */
    'failed_shipments': Array<string>;
}
/**
 * 
 * @export
 * @interface ShipmentBulkDeleteResponse
 */
export interface ShipmentBulkDeleteResponse {
    /**
     * 
     * @type {string}
     * @memberof ShipmentBulkDeleteResponse
     */
    'message'?: string;
    /**
     * 
     * @type {Array<ShipmentBulkDeleteResponseFailedShipmentsInner>}
     * @memberof ShipmentBulkDeleteResponse
     */
    'failed_shipments'?: Array<ShipmentBulkDeleteResponseFailedShipmentsInner>;
}
/**
 * 
 * @export
 * @interface ShipmentBulkDeleteResponseFailedShipmentsInner
 */
export interface ShipmentBulkDeleteResponseFailedShipmentsInner {
    /**
     * 
     * @type {string}
     * @memberof ShipmentBulkDeleteResponseFailedShipmentsInner
     */
    'shipment_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentBulkDeleteResponseFailedShipmentsInner
     */
    'fault'?: string;
}
/**
 * Type of delivery service requested, 1 for normal (standard) shipping or 2 for expedited (rush) shipping. Default=1.
 * @export
 * @enum {string}
 */

export enum ShipmentDeliveryTypeEnum {
    Standard = 1,
    Expedited = 2
}


/**
 * 
 * @export
 * @interface ShipmentExactLimitedResponseServiceAdmin
 */
export interface ShipmentExactLimitedResponseServiceAdmin {
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'shipment_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'channelpartner_id': number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'channelpartner_name': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'channelpartner_netsuite_customer_id': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'rushorder_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'external_order_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'fulfillment_partner'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'user_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'country_code_2'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'is_delivered': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'is_sent_to_fulfillment': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'is_shipped': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'is_post_pay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'is_tax_exempt'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'address_validation_bypass'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'organization_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'organization_netsuite_customer_id': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'recipient'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'recipient_telephone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     * @deprecated
     */
    'street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'tracking_link'?: string;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'delivery_type'?: ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {CarrierIdentifierEnum}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'carrier'?: CarrierIdentifierEnum;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'tracking_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'shipment_request_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'shipment_updated_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'shipped_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'delivered_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'shipment_state_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'shipment_state_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'shipment_state_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'shipment_customer_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'shipment_summary_description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'shipment_product_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'shipment_product_taxes'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'shipment_product_vat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'shipping_service_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'shipping_service_taxes'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'shipping_service_vat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'total_shipment_product_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'total_shipment_tax_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'total_shipment_vat_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'total_shipping_service_cost'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'is_vat_valid'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'shipment_destination_vat_rate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'total_shipment_vat'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'total_keys_shipped'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'total_cost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'shipment_type': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'override_action'?: string;
    /**
     * 
     * @type {ShipmentRMA}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'rma': ShipmentRMA;
    /**
     * This flag indicates if shipment is FIDO2 Pre-registered
     * @type {boolean}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'is_preregistered'?: boolean;
    /**
     * 
     * @type {ShipmentExactLimitedResponseServiceAdminDistributor}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'distributor': ShipmentExactLimitedResponseServiceAdminDistributor | null;
    /**
     * 
     * @type {CreationTypeEnum}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'creation_type'?: CreationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdmin
     */
    'grant_id': string | null;
}


/**
 * 
 * @export
 * @interface ShipmentExactLimitedResponseServiceAdminDistributor
 */
export interface ShipmentExactLimitedResponseServiceAdminDistributor {
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdminDistributor
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdminDistributor
     */
    'organization_name': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdminDistributor
     */
    'netsuite_customer_id': string;
}
/**
 * 
 * @export
 * @interface ShipmentExactLimitedResponseServiceAdminDistributorAllOf
 */
export interface ShipmentExactLimitedResponseServiceAdminDistributorAllOf {
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponseServiceAdminDistributorAllOf
     */
    'netsuite_customer_id': string;
}
/**
 * 
 * @export
 * @interface ShipmentExactRequestProduct
 */
export interface ShipmentExactRequestProduct {
    /**
     * The unique ID of a non-custom product, for example \'1\' for YubiKey 5 NFC. Can also refer to a custom product (legacy). See [Product and Inventory Identifiers](https://docs.yubico.com/cloud-services/yubienterprise/delivery/api-best-practices-faq.html#product-and-inventory-identifiers). To make a shipment request for *custom-programmed keys*, ensure to use the /inventory /products API to get the specific product_id.
     * @type {number}
     * @memberof ShipmentExactRequestProduct
     */
    'product_id'?: number;
    /**
     * The ID of the inventory from which to draw products. Relates to types of purchasing tier options, for example \'15\' for Primary Subscription-Advanced Tier-Initial. See [Product and Inventory Identifiers](https://docs.yubico.com/cloud-services/yubienterprise/delivery/api-best-practices-faq.html#product-and-inventory-identifiers). To make a shipment request for *custom-programmed keys*, ensure to use the /inventory /products API to get the specific inventory_product_id.
     * @type {number}
     * @memberof ShipmentExactRequestProduct
     */
    'inventory_product_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactRequestProduct
     */
    'customization_id'?: string | null;
    /**
     * The quantity of products of this type to include in the shipment request.
     * @type {number}
     * @memberof ShipmentExactRequestProduct
     */
    'shipment_product_quantity'?: number;
}
/**
 * 
 * @export
 * @interface ShipmentExactResponseServiceAdmin
 */
export interface ShipmentExactResponseServiceAdmin {
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipment_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'channelpartner_id': number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'channelpartner_name': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'channelpartner_netsuite_customer_id': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'rushorder_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'external_order_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'fulfillment_partner'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'user_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'country_code_2'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'is_delivered': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'is_sent_to_fulfillment': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'is_shipped': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'is_post_pay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'is_tax_exempt'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'address_validation_bypass'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'organization_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'organization_netsuite_customer_id': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'recipient'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'recipient_telephone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     * @deprecated
     */
    'street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'tracking_link'?: string;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'delivery_type'?: ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {CarrierIdentifierEnum}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'carrier'?: CarrierIdentifierEnum;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'tracking_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipment_request_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipment_updated_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipped_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'delivered_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipment_state_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipment_state_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipment_state_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipment_customer_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipment_summary_description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipment_product_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipment_product_taxes'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipment_product_vat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipping_service_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipping_service_taxes'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipping_service_vat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'total_shipment_product_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'total_shipment_tax_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'total_shipment_vat_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'total_shipping_service_cost'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'is_vat_valid'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipment_destination_vat_rate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'total_shipment_vat'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'total_keys_shipped'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'total_cost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipment_type': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'override_action'?: string;
    /**
     * 
     * @type {ShipmentRMA}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'rma': ShipmentRMA;
    /**
     * This flag indicates if shipment is FIDO2 Pre-registered
     * @type {boolean}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'is_preregistered'?: boolean;
    /**
     * 
     * @type {ShipmentExactLimitedResponseServiceAdminDistributor}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'distributor': ShipmentExactLimitedResponseServiceAdminDistributor | null;
    /**
     * 
     * @type {CreationTypeEnum}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'creation_type'?: CreationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'grant_id': string | null;
    /**
     * 
     * @type {Array<ShipmentResponseProductServiceAdmin>}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipment_items'?: Array<ShipmentResponseProductServiceAdmin>;
    /**
     * 
     * @type {Array<ShipmentMessage>}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipment_messages'?: Array<ShipmentMessage>;
    /**
     * 
     * @type {Array<ShipmentHistory>}
     * @memberof ShipmentExactResponseServiceAdmin
     */
    'shipment_history'?: Array<ShipmentHistory>;
}


/**
 * 
 * @export
 * @interface ShipmentExactResponseServiceAdminAllOf
 */
export interface ShipmentExactResponseServiceAdminAllOf {
    /**
     * 
     * @type {Array<ShipmentResponseProductServiceAdmin>}
     * @memberof ShipmentExactResponseServiceAdminAllOf
     */
    'shipment_items'?: Array<ShipmentResponseProductServiceAdmin>;
    /**
     * 
     * @type {Array<ShipmentMessage>}
     * @memberof ShipmentExactResponseServiceAdminAllOf
     */
    'shipment_messages'?: Array<ShipmentMessage>;
    /**
     * 
     * @type {Array<ShipmentHistory>}
     * @memberof ShipmentExactResponseServiceAdminAllOf
     */
    'shipment_history'?: Array<ShipmentHistory>;
}
/**
 * 
 * @export
 * @interface ShipmentExactResultSetServiceAdmin
 */
export interface ShipmentExactResultSetServiceAdmin {
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResultSetServiceAdmin
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResultSetServiceAdmin
     */
    'total_count': number;
    /**
     * 
     * @type {Array<ShipmentExactLimitedResponseServiceAdmin>}
     * @memberof ShipmentExactResultSetServiceAdmin
     */
    'shipments': Array<ShipmentExactLimitedResponseServiceAdmin>;
}
/**
 * 
 * @export
 * @interface ShipmentExactResultSetServiceAdminAllOf
 */
export interface ShipmentExactResultSetServiceAdminAllOf {
    /**
     * 
     * @type {Array<ShipmentExactLimitedResponseServiceAdmin>}
     * @memberof ShipmentExactResultSetServiceAdminAllOf
     */
    'shipments': Array<ShipmentExactLimitedResponseServiceAdmin>;
}
/**
 * 
 * @export
 * @interface ShipmentHistory
 */
export interface ShipmentHistory {
    /**
     * 
     * @type {number}
     * @memberof ShipmentHistory
     */
    'shipment_history_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentHistory
     */
    'shipment_action_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentHistory
     */
    'shipment_state_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentHistory
     */
    'user_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentHistory
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentHistory
     */
    'created_at'?: string;
    /**
     * 
     * @type {Array<ShipmentHistoryShipmentHistoryMessagesInner>}
     * @memberof ShipmentHistory
     */
    'shipment_history_messages': Array<ShipmentHistoryShipmentHistoryMessagesInner>;
    /**
     * 
     * @type {ShipmentHistoryShipmentOverrideComment}
     * @memberof ShipmentHistory
     */
    'shipment_override_comment'?: ShipmentHistoryShipmentOverrideComment | null;
    /**
     * 
     * @type {Array<ShipmentHistoryShipmentSupportTicketsInner>}
     * @memberof ShipmentHistory
     */
    'shipment_support_tickets'?: Array<ShipmentHistoryShipmentSupportTicketsInner>;
}
/**
 * 
 * @export
 * @interface ShipmentHistoryShipmentHistoryMessagesInner
 */
export interface ShipmentHistoryShipmentHistoryMessagesInner {
    /**
     * 
     * @type {string}
     * @memberof ShipmentHistoryShipmentHistoryMessagesInner
     */
    'shipment_history_message_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentHistoryShipmentHistoryMessagesInner
     */
    'shipment_message_body'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentHistoryShipmentHistoryMessagesInner
     */
    'update_counter': number;
}
/**
 * 
 * @export
 * @interface ShipmentHistoryShipmentOverrideComment
 */
export interface ShipmentHistoryShipmentOverrideComment {
    /**
     * 
     * @type {string}
     * @memberof ShipmentHistoryShipmentOverrideComment
     */
    'user_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentHistoryShipmentOverrideComment
     */
    'comment'?: string;
}
/**
 * 
 * @export
 * @interface ShipmentHistoryShipmentSupportTicketsInner
 */
export interface ShipmentHistoryShipmentSupportTicketsInner {
    /**
     * 
     * @type {string}
     * @memberof ShipmentHistoryShipmentSupportTicketsInner
     */
    'ticket_number': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentHistoryShipmentSupportTicketsInner
     */
    'ticket_type': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentHistoryShipmentSupportTicketsInner
     */
    'ticket_link'?: string;
}
/**
 * 
 * @export
 * @interface ShipmentMessage
 */
export interface ShipmentMessage {
    /**
     * 
     * @type {string}
     * @memberof ShipmentMessage
     */
    'shipment_message_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentMessage
     */
    'shipment_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentMessage
     */
    'shipment_message_body'?: string;
}
/**
 * 
 * @export
 * @interface ShipmentProductData
 */
export interface ShipmentProductData {
    /**
     * 
     * @type {string}
     * @memberof ShipmentProductData
     */
    'serial_number': string | null;
    /**
     * 
     * @type {string}
     * @memberof ShipmentProductData
     */
    'firmware_version': string | null;
}
/**
 * 
 * @export
 * @interface ShipmentProductParams
 */
export interface ShipmentProductParams {
    /**
     * 
     * @type {number}
     * @memberof ShipmentProductParams
     */
    'inventory_product_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentProductParams
     */
    'product_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentProductParams
     */
    'customization_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShipmentProductParams
     */
    'shipment_product_quantity': number;
}
/**
 * 
 * @export
 * @interface ShipmentRMA
 */
export interface ShipmentRMA {
    /**
     * 
     * @type {Array<string>}
     * @memberof ShipmentRMA
     */
    'replacement_shipments': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ShipmentRMA
     */
    'replaced_shipment'?: string;
}
/**
 * 
 * @export
 * @interface ShipmentRefundRequest
 */
export interface ShipmentRefundRequest {
    /**
     * 
     * @type {number}
     * @memberof ShipmentRefundRequest
     */
    'shipping_fee_refund'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentRefundRequest
     */
    'shipping_tax_refund'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentRefundRequest
     */
    'shipping_vat_refund'?: number;
    /**
     * 
     * @type {Array<ProductRefundRequest>}
     * @memberof ShipmentRefundRequest
     */
    'product_refund'?: Array<ProductRefundRequest>;
    /**
     * 
     * @type {RefundReasonRequest}
     * @memberof ShipmentRefundRequest
     */
    'refund_reason': RefundReasonRequest;
    /**
     * 
     * @type {string}
     * @memberof ShipmentRefundRequest
     */
    'comment': string;
    /**
     * 
     * @type {Array<SupportTicket>}
     * @memberof ShipmentRefundRequest
     */
    'shipment_support_tickets'?: Array<SupportTicket>;
}


/**
 * 
 * @export
 * @interface ShipmentRefundRequestAllOf
 */
export interface ShipmentRefundRequestAllOf {
    /**
     * 
     * @type {Array<ProductRefundRequest>}
     * @memberof ShipmentRefundRequestAllOf
     */
    'product_refund'?: Array<ProductRefundRequest>;
    /**
     * 
     * @type {RefundReasonRequest}
     * @memberof ShipmentRefundRequestAllOf
     */
    'refund_reason': RefundReasonRequest;
    /**
     * 
     * @type {string}
     * @memberof ShipmentRefundRequestAllOf
     */
    'comment': string;
    /**
     * 
     * @type {Array<SupportTicket>}
     * @memberof ShipmentRefundRequestAllOf
     */
    'shipment_support_tickets'?: Array<SupportTicket>;
}


/**
 * 
 * @export
 * @interface ShipmentResponseProductServiceAdmin
 */
export interface ShipmentResponseProductServiceAdmin {
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseProductServiceAdmin
     */
    'shipment_product_id': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseProductServiceAdmin
     */
    'shipment_id': string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseProductServiceAdmin
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseProductServiceAdmin
     */
    'product_name': string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseProductServiceAdmin
     */
    'inventory_product_id': number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseProductServiceAdmin
     */
    'shipment_product_quantity': number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseProductServiceAdmin
     */
    'shipment_product_line_cost': number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseProductServiceAdmin
     */
    'customization_id': string | null;
    /**
     * 
     * @type {Array<ShipmentProductData>}
     * @memberof ShipmentResponseProductServiceAdmin
     */
    'shipment_product_data': Array<ShipmentProductData>;
}
/**
 * 
 * @export
 * @interface ShipmentUpdateAddressRequest
 */
export interface ShipmentUpdateAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateAddressRequest
     */
    'country_code_2': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateAddressRequest
     */
    'recipient'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateAddressRequest
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateAddressRequest
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateAddressRequest
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateAddressRequest
     */
    'recipient_telephone': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateAddressRequest
     */
    'street_line1': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateAddressRequest
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateAddressRequest
     * @deprecated
     */
    'street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateAddressRequest
     */
    'city': string;
    /**
     * Required if `country_code_2` is either \"US\" or \"CA\"
     * @type {string}
     * @memberof ShipmentUpdateAddressRequest
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateAddressRequest
     */
    'postal_code': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateAddressRequest
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface ShipmentUpdateParams
 */
export interface ShipmentUpdateParams {
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateParams
     */
    'shipment_id'?: string;
    /**
     * 
     * @type {Array<ShipmentProductParams>}
     * @memberof ShipmentUpdateParams
     */
    'shipment_items'?: Array<ShipmentProductParams>;
    /**
     * 
     * @type {number}
     * @memberof ShipmentUpdateParams
     */
    'channel_partner_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateParams
     */
    'country_code_2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateParams
     */
    'recipient'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateParams
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateParams
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateParams
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateParams
     */
    'recipient_telephone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateParams
     */
    'street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateParams
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateParams
     */
    'street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateParams
     */
    'city'?: string;
    /**
     * Required if `country_code_2` is either \"US\" or \"CA\"
     * @type {string}
     * @memberof ShipmentUpdateParams
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentUpdateParams
     */
    'postal_code'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentUpdateParams
     */
    'delivery_type'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentUpdateParams
     */
    'address_validation_bypass'?: boolean;
}
/**
 * 
 * @export
 * @interface ShippableProduct
 */
export interface ShippableProduct {
    /**
     * 
     * @type {number}
     * @memberof ShippableProduct
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ShippableProduct
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ShippableProduct
     */
    'code': string;
    /**
     * 
     * @type {ProductState}
     * @memberof ShippableProduct
     */
    'state': ProductState;
    /**
     * 
     * @type {ProductType}
     * @memberof ShippableProduct
     */
    'type': ProductType;
    /**
     * 
     * @type {string}
     * @memberof ShippableProduct
     */
    'image': string;
    /**
     * 
     * @type {string}
     * @memberof ShippableProduct
     */
    'sku': string;
    /**
     * 
     * @type {string}
     * @memberof ShippableProduct
     */
    'ro_stock_number': string;
    /**
     * 
     * @type {string}
     * @memberof ShippableProduct
     */
    'customization_id': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShippableProduct
     */
    'default': boolean;
    /**
     * 
     * @type {ItemInfo}
     * @memberof ShippableProduct
     */
    'standard_item_info': ItemInfo | null;
    /**
     * 
     * @type {ItemInfo}
     * @memberof ShippableProduct
     */
    'custom_item_info': ItemInfo | null;
}


/**
 * 
 * @export
 * @interface ShippableProductAllOf
 */
export interface ShippableProductAllOf {
    /**
     * 
     * @type {string}
     * @memberof ShippableProductAllOf
     */
    'sku': string;
    /**
     * 
     * @type {string}
     * @memberof ShippableProductAllOf
     */
    'ro_stock_number': string;
    /**
     * 
     * @type {string}
     * @memberof ShippableProductAllOf
     */
    'customization_id': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShippableProductAllOf
     */
    'default': boolean;
    /**
     * 
     * @type {ItemInfo}
     * @memberof ShippableProductAllOf
     */
    'standard_item_info': ItemInfo | null;
    /**
     * 
     * @type {ItemInfo}
     * @memberof ShippableProductAllOf
     */
    'custom_item_info': ItemInfo | null;
}
/**
 * 
 * @export
 * @interface ShippingRefundRequest
 */
export interface ShippingRefundRequest {
    /**
     * 
     * @type {number}
     * @memberof ShippingRefundRequest
     */
    'shipping_fee_refund'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShippingRefundRequest
     */
    'shipping_tax_refund'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShippingRefundRequest
     */
    'shipping_vat_refund'?: number;
}
/**
 * 
 * @export
 * @interface ShippingRefundResponse
 */
export interface ShippingRefundResponse {
    /**
     * 
     * @type {string}
     * @memberof ShippingRefundResponse
     */
    'shipping_refund_id': string;
    /**
     * 
     * @type {number}
     * @memberof ShippingRefundResponse
     */
    'shipping_fee_refunded': number;
    /**
     * 
     * @type {number}
     * @memberof ShippingRefundResponse
     */
    'shipping_tax_refunded': number;
    /**
     * 
     * @type {number}
     * @memberof ShippingRefundResponse
     */
    'shipping_vat_refunded': number;
    /**
     * 
     * @type {string}
     * @memberof ShippingRefundResponse
     */
    'refund_date': string;
}
/**
 * 
 * @export
 * @interface StandardErrorDetail
 */
export interface StandardErrorDetail {
    /**
     * The message explaining the detailed error in text.
     * @type {string}
     * @memberof StandardErrorDetail
     */
    'message': string;
    /**
     * json path to the field, if the error detail refers to a field
     * @type {string}
     * @memberof StandardErrorDetail
     */
    'field'?: string;
}
/**
 * 
 * @export
 * @interface StandardErrorResult
 */
export interface StandardErrorResult {
    /**
     * 
     * @type {string}
     * @memberof StandardErrorResult
     */
    'code': string;
    /**
     * The error message in text
     * @type {string}
     * @memberof StandardErrorResult
     */
    'message'?: string;
    /**
     * A list of details of each distinct problem encountered. Omitted when empty
     * @type {Array<StandardErrorDetail>}
     * @memberof StandardErrorResult
     */
    'errors'?: Array<StandardErrorDetail>;
}
/**
 * 
 * @export
 * @interface StateOverride
 */
export interface StateOverride {
    /**
     * 
     * @type {number}
     * @memberof StateOverride
     */
    'shipment_state_id': number;
    /**
     * 
     * @type {string}
     * @memberof StateOverride
     */
    'comment': string;
    /**
     * Required if overriding to delivered, otherwise it is ignored.
     * @type {string}
     * @memberof StateOverride
     */
    'delivered_date': string | null;
    /**
     * Required if overriding to shipped or delivered, otherwise it is ignored.
     * @type {string}
     * @memberof StateOverride
     */
    'tracking_number': string | null;
    /**
     * 
     * @type {CarrierIdentifierEnum}
     * @memberof StateOverride
     */
    'carrier': CarrierIdentifierEnum | null;
    /**
     * 
     * @type {Array<SupportTicket>}
     * @memberof StateOverride
     */
    'shipment_support_tickets'?: Array<SupportTicket>;
}


/**
 * 
 * @export
 * @interface SubscriptionAttributes
 */
export interface SubscriptionAttributes {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionAttributes
     */
    'year': number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAttributes
     */
    'plan': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAttributes
     */
    'tier': string;
}
/**
 * The action that was performed (either \"Override\" or \"Delete\").
 * @export
 * @enum {string}
 */

export enum SubscriptionDateOverrideActionEnum {
    Override = 'Override',
    Delete = 'Delete'
}


/**
 * 
 * @export
 * @interface SubscriptionDateOverrideRequest
 */
export interface SubscriptionDateOverrideRequest {
    /**
     * Required if action is `Override`, otherwise it is ignored.
     * @type {string}
     * @memberof SubscriptionDateOverrideRequest
     */
    'start_date'?: string | null;
    /**
     * Required if action is `Override`, otherwise it is ignored.
     * @type {string}
     * @memberof SubscriptionDateOverrideRequest
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDateOverrideRequest
     */
    'comment'?: string;
    /**
     * 
     * @type {SubscriptionDateOverrideActionEnum}
     * @memberof SubscriptionDateOverrideRequest
     */
    'action'?: SubscriptionDateOverrideActionEnum;
}


/**
 * 
 * @export
 * @interface SubscriptionDateOverrideResponse
 */
export interface SubscriptionDateOverrideResponse {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDateOverrideResponse
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDateOverrideResponse
     */
    'end_date': string;
    /**
     * The email of the user who created the override action.
     * @type {string}
     * @memberof SubscriptionDateOverrideResponse
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDateOverrideResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDateOverrideResponse
     */
    'comment': string;
    /**
     * 
     * @type {SubscriptionDateOverrideActionEnum}
     * @memberof SubscriptionDateOverrideResponse
     */
    'action': SubscriptionDateOverrideActionEnum;
}


/**
 * 
 * @export
 * @interface SubscriptionSummary
 */
export interface SubscriptionSummary {
    /**
     * 
     * @type {ProductTierEnum}
     * @memberof SubscriptionSummary
     */
    'product_tier': ProductTierEnum;
    /**
     * 
     * @type {SubscriptionTypeEnum}
     * @memberof SubscriptionSummary
     */
    'subscription_type': SubscriptionTypeEnum;
    /**
     * Ordered by inventory type (initial first, then buffer, then replacement) 
     * @type {Array<ProductSummary>}
     * @memberof SubscriptionSummary
     */
    'products': Array<ProductSummary>;
}


/**
 * 0: N/A (no subscription) 1: Primary subscription 2: Backup subscription 3: Primary Standard subscription 2.0 4: Backup Standard subscription 2.0 5: Primary Plus subscription 2.0 6: Backup Plus subscription 2.0 
 * @export
 * @enum {string}
 */

export enum SubscriptionTypeEnum {
    NoSubscription = 0,
    PrimarySubscription = 1,
    BackupSubscription = 2,
    Sub2PrimaryStandard = 3,
    Sub2BackupStandard = 4,
    Sub2PrimaryPlus = 5,
    Sub2BackupPlus = 6
}


/**
 * 
 * @export
 * @interface SupportTicket
 */
export interface SupportTicket {
    /**
     * 
     * @type {string}
     * @memberof SupportTicket
     */
    'ticket_number': string;
    /**
     * 
     * @type {string}
     * @memberof SupportTicket
     */
    'ticket_type': string;
}
/**
 * 
 * @export
 * @interface TrackingInfoUpdateParams
 */
export interface TrackingInfoUpdateParams {
    /**
     * 
     * @type {string}
     * @memberof TrackingInfoUpdateParams
     */
    'tracking_number': string;
    /**
     * 
     * @type {CarrierIdentifierEnum}
     * @memberof TrackingInfoUpdateParams
     */
    'carrier': CarrierIdentifierEnum;
    /**
     * 
     * @type {string}
     * @memberof TrackingInfoUpdateParams
     */
    'comment': string;
}


/**
 * 
 * @export
 * @interface UpdateUserParams
 */
export interface UpdateUserParams {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserParams
     */
    'organization_id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserParams
     */
    'roles': Array<string>;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'id': string;
    /**
     * 
     * @type {UserProfile}
     * @memberof User
     */
    'profile': UserProfile;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'accepted_terms': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'demo_mode': boolean;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof User
     */
    'roles': { [key: string]: Array<string>; };
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'last_login': string | null;
    /**
     * The use of this property is not recommended, as it is an experimental field that is likely to change. True when the user has one or more mfa registered. 
     * @type {boolean}
     * @memberof User
     */
    'mfa_registered': boolean;
    /**
     * The use of this property is not recommended, as it is an experimental field that is likely to change. True when the user has password registered. 
     * @type {boolean}
     * @memberof User
     */
    'password_registered': boolean;
    /**
     * The use of this property is not recommended, as it is an experimental field that is likely to change. True when the user has migrated to passwordless authentication. 
     * @type {boolean}
     * @memberof User
     */
    'passwordless_migrated': boolean;
    /**
     * The use of this property is not recommended, as it is an experimental field that is likely to change. The number of passkeys a user has registered. 
     * @type {number}
     * @memberof User
     */
    'passkey_count': number;
    /**
     * 
     * @type {PasskeyComplianceStatus}
     * @memberof User
     */
    'compliance_status': PasskeyComplianceStatus;
}


/**
 * 
 * @export
 * @interface UserProfile
 */
export interface UserProfile {
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    'last_name': string;
}
/**
 * 
 * @export
 * @interface UserResultSet
 */
export interface UserResultSet {
    /**
     * 
     * @type {number}
     * @memberof UserResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof UserResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<User>}
     * @memberof UserResultSet
     */
    'users': Array<User>;
}
/**
 * Deprecated: To be replaced by \'#/components/schemas/StandardErrorResult\'
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'code': string;
    /**
     * The error message in text
     * @type {string}
     * @memberof ValidationError
     */
    'message'?: string;
    /**
     * A list of details of each distinct problem encountered. Omitted when empty
     * @type {Array<StandardErrorDetail>}
     * @memberof ValidationError
     */
    'errors'?: Array<StandardErrorDetail>;
}
/**
 * 
 * @export
 * @interface VirtualProduct
 */
export interface VirtualProduct {
    /**
     * 
     * @type {number}
     * @memberof VirtualProduct
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof VirtualProduct
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualProduct
     */
    'code': string;
    /**
     * 
     * @type {ProductState}
     * @memberof VirtualProduct
     */
    'state': ProductState;
    /**
     * 
     * @type {ProductType}
     * @memberof VirtualProduct
     */
    'type': ProductType;
    /**
     * 
     * @type {string}
     * @memberof VirtualProduct
     */
    'image': string;
    /**
     * 
     * @type {SubscriptionTypeEnum}
     * @memberof VirtualProduct
     */
    'subscription_type': SubscriptionTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof VirtualProduct
     */
    'product_mapping': Array<number>;
}


/**
 * 
 * @export
 * @interface VirtualProductAllOf
 */
export interface VirtualProductAllOf {
    /**
     * 
     * @type {SubscriptionTypeEnum}
     * @memberof VirtualProductAllOf
     */
    'subscription_type': SubscriptionTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof VirtualProductAllOf
     */
    'product_mapping': Array<number>;
}


/**
 * 
 * @export
 * @interface WithID
 */
export interface WithID {
    /**
     * 
     * @type {string}
     * @memberof WithID
     */
    'id': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum YEDClassification {
    Subscription = 1,
    YubiKey = 2,
    YubiAccessory = 3
}


/**
 * 0: Unknown subsidiary 1: Yubico AB 2: Yubico Inc. 
 * @export
 * @enum {string}
 */

export enum YubicoSubsidiaryEnum {
    Unknown = 0,
    YubicoAB = 1,
    YubicoInc = 2
}



/**
 * BannerApi - axios parameter creator
 * @export
 */
export const BannerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new banner to the system
         * @summary Create banner
         * @param {Banner} banner Banner object that will be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBanner: async (banner: Banner, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'banner' is not null or undefined
            assertParamExists('addBanner', 'banner', banner)
            const localVarPath = `/v1/serviceadmin/banners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(banner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all banners in the system
         * @summary Get all banners
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetBanners: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/banners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a banner by making it non-active.
         * @summary Delete a banner
         * @param {string} bannerId ID of the banner that will be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBanner: async (bannerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bannerId' is not null or undefined
            assertParamExists('deleteBanner', 'bannerId', bannerId)
            const localVarPath = `/v1/serviceadmin/banners/{bannerId}`
                .replace(`{${"bannerId"}}`, encodeURIComponent(String(bannerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes banner searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBannerSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/banners/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replace a banner by deleting and creating a new one
         * @summary Replace a banner
         * @param {string} bannerId ID of the banner that will be replaced
         * @param {Banner} banner Banner object that will be re-created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceBanner: async (bannerId: string, banner: Banner, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bannerId' is not null or undefined
            assertParamExists('replaceBanner', 'bannerId', bannerId)
            // verify required parameter 'banner' is not null or undefined
            assertParamExists('replaceBanner', 'banner', banner)
            const localVarPath = `/v1/serviceadmin/banners/replace/{bannerId}`
                .replace(`{${"bannerId"}}`, encodeURIComponent(String(bannerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(banner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BannerApi - functional programming interface
 * @export
 */
export const BannerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BannerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new banner to the system
         * @summary Create banner
         * @param {Banner} banner Banner object that will be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBanner(banner: Banner, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBanner(banner, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all banners in the system
         * @summary Get all banners
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetBanners(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBannersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetBanners(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes a banner by making it non-active.
         * @summary Delete a banner
         * @param {string} bannerId ID of the banner that will be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBanner(bannerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBanner(bannerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes banner searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBannerSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBannerSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Replace a banner by deleting and creating a new one
         * @summary Replace a banner
         * @param {string} bannerId ID of the banner that will be replaced
         * @param {Banner} banner Banner object that will be re-created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceBanner(bannerId: string, banner: Banner, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceBanner(bannerId, banner, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BannerApi - factory interface
 * @export
 */
export const BannerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BannerApiFp(configuration)
    return {
        /**
         * Add a new banner to the system
         * @summary Create banner
         * @param {Banner} banner Banner object that will be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBanner(banner: Banner, options?: any): AxiosPromise<void> {
            return localVarFp.addBanner(banner, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all banners in the system
         * @summary Get all banners
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetBanners(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<GetBannersResponse> {
            return localVarFp.adminGetBanners(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a banner by making it non-active.
         * @summary Delete a banner
         * @param {string} bannerId ID of the banner that will be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBanner(bannerId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteBanner(bannerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes banner searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBannerSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listBannerSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * Replace a banner by deleting and creating a new one
         * @summary Replace a banner
         * @param {string} bannerId ID of the banner that will be replaced
         * @param {Banner} banner Banner object that will be re-created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceBanner(bannerId: string, banner: Banner, options?: any): AxiosPromise<void> {
            return localVarFp.replaceBanner(bannerId, banner, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BannerApi - object-oriented interface
 * @export
 * @class BannerApi
 * @extends {BaseAPI}
 */
export class BannerApi extends BaseAPI {
    /**
     * Add a new banner to the system
     * @summary Create banner
     * @param {Banner} banner Banner object that will be created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannerApi
     */
    public addBanner(banner: Banner, options?: AxiosRequestConfig) {
        return BannerApiFp(this.configuration).addBanner(banner, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all banners in the system
     * @summary Get all banners
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannerApi
     */
    public adminGetBanners(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return BannerApiFp(this.configuration).adminGetBanners(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a banner by making it non-active.
     * @summary Delete a banner
     * @param {string} bannerId ID of the banner that will be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannerApi
     */
    public deleteBanner(bannerId: string, options?: AxiosRequestConfig) {
        return BannerApiFp(this.configuration).deleteBanner(bannerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes banner searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannerApi
     */
    public listBannerSearchDescription(options?: AxiosRequestConfig) {
        return BannerApiFp(this.configuration).listBannerSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replace a banner by deleting and creating a new one
     * @summary Replace a banner
     * @param {string} bannerId ID of the banner that will be replaced
     * @param {Banner} banner Banner object that will be re-created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannerApi
     */
    public replaceBanner(bannerId: string, banner: Banner, options?: AxiosRequestConfig) {
        return BannerApiFp(this.configuration).replaceBanner(bannerId, banner, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ChannelpartnerApi - axios parameter creator
 * @export
 */
export const ChannelpartnerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns array of product SKUs and quantities for the organizationId and the channelpartnerId in the URL
         * @summary Returns array of SKUs and quantities available for the organization for a specific channelpartner
         * @param {string} organizationId ID of Organization to return
         * @param {number} channelpartnerId ID of the channelpartner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryOfOrganizationInURLWithChannelPartnerId: async (organizationId: string, channelpartnerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getInventoryOfOrganizationInURLWithChannelPartnerId', 'organizationId', organizationId)
            // verify required parameter 'channelpartnerId' is not null or undefined
            assertParamExists('getInventoryOfOrganizationInURLWithChannelPartnerId', 'channelpartnerId', channelpartnerId)
            const localVarPath = `/v1/serviceadmin/inventory/{organizationId}/channelpartners/{channelpartnerId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelpartnerId"}}`, encodeURIComponent(String(channelpartnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChannelpartnerApi - functional programming interface
 * @export
 */
export const ChannelpartnerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChannelpartnerApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns array of product SKUs and quantities for the organizationId and the channelpartnerId in the URL
         * @summary Returns array of SKUs and quantities available for the organization for a specific channelpartner
         * @param {string} organizationId ID of Organization to return
         * @param {number} channelpartnerId ID of the channelpartner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryOfOrganizationInURLWithChannelPartnerId(organizationId: string, channelpartnerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationProductInventorySet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryOfOrganizationInURLWithChannelPartnerId(organizationId, channelpartnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ChannelpartnerApi - factory interface
 * @export
 */
export const ChannelpartnerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChannelpartnerApiFp(configuration)
    return {
        /**
         * Returns array of product SKUs and quantities for the organizationId and the channelpartnerId in the URL
         * @summary Returns array of SKUs and quantities available for the organization for a specific channelpartner
         * @param {string} organizationId ID of Organization to return
         * @param {number} channelpartnerId ID of the channelpartner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryOfOrganizationInURLWithChannelPartnerId(organizationId: string, channelpartnerId: number, options?: any): AxiosPromise<OrganizationProductInventorySet> {
            return localVarFp.getInventoryOfOrganizationInURLWithChannelPartnerId(organizationId, channelpartnerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChannelpartnerApi - object-oriented interface
 * @export
 * @class ChannelpartnerApi
 * @extends {BaseAPI}
 */
export class ChannelpartnerApi extends BaseAPI {
    /**
     * Returns array of product SKUs and quantities for the organizationId and the channelpartnerId in the URL
     * @summary Returns array of SKUs and quantities available for the organization for a specific channelpartner
     * @param {string} organizationId ID of Organization to return
     * @param {number} channelpartnerId ID of the channelpartner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChannelpartnerApi
     */
    public getInventoryOfOrganizationInURLWithChannelPartnerId(organizationId: string, channelpartnerId: number, options?: AxiosRequestConfig) {
        return ChannelpartnerApiFp(this.configuration).getInventoryOfOrganizationInURLWithChannelPartnerId(organizationId, channelpartnerId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ChannelpartnersApi - axios parameter creator
 * @export
 */
export const ChannelpartnersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Restricted to service admins, owners and auditors.
         * @summary Get all channelpartners
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllChannelPartners: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/channelpartners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get channelpartner by ID
         * @param {number} channelpartnerId ID of the channelpartner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChannelPartnerById: async (channelpartnerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'channelpartnerId' is not null or undefined
            assertParamExists('getChannelPartnerById', 'channelpartnerId', channelpartnerId)
            const localVarPath = `/v1/serviceadmin/channelpartners/{channelpartnerId}`
                .replace(`{${"channelpartnerId"}}`, encodeURIComponent(String(channelpartnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChannelpartnersApi - functional programming interface
 * @export
 */
export const ChannelpartnersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChannelpartnersApiAxiosParamCreator(configuration)
    return {
        /**
         * Restricted to service admins, owners and auditors.
         * @summary Get all channelpartners
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllChannelPartners(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChannelPartnerResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllChannelPartners(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get channelpartner by ID
         * @param {number} channelpartnerId ID of the channelpartner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChannelPartnerById(channelpartnerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChannelPartner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChannelPartnerById(channelpartnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ChannelpartnersApi - factory interface
 * @export
 */
export const ChannelpartnersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChannelpartnersApiFp(configuration)
    return {
        /**
         * Restricted to service admins, owners and auditors.
         * @summary Get all channelpartners
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllChannelPartners(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<ChannelPartnerResultSet> {
            return localVarFp.getAllChannelPartners(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get channelpartner by ID
         * @param {number} channelpartnerId ID of the channelpartner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChannelPartnerById(channelpartnerId: number, options?: any): AxiosPromise<ChannelPartner> {
            return localVarFp.getChannelPartnerById(channelpartnerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChannelpartnersApi - object-oriented interface
 * @export
 * @class ChannelpartnersApi
 * @extends {BaseAPI}
 */
export class ChannelpartnersApi extends BaseAPI {
    /**
     * Restricted to service admins, owners and auditors.
     * @summary Get all channelpartners
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChannelpartnersApi
     */
    public getAllChannelPartners(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return ChannelpartnersApiFp(this.configuration).getAllChannelPartners(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get channelpartner by ID
     * @param {number} channelpartnerId ID of the channelpartner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChannelpartnersApi
     */
    public getChannelPartnerById(channelpartnerId: number, options?: AxiosRequestConfig) {
        return ChannelpartnersApiFp(this.configuration).getChannelPartnerById(channelpartnerId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CountriesApi - axios parameter creator
 * @export
 */
export const CountriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all available countries
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: async (offset?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns Country record with two letter code
         * @summary Find country by two letter code
         * @param {string} countryCode2 Unique two letter code associated to country record to be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryById: async (countryCode2: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryCode2' is not null or undefined
            assertParamExists('getCountryById', 'countryCode2', countryCode2)
            const localVarPath = `/v1/serviceadmin/countries/{countryCode2}`
                .replace(`{${"countryCode2"}}`, encodeURIComponent(String(countryCode2)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set of all country permissions for an organization
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCountries: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getOrganizationCountries', 'orgId', orgId)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/countries`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace enabled countries for an organization
         * @param {string} orgId ID of the Organization
         * @param {OrganizationCountryRequestBulk} body Country IDs of all countries to be enabled for the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationCountries: async (orgId: string, body: OrganizationCountryRequestBulk, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updateOrganizationCountries', 'orgId', orgId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateOrganizationCountries', 'body', body)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/countries`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CountriesApi - functional programming interface
 * @export
 */
export const CountriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CountriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List all available countries
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountries(offset?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountryResultSetServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountries(offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns Country record with two letter code
         * @summary Find country by two letter code
         * @param {string} countryCode2 Unique two letter code associated to country record to be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountryById(countryCode2: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountryResponseServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountryById(countryCode2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set of all country permissions for an organization
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationCountries(orgId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationCountryResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationCountries(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace enabled countries for an organization
         * @param {string} orgId ID of the Organization
         * @param {OrganizationCountryRequestBulk} body Country IDs of all countries to be enabled for the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationCountries(orgId: string, body: OrganizationCountryRequestBulk, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationCountryResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationCountries(orgId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CountriesApi - factory interface
 * @export
 */
export const CountriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CountriesApiFp(configuration)
    return {
        /**
         * 
         * @summary List all available countries
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(offset?: number, limit?: number, options?: any): AxiosPromise<CountryResultSetServiceAdmin> {
            return localVarFp.getCountries(offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns Country record with two letter code
         * @summary Find country by two letter code
         * @param {string} countryCode2 Unique two letter code associated to country record to be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryById(countryCode2: string, options?: any): AxiosPromise<CountryResponseServiceAdmin> {
            return localVarFp.getCountryById(countryCode2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set of all country permissions for an organization
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCountries(orgId: string, options?: any): AxiosPromise<OrganizationCountryResultSet> {
            return localVarFp.getOrganizationCountries(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace enabled countries for an organization
         * @param {string} orgId ID of the Organization
         * @param {OrganizationCountryRequestBulk} body Country IDs of all countries to be enabled for the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationCountries(orgId: string, body: OrganizationCountryRequestBulk, options?: any): AxiosPromise<OrganizationCountryResultSet> {
            return localVarFp.updateOrganizationCountries(orgId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CountriesApi - object-oriented interface
 * @export
 * @class CountriesApi
 * @extends {BaseAPI}
 */
export class CountriesApi extends BaseAPI {
    /**
     * 
     * @summary List all available countries
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    public getCountries(offset?: number, limit?: number, options?: AxiosRequestConfig) {
        return CountriesApiFp(this.configuration).getCountries(offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns Country record with two letter code
     * @summary Find country by two letter code
     * @param {string} countryCode2 Unique two letter code associated to country record to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    public getCountryById(countryCode2: string, options?: AxiosRequestConfig) {
        return CountriesApiFp(this.configuration).getCountryById(countryCode2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set of all country permissions for an organization
     * @param {string} orgId ID of the Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    public getOrganizationCountries(orgId: string, options?: AxiosRequestConfig) {
        return CountriesApiFp(this.configuration).getOrganizationCountries(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace enabled countries for an organization
     * @param {string} orgId ID of the Organization
     * @param {OrganizationCountryRequestBulk} body Country IDs of all countries to be enabled for the organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    public updateOrganizationCountries(orgId: string, body: OrganizationCountryRequestBulk, options?: AxiosRequestConfig) {
        return CountriesApiFp(this.configuration).updateOrganizationCountries(orgId, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomizationsApi - axios parameter creator
 * @export
 */
export const CustomizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all customizations in the system
         * @summary Get all customizations
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCustomizations: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/customizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all history events for a given customization
         * @param {string} customizationId ID of the Customization for which the inventory is being fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomizationHistory: async (customizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customizationId' is not null or undefined
            assertParamExists('getCustomizationHistory', 'customizationId', customizationId)
            const localVarPath = `/v1/serviceadmin/customizations/{customizationId}/history`
                .replace(`{${"customizationId"}}`, encodeURIComponent(String(customizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes customization searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomizationSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/customizations/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all organizations that can use the customization
         * @summary List associations of customization to organizations
         * @param {string} customizationId ID of the Customization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readOrgCustomizationRelationship: async (customizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customizationId' is not null or undefined
            assertParamExists('readOrgCustomizationRelationship', 'customizationId', customizationId)
            const localVarPath = `/v1/serviceadmin/customizations/{customizationId}/organizations`
                .replace(`{${"customizationId"}}`, encodeURIComponent(String(customizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable new set of organizations to use the customization. An empty set will delete all organization mappings.
         * @summary Manage customization to organizations
         * @param {string} customizationId ID of the Customization
         * @param {CreateCustomizationRelationship} [createCustomizationRelationship] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrgCustomizationRelationship: async (customizationId: string, createCustomizationRelationship?: CreateCustomizationRelationship, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customizationId' is not null or undefined
            assertParamExists('updateOrgCustomizationRelationship', 'customizationId', customizationId)
            const localVarPath = `/v1/serviceadmin/customizations/{customizationId}/organizations`
                .replace(`{${"customizationId"}}`, encodeURIComponent(String(customizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomizationRelationship, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomizationsApi - functional programming interface
 * @export
 */
export const CustomizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all customizations in the system
         * @summary Get all customizations
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetCustomizations(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomizationResponseSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetCustomizations(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieves all history events for a given customization
         * @param {string} customizationId ID of the Customization for which the inventory is being fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomizationHistory(customizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomizationHistoryResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomizationHistory(customizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes customization searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCustomizationSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCustomizationSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List all organizations that can use the customization
         * @summary List associations of customization to organizations
         * @param {string} customizationId ID of the Customization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readOrgCustomizationRelationship(customizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgCustomizationRelationshipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readOrgCustomizationRelationship(customizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Enable new set of organizations to use the customization. An empty set will delete all organization mappings.
         * @summary Manage customization to organizations
         * @param {string} customizationId ID of the Customization
         * @param {CreateCustomizationRelationship} [createCustomizationRelationship] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrgCustomizationRelationship(customizationId: string, createCustomizationRelationship?: CreateCustomizationRelationship, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgCustomizationRelationshipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrgCustomizationRelationship(customizationId, createCustomizationRelationship, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomizationsApi - factory interface
 * @export
 */
export const CustomizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomizationsApiFp(configuration)
    return {
        /**
         * Get all customizations in the system
         * @summary Get all customizations
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCustomizations(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<CustomizationResponseSet> {
            return localVarFp.adminGetCustomizations(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all history events for a given customization
         * @param {string} customizationId ID of the Customization for which the inventory is being fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomizationHistory(customizationId: string, options?: any): AxiosPromise<Array<CustomizationHistoryResponseInner>> {
            return localVarFp.getCustomizationHistory(customizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes customization searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomizationSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listCustomizationSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * List all organizations that can use the customization
         * @summary List associations of customization to organizations
         * @param {string} customizationId ID of the Customization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readOrgCustomizationRelationship(customizationId: string, options?: any): AxiosPromise<OrgCustomizationRelationshipResponse> {
            return localVarFp.readOrgCustomizationRelationship(customizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable new set of organizations to use the customization. An empty set will delete all organization mappings.
         * @summary Manage customization to organizations
         * @param {string} customizationId ID of the Customization
         * @param {CreateCustomizationRelationship} [createCustomizationRelationship] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrgCustomizationRelationship(customizationId: string, createCustomizationRelationship?: CreateCustomizationRelationship, options?: any): AxiosPromise<OrgCustomizationRelationshipResponse> {
            return localVarFp.updateOrgCustomizationRelationship(customizationId, createCustomizationRelationship, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomizationsApi - object-oriented interface
 * @export
 * @class CustomizationsApi
 * @extends {BaseAPI}
 */
export class CustomizationsApi extends BaseAPI {
    /**
     * Get all customizations in the system
     * @summary Get all customizations
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomizationsApi
     */
    public adminGetCustomizations(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return CustomizationsApiFp(this.configuration).adminGetCustomizations(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all history events for a given customization
     * @param {string} customizationId ID of the Customization for which the inventory is being fetched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomizationsApi
     */
    public getCustomizationHistory(customizationId: string, options?: AxiosRequestConfig) {
        return CustomizationsApiFp(this.configuration).getCustomizationHistory(customizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes customization searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomizationsApi
     */
    public listCustomizationSearchDescription(options?: AxiosRequestConfig) {
        return CustomizationsApiFp(this.configuration).listCustomizationSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all organizations that can use the customization
     * @summary List associations of customization to organizations
     * @param {string} customizationId ID of the Customization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomizationsApi
     */
    public readOrgCustomizationRelationship(customizationId: string, options?: AxiosRequestConfig) {
        return CustomizationsApiFp(this.configuration).readOrgCustomizationRelationship(customizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable new set of organizations to use the customization. An empty set will delete all organization mappings.
     * @summary Manage customization to organizations
     * @param {string} customizationId ID of the Customization
     * @param {CreateCustomizationRelationship} [createCustomizationRelationship] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomizationsApi
     */
    public updateOrgCustomizationRelationship(customizationId: string, createCustomizationRelationship?: CreateCustomizationRelationship, options?: AxiosRequestConfig) {
        return CustomizationsApiFp(this.configuration).updateOrgCustomizationRelationship(customizationId, createCustomizationRelationship, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomproductredeemApi - axios parameter creator
 * @export
 */
export const CustomproductredeemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create the custom product redeems for a virtual product
         * @summary Create the custom product redeems for a virtual product
         * @param {string} orgId ID of the Organization
         * @param {CustomProductRedeemVirtualProduct} customProductRedeemVirtualProduct Mapping between virtual product and the physical keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomProductRedeem: async (orgId: string, customProductRedeemVirtualProduct: CustomProductRedeemVirtualProduct, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('createCustomProductRedeem', 'orgId', orgId)
            // verify required parameter 'customProductRedeemVirtualProduct' is not null or undefined
            assertParamExists('createCustomProductRedeem', 'customProductRedeemVirtualProduct', customProductRedeemVirtualProduct)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/customproductredeem`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customProductRedeemVirtualProduct, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create the custom product redeems for all virtual products in a tier
         * @summary Create the custom product redeems for all virtual products in a tier
         * @param {string} orgId ID of the Organization
         * @param {CustomProductRedeemTierRequest} customProductRedeemTierRequest Mapping between the virtual product tier and the physical keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomProductRedeemTier: async (orgId: string, customProductRedeemTierRequest: CustomProductRedeemTierRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('createCustomProductRedeemTier', 'orgId', orgId)
            // verify required parameter 'customProductRedeemTierRequest' is not null or undefined
            assertParamExists('createCustomProductRedeemTier', 'customProductRedeemTierRequest', customProductRedeemTierRequest)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/customproductredeem-tier`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customProductRedeemTierRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the custom product redeems for a virtual product
         * @summary Delete the custom product redeems for a virtual product
         * @param {string} orgId ID of the Organization
         * @param {string} virtualProductId ID of the virtual product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomProductRedeem: async (orgId: string, virtualProductId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('deleteCustomProductRedeem', 'orgId', orgId)
            // verify required parameter 'virtualProductId' is not null or undefined
            assertParamExists('deleteCustomProductRedeem', 'virtualProductId', virtualProductId)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/customproductredeem/{virtualProductId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"virtualProductId"}}`, encodeURIComponent(String(virtualProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the custom product redeems for all virtual products in a tier
         * @summary Delete the custom product redeems for all virtual products in a tier
         * @param {string} orgId ID of the Organization
         * @param {string} productTier Product tier of virtual products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomProductRedeemTier: async (orgId: string, productTier: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('deleteCustomProductRedeemTier', 'orgId', orgId)
            // verify required parameter 'productTier' is not null or undefined
            assertParamExists('deleteCustomProductRedeemTier', 'productTier', productTier)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/customproductredeem-tier/{productTier}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"productTier"}}`, encodeURIComponent(String(productTier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the custom product redeems for a virtual product
         * @summary Return the custom product redeems for a virtual product
         * @param {string} orgId ID of the Organization
         * @param {string} virtualProductId ID of the virtual product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomProductRedeem: async (orgId: string, virtualProductId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getCustomProductRedeem', 'orgId', orgId)
            // verify required parameter 'virtualProductId' is not null or undefined
            assertParamExists('getCustomProductRedeem', 'virtualProductId', virtualProductId)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/customproductredeem/{virtualProductId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"virtualProductId"}}`, encodeURIComponent(String(virtualProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the custom product redeems for all virtual products in a tier
         * @summary Get the custom product redeems for all virtual products in a tier
         * @param {string} orgId ID of the Organization
         * @param {string} productTier Product tier of virtual products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomProductRedeemTier: async (orgId: string, productTier: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getCustomProductRedeemTier', 'orgId', orgId)
            // verify required parameter 'productTier' is not null or undefined
            assertParamExists('getCustomProductRedeemTier', 'productTier', productTier)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/customproductredeem-tier/{productTier}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"productTier"}}`, encodeURIComponent(String(productTier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the custom product redeems for all virtual product tiers
         * @summary Get the custom product redeems for all virtual product tiers
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomProductRedeemTiers: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getCustomProductRedeemTiers', 'orgId', orgId)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/customproductredeem-tier`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the array of custom product redeems
         * @summary Return the array of custom product redeems
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomProductRedeems: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getCustomProductRedeems', 'orgId', orgId)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/customproductredeem`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the custom product redeems for a virtual product
         * @summary Update the custom product redeems for a virtual product
         * @param {string} orgId ID of the Organization
         * @param {string} virtualProductId ID of the virtual product
         * @param {CustomProductRedeemVirtualProduct} customProductRedeemVirtualProduct Mapping between virtual product and the physical keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomProductRedeem: async (orgId: string, virtualProductId: string, customProductRedeemVirtualProduct: CustomProductRedeemVirtualProduct, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updateCustomProductRedeem', 'orgId', orgId)
            // verify required parameter 'virtualProductId' is not null or undefined
            assertParamExists('updateCustomProductRedeem', 'virtualProductId', virtualProductId)
            // verify required parameter 'customProductRedeemVirtualProduct' is not null or undefined
            assertParamExists('updateCustomProductRedeem', 'customProductRedeemVirtualProduct', customProductRedeemVirtualProduct)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/customproductredeem/{virtualProductId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"virtualProductId"}}`, encodeURIComponent(String(virtualProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customProductRedeemVirtualProduct, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the custom product redeems for all virtual products in a tier
         * @summary Update the custom product redeems for all virtual products in a tier
         * @param {string} orgId ID of the Organization
         * @param {string} productTier Product tier of virtual products
         * @param {CustomProductRedeemTier} customProductRedeemTier Mapping between the virtual product tier and the physical keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomProductRedeemTier: async (orgId: string, productTier: string, customProductRedeemTier: CustomProductRedeemTier, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updateCustomProductRedeemTier', 'orgId', orgId)
            // verify required parameter 'productTier' is not null or undefined
            assertParamExists('updateCustomProductRedeemTier', 'productTier', productTier)
            // verify required parameter 'customProductRedeemTier' is not null or undefined
            assertParamExists('updateCustomProductRedeemTier', 'customProductRedeemTier', customProductRedeemTier)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/customproductredeem-tier/{productTier}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"productTier"}}`, encodeURIComponent(String(productTier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customProductRedeemTier, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomproductredeemApi - functional programming interface
 * @export
 */
export const CustomproductredeemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomproductredeemApiAxiosParamCreator(configuration)
    return {
        /**
         * Create the custom product redeems for a virtual product
         * @summary Create the custom product redeems for a virtual product
         * @param {string} orgId ID of the Organization
         * @param {CustomProductRedeemVirtualProduct} customProductRedeemVirtualProduct Mapping between virtual product and the physical keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomProductRedeem(orgId: string, customProductRedeemVirtualProduct: CustomProductRedeemVirtualProduct, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomProductRedeemVirtualProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomProductRedeem(orgId, customProductRedeemVirtualProduct, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create the custom product redeems for all virtual products in a tier
         * @summary Create the custom product redeems for all virtual products in a tier
         * @param {string} orgId ID of the Organization
         * @param {CustomProductRedeemTierRequest} customProductRedeemTierRequest Mapping between the virtual product tier and the physical keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomProductRedeemTier(orgId: string, customProductRedeemTierRequest: CustomProductRedeemTierRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomProductRedeemTierResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomProductRedeemTier(orgId, customProductRedeemTierRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete the custom product redeems for a virtual product
         * @summary Delete the custom product redeems for a virtual product
         * @param {string} orgId ID of the Organization
         * @param {string} virtualProductId ID of the virtual product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomProductRedeem(orgId: string, virtualProductId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomProductRedeem(orgId, virtualProductId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete the custom product redeems for all virtual products in a tier
         * @summary Delete the custom product redeems for all virtual products in a tier
         * @param {string} orgId ID of the Organization
         * @param {string} productTier Product tier of virtual products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomProductRedeemTier(orgId: string, productTier: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomProductRedeemTier(orgId, productTier, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the custom product redeems for a virtual product
         * @summary Return the custom product redeems for a virtual product
         * @param {string} orgId ID of the Organization
         * @param {string} virtualProductId ID of the virtual product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomProductRedeem(orgId: string, virtualProductId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomProductRedeemVirtualProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomProductRedeem(orgId, virtualProductId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the custom product redeems for all virtual products in a tier
         * @summary Get the custom product redeems for all virtual products in a tier
         * @param {string} orgId ID of the Organization
         * @param {string} productTier Product tier of virtual products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomProductRedeemTier(orgId: string, productTier: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomProductRedeemTier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomProductRedeemTier(orgId, productTier, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the custom product redeems for all virtual product tiers
         * @summary Get the custom product redeems for all virtual product tiers
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomProductRedeemTiers(orgId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllCustomProductRedeemTiersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomProductRedeemTiers(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return the array of custom product redeems
         * @summary Return the array of custom product redeems
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomProductRedeems(orgId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomProductRedeemVirtualProduct>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomProductRedeems(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update the custom product redeems for a virtual product
         * @summary Update the custom product redeems for a virtual product
         * @param {string} orgId ID of the Organization
         * @param {string} virtualProductId ID of the virtual product
         * @param {CustomProductRedeemVirtualProduct} customProductRedeemVirtualProduct Mapping between virtual product and the physical keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomProductRedeem(orgId: string, virtualProductId: string, customProductRedeemVirtualProduct: CustomProductRedeemVirtualProduct, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomProductRedeemVirtualProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomProductRedeem(orgId, virtualProductId, customProductRedeemVirtualProduct, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update the custom product redeems for all virtual products in a tier
         * @summary Update the custom product redeems for all virtual products in a tier
         * @param {string} orgId ID of the Organization
         * @param {string} productTier Product tier of virtual products
         * @param {CustomProductRedeemTier} customProductRedeemTier Mapping between the virtual product tier and the physical keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomProductRedeemTier(orgId: string, productTier: string, customProductRedeemTier: CustomProductRedeemTier, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomProductRedeemTier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomProductRedeemTier(orgId, productTier, customProductRedeemTier, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomproductredeemApi - factory interface
 * @export
 */
export const CustomproductredeemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomproductredeemApiFp(configuration)
    return {
        /**
         * Create the custom product redeems for a virtual product
         * @summary Create the custom product redeems for a virtual product
         * @param {string} orgId ID of the Organization
         * @param {CustomProductRedeemVirtualProduct} customProductRedeemVirtualProduct Mapping between virtual product and the physical keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomProductRedeem(orgId: string, customProductRedeemVirtualProduct: CustomProductRedeemVirtualProduct, options?: any): AxiosPromise<CustomProductRedeemVirtualProduct> {
            return localVarFp.createCustomProductRedeem(orgId, customProductRedeemVirtualProduct, options).then((request) => request(axios, basePath));
        },
        /**
         * Create the custom product redeems for all virtual products in a tier
         * @summary Create the custom product redeems for all virtual products in a tier
         * @param {string} orgId ID of the Organization
         * @param {CustomProductRedeemTierRequest} customProductRedeemTierRequest Mapping between the virtual product tier and the physical keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomProductRedeemTier(orgId: string, customProductRedeemTierRequest: CustomProductRedeemTierRequest, options?: any): AxiosPromise<CustomProductRedeemTierResponse> {
            return localVarFp.createCustomProductRedeemTier(orgId, customProductRedeemTierRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the custom product redeems for a virtual product
         * @summary Delete the custom product redeems for a virtual product
         * @param {string} orgId ID of the Organization
         * @param {string} virtualProductId ID of the virtual product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomProductRedeem(orgId: string, virtualProductId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCustomProductRedeem(orgId, virtualProductId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the custom product redeems for all virtual products in a tier
         * @summary Delete the custom product redeems for all virtual products in a tier
         * @param {string} orgId ID of the Organization
         * @param {string} productTier Product tier of virtual products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomProductRedeemTier(orgId: string, productTier: string, options?: any): AxiosPromise<APIResponse> {
            return localVarFp.deleteCustomProductRedeemTier(orgId, productTier, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the custom product redeems for a virtual product
         * @summary Return the custom product redeems for a virtual product
         * @param {string} orgId ID of the Organization
         * @param {string} virtualProductId ID of the virtual product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomProductRedeem(orgId: string, virtualProductId: string, options?: any): AxiosPromise<CustomProductRedeemVirtualProduct> {
            return localVarFp.getCustomProductRedeem(orgId, virtualProductId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the custom product redeems for all virtual products in a tier
         * @summary Get the custom product redeems for all virtual products in a tier
         * @param {string} orgId ID of the Organization
         * @param {string} productTier Product tier of virtual products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomProductRedeemTier(orgId: string, productTier: string, options?: any): AxiosPromise<CustomProductRedeemTier> {
            return localVarFp.getCustomProductRedeemTier(orgId, productTier, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the custom product redeems for all virtual product tiers
         * @summary Get the custom product redeems for all virtual product tiers
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomProductRedeemTiers(orgId: string, options?: any): AxiosPromise<AllCustomProductRedeemTiersResponse> {
            return localVarFp.getCustomProductRedeemTiers(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the array of custom product redeems
         * @summary Return the array of custom product redeems
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomProductRedeems(orgId: string, options?: any): AxiosPromise<Array<CustomProductRedeemVirtualProduct>> {
            return localVarFp.getCustomProductRedeems(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the custom product redeems for a virtual product
         * @summary Update the custom product redeems for a virtual product
         * @param {string} orgId ID of the Organization
         * @param {string} virtualProductId ID of the virtual product
         * @param {CustomProductRedeemVirtualProduct} customProductRedeemVirtualProduct Mapping between virtual product and the physical keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomProductRedeem(orgId: string, virtualProductId: string, customProductRedeemVirtualProduct: CustomProductRedeemVirtualProduct, options?: any): AxiosPromise<CustomProductRedeemVirtualProduct> {
            return localVarFp.updateCustomProductRedeem(orgId, virtualProductId, customProductRedeemVirtualProduct, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the custom product redeems for all virtual products in a tier
         * @summary Update the custom product redeems for all virtual products in a tier
         * @param {string} orgId ID of the Organization
         * @param {string} productTier Product tier of virtual products
         * @param {CustomProductRedeemTier} customProductRedeemTier Mapping between the virtual product tier and the physical keys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomProductRedeemTier(orgId: string, productTier: string, customProductRedeemTier: CustomProductRedeemTier, options?: any): AxiosPromise<CustomProductRedeemTier> {
            return localVarFp.updateCustomProductRedeemTier(orgId, productTier, customProductRedeemTier, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomproductredeemApi - object-oriented interface
 * @export
 * @class CustomproductredeemApi
 * @extends {BaseAPI}
 */
export class CustomproductredeemApi extends BaseAPI {
    /**
     * Create the custom product redeems for a virtual product
     * @summary Create the custom product redeems for a virtual product
     * @param {string} orgId ID of the Organization
     * @param {CustomProductRedeemVirtualProduct} customProductRedeemVirtualProduct Mapping between virtual product and the physical keys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomproductredeemApi
     */
    public createCustomProductRedeem(orgId: string, customProductRedeemVirtualProduct: CustomProductRedeemVirtualProduct, options?: AxiosRequestConfig) {
        return CustomproductredeemApiFp(this.configuration).createCustomProductRedeem(orgId, customProductRedeemVirtualProduct, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create the custom product redeems for all virtual products in a tier
     * @summary Create the custom product redeems for all virtual products in a tier
     * @param {string} orgId ID of the Organization
     * @param {CustomProductRedeemTierRequest} customProductRedeemTierRequest Mapping between the virtual product tier and the physical keys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomproductredeemApi
     */
    public createCustomProductRedeemTier(orgId: string, customProductRedeemTierRequest: CustomProductRedeemTierRequest, options?: AxiosRequestConfig) {
        return CustomproductredeemApiFp(this.configuration).createCustomProductRedeemTier(orgId, customProductRedeemTierRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the custom product redeems for a virtual product
     * @summary Delete the custom product redeems for a virtual product
     * @param {string} orgId ID of the Organization
     * @param {string} virtualProductId ID of the virtual product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomproductredeemApi
     */
    public deleteCustomProductRedeem(orgId: string, virtualProductId: string, options?: AxiosRequestConfig) {
        return CustomproductredeemApiFp(this.configuration).deleteCustomProductRedeem(orgId, virtualProductId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the custom product redeems for all virtual products in a tier
     * @summary Delete the custom product redeems for all virtual products in a tier
     * @param {string} orgId ID of the Organization
     * @param {string} productTier Product tier of virtual products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomproductredeemApi
     */
    public deleteCustomProductRedeemTier(orgId: string, productTier: string, options?: AxiosRequestConfig) {
        return CustomproductredeemApiFp(this.configuration).deleteCustomProductRedeemTier(orgId, productTier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the custom product redeems for a virtual product
     * @summary Return the custom product redeems for a virtual product
     * @param {string} orgId ID of the Organization
     * @param {string} virtualProductId ID of the virtual product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomproductredeemApi
     */
    public getCustomProductRedeem(orgId: string, virtualProductId: string, options?: AxiosRequestConfig) {
        return CustomproductredeemApiFp(this.configuration).getCustomProductRedeem(orgId, virtualProductId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the custom product redeems for all virtual products in a tier
     * @summary Get the custom product redeems for all virtual products in a tier
     * @param {string} orgId ID of the Organization
     * @param {string} productTier Product tier of virtual products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomproductredeemApi
     */
    public getCustomProductRedeemTier(orgId: string, productTier: string, options?: AxiosRequestConfig) {
        return CustomproductredeemApiFp(this.configuration).getCustomProductRedeemTier(orgId, productTier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the custom product redeems for all virtual product tiers
     * @summary Get the custom product redeems for all virtual product tiers
     * @param {string} orgId ID of the Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomproductredeemApi
     */
    public getCustomProductRedeemTiers(orgId: string, options?: AxiosRequestConfig) {
        return CustomproductredeemApiFp(this.configuration).getCustomProductRedeemTiers(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the array of custom product redeems
     * @summary Return the array of custom product redeems
     * @param {string} orgId ID of the Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomproductredeemApi
     */
    public getCustomProductRedeems(orgId: string, options?: AxiosRequestConfig) {
        return CustomproductredeemApiFp(this.configuration).getCustomProductRedeems(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the custom product redeems for a virtual product
     * @summary Update the custom product redeems for a virtual product
     * @param {string} orgId ID of the Organization
     * @param {string} virtualProductId ID of the virtual product
     * @param {CustomProductRedeemVirtualProduct} customProductRedeemVirtualProduct Mapping between virtual product and the physical keys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomproductredeemApi
     */
    public updateCustomProductRedeem(orgId: string, virtualProductId: string, customProductRedeemVirtualProduct: CustomProductRedeemVirtualProduct, options?: AxiosRequestConfig) {
        return CustomproductredeemApiFp(this.configuration).updateCustomProductRedeem(orgId, virtualProductId, customProductRedeemVirtualProduct, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the custom product redeems for all virtual products in a tier
     * @summary Update the custom product redeems for all virtual products in a tier
     * @param {string} orgId ID of the Organization
     * @param {string} productTier Product tier of virtual products
     * @param {CustomProductRedeemTier} customProductRedeemTier Mapping between the virtual product tier and the physical keys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomproductredeemApi
     */
    public updateCustomProductRedeemTier(orgId: string, productTier: string, customProductRedeemTier: CustomProductRedeemTier, options?: AxiosRequestConfig) {
        return CustomproductredeemApiFp(this.configuration).updateCustomProductRedeemTier(orgId, productTier, customProductRedeemTier, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get inventory summary for the given organization
         * @summary Get organization dashboard
         * @param {string} orgId ID of the Organization
         * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetOrganizationDashboard: async (orgId: string, shippableOnly?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('adminGetOrganizationDashboard', 'orgId', orgId)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/dashboard`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (shippableOnly !== undefined) {
                localVarQueryParameter['shippable_only'] = shippableOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * Get inventory summary for the given organization
         * @summary Get organization dashboard
         * @param {string} orgId ID of the Organization
         * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetOrganizationDashboard(orgId: string, shippableOnly?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetOrganizationDashboard(orgId, shippableOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * Get inventory summary for the given organization
         * @summary Get organization dashboard
         * @param {string} orgId ID of the Organization
         * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetOrganizationDashboard(orgId: string, shippableOnly?: boolean, options?: any): AxiosPromise<DashboardResponse> {
            return localVarFp.adminGetOrganizationDashboard(orgId, shippableOnly, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
    /**
     * Get inventory summary for the given organization
     * @summary Get organization dashboard
     * @param {string} orgId ID of the Organization
     * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public adminGetOrganizationDashboard(orgId: string, shippableOnly?: boolean, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).adminGetOrganizationDashboard(orgId, shippableOnly, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DistributorsApi - axios parameter creator
 * @export
 */
export const DistributorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the list of visibility granting from a distributor to its resellers
         * @summary Get relationships of a distributor organization as admin
         * @param {string} distributorOrganizationId distributor organization id
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDistributorRelationships: async (distributorOrganizationId: string, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'distributorOrganizationId' is not null or undefined
            assertParamExists('adminGetDistributorRelationships', 'distributorOrganizationId', distributorOrganizationId)
            const localVarPath = `/v1/serviceadmin/distributors/{distributorOrganizationId}/relationships`
                .replace(`{${"distributorOrganizationId"}}`, encodeURIComponent(String(distributorOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the list of all distributors from existing purchaseorders
         * @summary Get all distributor organizations
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDistributors: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/distributors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Grant visibility of inventory from a distributor to a reseller.
         * @summary Grant visibility of inventory from a distributor to a reseller
         * @param {string} distributorOrganizationId distributor organization id
         * @param {AdminOrgRelationshipCreateRequest} [adminOrgRelationshipCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGrantDistributorVisibilityToReseller: async (distributorOrganizationId: string, adminOrgRelationshipCreateRequest?: AdminOrgRelationshipCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'distributorOrganizationId' is not null or undefined
            assertParamExists('adminGrantDistributorVisibilityToReseller', 'distributorOrganizationId', distributorOrganizationId)
            const localVarPath = `/v1/serviceadmin/distributors/{distributorOrganizationId}/relationships`
                .replace(`{${"distributorOrganizationId"}}`, encodeURIComponent(String(distributorOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminOrgRelationshipCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke visibility of inventory from a distributor of a reseller.
         * @param {string} distributorOrganizationId distributor organization id
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRevokeDistributorVisibilityOfReseller: async (distributorOrganizationId: string, resellerOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'distributorOrganizationId' is not null or undefined
            assertParamExists('adminRevokeDistributorVisibilityOfReseller', 'distributorOrganizationId', distributorOrganizationId)
            // verify required parameter 'resellerOrganizationId' is not null or undefined
            assertParamExists('adminRevokeDistributorVisibilityOfReseller', 'resellerOrganizationId', resellerOrganizationId)
            const localVarPath = `/v1/serviceadmin/distributors/{distributorOrganizationId}/relationships/{resellerOrganizationId}`
                .replace(`{${"distributorOrganizationId"}}`, encodeURIComponent(String(distributorOrganizationId)))
                .replace(`{${"resellerOrganizationId"}}`, encodeURIComponent(String(resellerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes distributor relationships searchable fields
         * @summary Lists searchable fields
         * @param {string} distributorOrganizationId distributor organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminDistributorRelationshipsSearchDescription: async (distributorOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'distributorOrganizationId' is not null or undefined
            assertParamExists('listAdminDistributorRelationshipsSearchDescription', 'distributorOrganizationId', distributorOrganizationId)
            const localVarPath = `/v1/serviceadmin/distributors/{distributorOrganizationId}/relationships/search-description`
                .replace(`{${"distributorOrganizationId"}}`, encodeURIComponent(String(distributorOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes distributors searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminDistributorsSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/distributors/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DistributorsApi - functional programming interface
 * @export
 */
export const DistributorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DistributorsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the list of visibility granting from a distributor to its resellers
         * @summary Get relationships of a distributor organization as admin
         * @param {string} distributorOrganizationId distributor organization id
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetDistributorRelationships(distributorOrganizationId: string, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrgRelationshipsResponseSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetDistributorRelationships(distributorOrganizationId, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the list of all distributors from existing purchaseorders
         * @summary Get all distributor organizations
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetDistributors(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminHigherTierOrganizationResponseSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetDistributors(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Grant visibility of inventory from a distributor to a reseller.
         * @summary Grant visibility of inventory from a distributor to a reseller
         * @param {string} distributorOrganizationId distributor organization id
         * @param {AdminOrgRelationshipCreateRequest} [adminOrgRelationshipCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGrantDistributorVisibilityToReseller(distributorOrganizationId: string, adminOrgRelationshipCreateRequest?: AdminOrgRelationshipCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrgRelationshipsCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGrantDistributorVisibilityToReseller(distributorOrganizationId, adminOrgRelationshipCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Revoke visibility of inventory from a distributor of a reseller.
         * @param {string} distributorOrganizationId distributor organization id
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRevokeDistributorVisibilityOfReseller(distributorOrganizationId: string, resellerOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRevokeDistributorVisibilityOfReseller(distributorOrganizationId, resellerOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes distributor relationships searchable fields
         * @summary Lists searchable fields
         * @param {string} distributorOrganizationId distributor organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAdminDistributorRelationshipsSearchDescription(distributorOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAdminDistributorRelationshipsSearchDescription(distributorOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes distributors searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAdminDistributorsSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAdminDistributorsSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DistributorsApi - factory interface
 * @export
 */
export const DistributorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DistributorsApiFp(configuration)
    return {
        /**
         * Get the list of visibility granting from a distributor to its resellers
         * @summary Get relationships of a distributor organization as admin
         * @param {string} distributorOrganizationId distributor organization id
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDistributorRelationships(distributorOrganizationId: string, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<AdminOrgRelationshipsResponseSet> {
            return localVarFp.adminGetDistributorRelationships(distributorOrganizationId, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of all distributors from existing purchaseorders
         * @summary Get all distributor organizations
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDistributors(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<AdminHigherTierOrganizationResponseSet> {
            return localVarFp.adminGetDistributors(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Grant visibility of inventory from a distributor to a reseller.
         * @summary Grant visibility of inventory from a distributor to a reseller
         * @param {string} distributorOrganizationId distributor organization id
         * @param {AdminOrgRelationshipCreateRequest} [adminOrgRelationshipCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGrantDistributorVisibilityToReseller(distributorOrganizationId: string, adminOrgRelationshipCreateRequest?: AdminOrgRelationshipCreateRequest, options?: any): AxiosPromise<AdminOrgRelationshipsCreateResponse> {
            return localVarFp.adminGrantDistributorVisibilityToReseller(distributorOrganizationId, adminOrgRelationshipCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke visibility of inventory from a distributor of a reseller.
         * @param {string} distributorOrganizationId distributor organization id
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRevokeDistributorVisibilityOfReseller(distributorOrganizationId: string, resellerOrganizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminRevokeDistributorVisibilityOfReseller(distributorOrganizationId, resellerOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes distributor relationships searchable fields
         * @summary Lists searchable fields
         * @param {string} distributorOrganizationId distributor organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminDistributorRelationshipsSearchDescription(distributorOrganizationId: string, options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listAdminDistributorRelationshipsSearchDescription(distributorOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes distributors searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminDistributorsSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listAdminDistributorsSearchDescription(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DistributorsApi - object-oriented interface
 * @export
 * @class DistributorsApi
 * @extends {BaseAPI}
 */
export class DistributorsApi extends BaseAPI {
    /**
     * Get the list of visibility granting from a distributor to its resellers
     * @summary Get relationships of a distributor organization as admin
     * @param {string} distributorOrganizationId distributor organization id
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributorsApi
     */
    public adminGetDistributorRelationships(distributorOrganizationId: string, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return DistributorsApiFp(this.configuration).adminGetDistributorRelationships(distributorOrganizationId, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the list of all distributors from existing purchaseorders
     * @summary Get all distributor organizations
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributorsApi
     */
    public adminGetDistributors(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return DistributorsApiFp(this.configuration).adminGetDistributors(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Grant visibility of inventory from a distributor to a reseller.
     * @summary Grant visibility of inventory from a distributor to a reseller
     * @param {string} distributorOrganizationId distributor organization id
     * @param {AdminOrgRelationshipCreateRequest} [adminOrgRelationshipCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributorsApi
     */
    public adminGrantDistributorVisibilityToReseller(distributorOrganizationId: string, adminOrgRelationshipCreateRequest?: AdminOrgRelationshipCreateRequest, options?: AxiosRequestConfig) {
        return DistributorsApiFp(this.configuration).adminGrantDistributorVisibilityToReseller(distributorOrganizationId, adminOrgRelationshipCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke visibility of inventory from a distributor of a reseller.
     * @param {string} distributorOrganizationId distributor organization id
     * @param {string} resellerOrganizationId reseller organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributorsApi
     */
    public adminRevokeDistributorVisibilityOfReseller(distributorOrganizationId: string, resellerOrganizationId: string, options?: AxiosRequestConfig) {
        return DistributorsApiFp(this.configuration).adminRevokeDistributorVisibilityOfReseller(distributorOrganizationId, resellerOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes distributor relationships searchable fields
     * @summary Lists searchable fields
     * @param {string} distributorOrganizationId distributor organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributorsApi
     */
    public listAdminDistributorRelationshipsSearchDescription(distributorOrganizationId: string, options?: AxiosRequestConfig) {
        return DistributorsApiFp(this.configuration).listAdminDistributorRelationshipsSearchDescription(distributorOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes distributors searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributorsApi
     */
    public listAdminDistributorsSearchDescription(options?: AxiosRequestConfig) {
        return DistributorsApiFp(this.configuration).listAdminDistributorsSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FeatureTogglesApi - axios parameter creator
 * @export
 */
export const FeatureTogglesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns feature toggles with default values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultToggles: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/feature-toggles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns feature toggles for the given org
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationToggles: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getOrganizationToggles', 'orgId', orgId)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/feature-toggles`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the feature toggle defined in the \"toggleId\" param from the path and includes which organizations override that value.
         * @summary Returns a feature toggle with a list of organization overrides
         * @param {string} toggleName toggle name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToggleOverrides: async (toggleName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleName' is not null or undefined
            assertParamExists('getToggleOverrides', 'toggleName', toggleName)
            const localVarPath = `/v1/serviceadmin/feature-toggles/{toggleName}`
                .replace(`{${"toggleName"}}`, encodeURIComponent(String(toggleName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Overrides feature toggle for the given org
         * @param {string} orgId ID of the Organization
         * @param {string} toggleName toggle name
         * @param {FeatureToggleRequest} [featureToggleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideFeatureToggle: async (orgId: string, toggleName: string, featureToggleRequest?: FeatureToggleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('overrideFeatureToggle', 'orgId', orgId)
            // verify required parameter 'toggleName' is not null or undefined
            assertParamExists('overrideFeatureToggle', 'toggleName', toggleName)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/feature-toggles/{toggleName}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"toggleName"}}`, encodeURIComponent(String(toggleName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(featureToggleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Changes the default toggle value
         * @param {string} toggleName toggle name
         * @param {FeatureToggleRequest} [featureToggleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultToggle: async (toggleName: string, featureToggleRequest?: FeatureToggleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleName' is not null or undefined
            assertParamExists('updateDefaultToggle', 'toggleName', toggleName)
            const localVarPath = `/v1/serviceadmin/feature-toggles/{toggleName}`
                .replace(`{${"toggleName"}}`, encodeURIComponent(String(toggleName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(featureToggleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureTogglesApi - functional programming interface
 * @export
 */
export const FeatureTogglesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeatureTogglesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns feature toggles with default values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultToggles(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFeatureToggleCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultToggles(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns feature toggles for the given org
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationToggles(orgId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFeatureToggleCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationToggles(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the feature toggle defined in the \"toggleId\" param from the path and includes which organizations override that value.
         * @summary Returns a feature toggle with a list of organization overrides
         * @param {string} toggleName toggle name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getToggleOverrides(toggleName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureToggleOverridesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getToggleOverrides(toggleName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Overrides feature toggle for the given org
         * @param {string} orgId ID of the Organization
         * @param {string} toggleName toggle name
         * @param {FeatureToggleRequest} [featureToggleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overrideFeatureToggle(orgId: string, toggleName: string, featureToggleRequest?: FeatureToggleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureTogglePutResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overrideFeatureToggle(orgId, toggleName, featureToggleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Changes the default toggle value
         * @param {string} toggleName toggle name
         * @param {FeatureToggleRequest} [featureToggleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDefaultToggle(toggleName: string, featureToggleRequest?: FeatureToggleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureTogglePutResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDefaultToggle(toggleName, featureToggleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FeatureTogglesApi - factory interface
 * @export
 */
export const FeatureTogglesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeatureTogglesApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns feature toggles with default values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultToggles(options?: any): AxiosPromise<AdminFeatureToggleCollectionResponse> {
            return localVarFp.getDefaultToggles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns feature toggles for the given org
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationToggles(orgId: string, options?: any): AxiosPromise<AdminFeatureToggleCollectionResponse> {
            return localVarFp.getOrganizationToggles(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the feature toggle defined in the \"toggleId\" param from the path and includes which organizations override that value.
         * @summary Returns a feature toggle with a list of organization overrides
         * @param {string} toggleName toggle name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToggleOverrides(toggleName: string, options?: any): AxiosPromise<FeatureToggleOverridesResponse> {
            return localVarFp.getToggleOverrides(toggleName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Overrides feature toggle for the given org
         * @param {string} orgId ID of the Organization
         * @param {string} toggleName toggle name
         * @param {FeatureToggleRequest} [featureToggleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideFeatureToggle(orgId: string, toggleName: string, featureToggleRequest?: FeatureToggleRequest, options?: any): AxiosPromise<FeatureTogglePutResponse> {
            return localVarFp.overrideFeatureToggle(orgId, toggleName, featureToggleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Changes the default toggle value
         * @param {string} toggleName toggle name
         * @param {FeatureToggleRequest} [featureToggleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultToggle(toggleName: string, featureToggleRequest?: FeatureToggleRequest, options?: any): AxiosPromise<FeatureTogglePutResponse> {
            return localVarFp.updateDefaultToggle(toggleName, featureToggleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeatureTogglesApi - object-oriented interface
 * @export
 * @class FeatureTogglesApi
 * @extends {BaseAPI}
 */
export class FeatureTogglesApi extends BaseAPI {
    /**
     * 
     * @summary Returns feature toggles with default values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureTogglesApi
     */
    public getDefaultToggles(options?: AxiosRequestConfig) {
        return FeatureTogglesApiFp(this.configuration).getDefaultToggles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns feature toggles for the given org
     * @param {string} orgId ID of the Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureTogglesApi
     */
    public getOrganizationToggles(orgId: string, options?: AxiosRequestConfig) {
        return FeatureTogglesApiFp(this.configuration).getOrganizationToggles(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the feature toggle defined in the \"toggleId\" param from the path and includes which organizations override that value.
     * @summary Returns a feature toggle with a list of organization overrides
     * @param {string} toggleName toggle name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureTogglesApi
     */
    public getToggleOverrides(toggleName: string, options?: AxiosRequestConfig) {
        return FeatureTogglesApiFp(this.configuration).getToggleOverrides(toggleName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Overrides feature toggle for the given org
     * @param {string} orgId ID of the Organization
     * @param {string} toggleName toggle name
     * @param {FeatureToggleRequest} [featureToggleRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureTogglesApi
     */
    public overrideFeatureToggle(orgId: string, toggleName: string, featureToggleRequest?: FeatureToggleRequest, options?: AxiosRequestConfig) {
        return FeatureTogglesApiFp(this.configuration).overrideFeatureToggle(orgId, toggleName, featureToggleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Changes the default toggle value
     * @param {string} toggleName toggle name
     * @param {FeatureToggleRequest} [featureToggleRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureTogglesApi
     */
    public updateDefaultToggle(toggleName: string, featureToggleRequest?: FeatureToggleRequest, options?: AxiosRequestConfig) {
        return FeatureTogglesApiFp(this.configuration).updateDefaultToggle(toggleName, featureToggleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FinancialReportApi - axios parameter creator
 * @export
 */
export const FinancialReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The downloaded CSV contains the eu fulfillment report considering the date range according to:   - Date range from `start_date` to `end_date`: if both parameters are provided;   - Date range from year start to `end_date`: if only `end_date` is provided;   - Date range from `start_date` to current date: if only `start_date` is provided;   - Date range of the last month: if no query parameter is provided. The date range should not exceed 1 year unless an advanced filter is provided in the request. 
         * @summary Download a CSV with the EU fulfillment report
         * @param {string} [startDate] Start date (UTC timezone) to retrieve the financial report data
         * @param {string} [endDate] End date (UTC timezone) to retrieve the financial report data
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDownloadEuFulfillmentReport: async (startDate?: string, endDate?: string, advancedSearch?: boolean, search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/financial-report/eu-fulfillment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The downloaded CSV contains the financial report considering the date range according to:   - Date range from `start_date` to `end_date`: if both parameters are provided;   - Date range from year start to `end_date`: if only `end_date` is provided;   - Date range from `start_date` to current date: if only `start_date` is provided;   - Date range of the last month: if no query parameter is provided. The date range should not exceed 1 year unless an advanced filter is provided in the request. 
         * @summary Download a CSV with financial report
         * @param {string} [startDate] Start date (UTC timezone) to retrieve the financial report data
         * @param {string} [endDate] End date (UTC timezone) to retrieve the financial report data
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDownloadFinancialReport: async (startDate?: string, endDate?: string, advancedSearch?: boolean, search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/financial-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FinancialReportApi - functional programming interface
 * @export
 */
export const FinancialReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FinancialReportApiAxiosParamCreator(configuration)
    return {
        /**
         * The downloaded CSV contains the eu fulfillment report considering the date range according to:   - Date range from `start_date` to `end_date`: if both parameters are provided;   - Date range from year start to `end_date`: if only `end_date` is provided;   - Date range from `start_date` to current date: if only `start_date` is provided;   - Date range of the last month: if no query parameter is provided. The date range should not exceed 1 year unless an advanced filter is provided in the request. 
         * @summary Download a CSV with the EU fulfillment report
         * @param {string} [startDate] Start date (UTC timezone) to retrieve the financial report data
         * @param {string} [endDate] End date (UTC timezone) to retrieve the financial report data
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDownloadEuFulfillmentReport(startDate?: string, endDate?: string, advancedSearch?: boolean, search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDownloadEuFulfillmentReport(startDate, endDate, advancedSearch, search, searchField, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The downloaded CSV contains the financial report considering the date range according to:   - Date range from `start_date` to `end_date`: if both parameters are provided;   - Date range from year start to `end_date`: if only `end_date` is provided;   - Date range from `start_date` to current date: if only `start_date` is provided;   - Date range of the last month: if no query parameter is provided. The date range should not exceed 1 year unless an advanced filter is provided in the request. 
         * @summary Download a CSV with financial report
         * @param {string} [startDate] Start date (UTC timezone) to retrieve the financial report data
         * @param {string} [endDate] End date (UTC timezone) to retrieve the financial report data
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDownloadFinancialReport(startDate?: string, endDate?: string, advancedSearch?: boolean, search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDownloadFinancialReport(startDate, endDate, advancedSearch, search, searchField, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FinancialReportApi - factory interface
 * @export
 */
export const FinancialReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FinancialReportApiFp(configuration)
    return {
        /**
         * The downloaded CSV contains the eu fulfillment report considering the date range according to:   - Date range from `start_date` to `end_date`: if both parameters are provided;   - Date range from year start to `end_date`: if only `end_date` is provided;   - Date range from `start_date` to current date: if only `start_date` is provided;   - Date range of the last month: if no query parameter is provided. The date range should not exceed 1 year unless an advanced filter is provided in the request. 
         * @summary Download a CSV with the EU fulfillment report
         * @param {string} [startDate] Start date (UTC timezone) to retrieve the financial report data
         * @param {string} [endDate] End date (UTC timezone) to retrieve the financial report data
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDownloadEuFulfillmentReport(startDate?: string, endDate?: string, advancedSearch?: boolean, search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, options?: any): AxiosPromise<string> {
            return localVarFp.adminDownloadEuFulfillmentReport(startDate, endDate, advancedSearch, search, searchField, options).then((request) => request(axios, basePath));
        },
        /**
         * The downloaded CSV contains the financial report considering the date range according to:   - Date range from `start_date` to `end_date`: if both parameters are provided;   - Date range from year start to `end_date`: if only `end_date` is provided;   - Date range from `start_date` to current date: if only `start_date` is provided;   - Date range of the last month: if no query parameter is provided. The date range should not exceed 1 year unless an advanced filter is provided in the request. 
         * @summary Download a CSV with financial report
         * @param {string} [startDate] Start date (UTC timezone) to retrieve the financial report data
         * @param {string} [endDate] End date (UTC timezone) to retrieve the financial report data
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDownloadFinancialReport(startDate?: string, endDate?: string, advancedSearch?: boolean, search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, options?: any): AxiosPromise<string> {
            return localVarFp.adminDownloadFinancialReport(startDate, endDate, advancedSearch, search, searchField, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FinancialReportApi - object-oriented interface
 * @export
 * @class FinancialReportApi
 * @extends {BaseAPI}
 */
export class FinancialReportApi extends BaseAPI {
    /**
     * The downloaded CSV contains the eu fulfillment report considering the date range according to:   - Date range from `start_date` to `end_date`: if both parameters are provided;   - Date range from year start to `end_date`: if only `end_date` is provided;   - Date range from `start_date` to current date: if only `start_date` is provided;   - Date range of the last month: if no query parameter is provided. The date range should not exceed 1 year unless an advanced filter is provided in the request. 
     * @summary Download a CSV with the EU fulfillment report
     * @param {string} [startDate] Start date (UTC timezone) to retrieve the financial report data
     * @param {string} [endDate] End date (UTC timezone) to retrieve the financial report data
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialReportApi
     */
    public adminDownloadEuFulfillmentReport(startDate?: string, endDate?: string, advancedSearch?: boolean, search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, options?: AxiosRequestConfig) {
        return FinancialReportApiFp(this.configuration).adminDownloadEuFulfillmentReport(startDate, endDate, advancedSearch, search, searchField, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The downloaded CSV contains the financial report considering the date range according to:   - Date range from `start_date` to `end_date`: if both parameters are provided;   - Date range from year start to `end_date`: if only `end_date` is provided;   - Date range from `start_date` to current date: if only `start_date` is provided;   - Date range of the last month: if no query parameter is provided. The date range should not exceed 1 year unless an advanced filter is provided in the request. 
     * @summary Download a CSV with financial report
     * @param {string} [startDate] Start date (UTC timezone) to retrieve the financial report data
     * @param {string} [endDate] End date (UTC timezone) to retrieve the financial report data
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialReportApi
     */
    public adminDownloadFinancialReport(startDate?: string, endDate?: string, advancedSearch?: boolean, search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, options?: AxiosRequestConfig) {
        return FinancialReportApiFp(this.configuration).adminDownloadFinancialReport(startDate, endDate, advancedSearch, search, searchField, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FprShipmentsApi - axios parameter creator
 * @export
 */
export const FprShipmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Patch a FPR shipment\'s address
         * @param {string} shipmentId Id of shipment
         * @param {FPRShipmentAddressRequest} body A shipment address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFPRShipmentAddress: async (shipmentId: string, body: FPRShipmentAddressRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('patchFPRShipmentAddress', 'shipmentId', shipmentId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('patchFPRShipmentAddress', 'body', body)
            const localVarPath = `/v1/serviceadmin/shipments-fpr/{shipmentId}`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FprShipmentsApi - functional programming interface
 * @export
 */
export const FprShipmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FprShipmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Patch a FPR shipment\'s address
         * @param {string} shipmentId Id of shipment
         * @param {FPRShipmentAddressRequest} body A shipment address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchFPRShipmentAddress(shipmentId: string, body: FPRShipmentAddressRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponseServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchFPRShipmentAddress(shipmentId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FprShipmentsApi - factory interface
 * @export
 */
export const FprShipmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FprShipmentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Patch a FPR shipment\'s address
         * @param {string} shipmentId Id of shipment
         * @param {FPRShipmentAddressRequest} body A shipment address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFPRShipmentAddress(shipmentId: string, body: FPRShipmentAddressRequest, options?: any): AxiosPromise<ShipmentExactResponseServiceAdmin> {
            return localVarFp.patchFPRShipmentAddress(shipmentId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FprShipmentsApi - object-oriented interface
 * @export
 * @class FprShipmentsApi
 * @extends {BaseAPI}
 */
export class FprShipmentsApi extends BaseAPI {
    /**
     * 
     * @summary Patch a FPR shipment\'s address
     * @param {string} shipmentId Id of shipment
     * @param {FPRShipmentAddressRequest} body A shipment address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FprShipmentsApi
     */
    public patchFPRShipmentAddress(shipmentId: string, body: FPRShipmentAddressRequest, options?: AxiosRequestConfig) {
        return FprShipmentsApiFp(this.configuration).patchFPRShipmentAddress(shipmentId, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GrantsApi - axios parameter creator
 * @export
 */
export const GrantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve a single grant by ID, including for each product whether it\'s eligible (i.e. active & enabled for the org). 
         * @summary Get grant information
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrantInfoById: async (grantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('getGrantInfoById', 'grantId', grantId)
            const localVarPath = `/v1/serviceadmin/grants/{grantId}`
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all grants
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrants: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/grants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes grants searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGrantsSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/grants/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GrantsApi - functional programming interface
 * @export
 */
export const GrantsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GrantsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve a single grant by ID, including for each product whether it\'s eligible (i.e. active & enabled for the org). 
         * @summary Get grant information
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGrantInfoById(grantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrantDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGrantInfoById(grantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all grants
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGrants(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrantsResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGrants(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes grants searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGrantsSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGrantsSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GrantsApi - factory interface
 * @export
 */
export const GrantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GrantsApiFp(configuration)
    return {
        /**
         * Retrieve a single grant by ID, including for each product whether it\'s eligible (i.e. active & enabled for the org). 
         * @summary Get grant information
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrantInfoById(grantId: string, options?: any): AxiosPromise<GrantDetailResponse> {
            return localVarFp.getGrantInfoById(grantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all grants
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrants(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<GrantsResultSet> {
            return localVarFp.getGrants(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes grants searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGrantsSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listGrantsSearchDescription(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GrantsApi - object-oriented interface
 * @export
 * @class GrantsApi
 * @extends {BaseAPI}
 */
export class GrantsApi extends BaseAPI {
    /**
     * Retrieve a single grant by ID, including for each product whether it\'s eligible (i.e. active & enabled for the org). 
     * @summary Get grant information
     * @param {string} grantId The ID of the grant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantsApi
     */
    public getGrantInfoById(grantId: string, options?: AxiosRequestConfig) {
        return GrantsApiFp(this.configuration).getGrantInfoById(grantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all grants
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantsApi
     */
    public getGrants(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return GrantsApiFp(this.configuration).getGrants(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes grants searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantsApi
     */
    public listGrantsSearchDescription(options?: AxiosRequestConfig) {
        return GrantsApiFp(this.configuration).listGrantsSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InventoryApi - axios parameter creator
 * @export
 */
export const InventoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns products and their quantities available for the organization per channel partner
         * @summary Returns products and their quantities available for the organization per channel partner
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetInventoryOfOrganizationPerChannelPartner: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('adminGetInventoryOfOrganizationPerChannelPartner', 'orgId', orgId)
            const localVarPath = `/v1/serviceadmin/inventory/{orgId}/channelpartners`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns array of product SKUs and quantities for the organizationId and the channelpartnerId in the URL
         * @summary Returns array of SKUs and quantities available for the organization for a specific channelpartner
         * @param {string} organizationId ID of Organization to return
         * @param {number} channelpartnerId ID of the channelpartner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryOfOrganizationInURLWithChannelPartnerId: async (organizationId: string, channelpartnerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getInventoryOfOrganizationInURLWithChannelPartnerId', 'organizationId', organizationId)
            // verify required parameter 'channelpartnerId' is not null or undefined
            assertParamExists('getInventoryOfOrganizationInURLWithChannelPartnerId', 'channelpartnerId', channelpartnerId)
            const localVarPath = `/v1/serviceadmin/inventory/{organizationId}/channelpartners/{channelpartnerId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelpartnerId"}}`, encodeURIComponent(String(channelpartnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryApi - functional programming interface
 * @export
 */
export const InventoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns products and their quantities available for the organization per channel partner
         * @summary Returns products and their quantities available for the organization per channel partner
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetInventoryOfOrganizationPerChannelPartner(orgId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChannelPartnerProductInventoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetInventoryOfOrganizationPerChannelPartner(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns array of product SKUs and quantities for the organizationId and the channelpartnerId in the URL
         * @summary Returns array of SKUs and quantities available for the organization for a specific channelpartner
         * @param {string} organizationId ID of Organization to return
         * @param {number} channelpartnerId ID of the channelpartner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryOfOrganizationInURLWithChannelPartnerId(organizationId: string, channelpartnerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationProductInventorySet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryOfOrganizationInURLWithChannelPartnerId(organizationId, channelpartnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InventoryApi - factory interface
 * @export
 */
export const InventoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryApiFp(configuration)
    return {
        /**
         * Returns products and their quantities available for the organization per channel partner
         * @summary Returns products and their quantities available for the organization per channel partner
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetInventoryOfOrganizationPerChannelPartner(orgId: string, options?: any): AxiosPromise<ChannelPartnerProductInventoryResponse> {
            return localVarFp.adminGetInventoryOfOrganizationPerChannelPartner(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns array of product SKUs and quantities for the organizationId and the channelpartnerId in the URL
         * @summary Returns array of SKUs and quantities available for the organization for a specific channelpartner
         * @param {string} organizationId ID of Organization to return
         * @param {number} channelpartnerId ID of the channelpartner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryOfOrganizationInURLWithChannelPartnerId(organizationId: string, channelpartnerId: number, options?: any): AxiosPromise<OrganizationProductInventorySet> {
            return localVarFp.getInventoryOfOrganizationInURLWithChannelPartnerId(organizationId, channelpartnerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryApi - object-oriented interface
 * @export
 * @class InventoryApi
 * @extends {BaseAPI}
 */
export class InventoryApi extends BaseAPI {
    /**
     * Returns products and their quantities available for the organization per channel partner
     * @summary Returns products and their quantities available for the organization per channel partner
     * @param {string} orgId ID of the Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public adminGetInventoryOfOrganizationPerChannelPartner(orgId: string, options?: AxiosRequestConfig) {
        return InventoryApiFp(this.configuration).adminGetInventoryOfOrganizationPerChannelPartner(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns array of product SKUs and quantities for the organizationId and the channelpartnerId in the URL
     * @summary Returns array of SKUs and quantities available for the organization for a specific channelpartner
     * @param {string} organizationId ID of Organization to return
     * @param {number} channelpartnerId ID of the channelpartner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public getInventoryOfOrganizationInURLWithChannelPartnerId(organizationId: string, channelpartnerId: number, options?: AxiosRequestConfig) {
        return InventoryApiFp(this.configuration).getInventoryOfOrganizationInURLWithChannelPartnerId(organizationId, channelpartnerId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InventoryAllocationApi - axios parameter creator
 * @export
 */
export const InventoryAllocationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Creates an inventory allocation
         * @param {AdminCreateInventoryAllocationRequest} adminCreateInventoryAllocationRequest Inventory allocation object that needs to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateInventoryAllocation: async (adminCreateInventoryAllocationRequest: AdminCreateInventoryAllocationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminCreateInventoryAllocationRequest' is not null or undefined
            assertParamExists('adminCreateInventoryAllocation', 'adminCreateInventoryAllocationRequest', adminCreateInventoryAllocationRequest)
            const localVarPath = `/v1/serviceadmin/inventory-allocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateInventoryAllocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download a CSV of all inventory allocation
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {boolean} [includeDeleted] include deleted, no longer applicable allocations in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDownloadInventoryAllocations: async (sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, includeDeleted?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/inventory-allocations/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['include_deleted'] = includeDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all inventory allocation
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {boolean} [includeDeleted] include deleted, no longer applicable allocations in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetInventoryAllocations: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, includeDeleted?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/inventory-allocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['include_deleted'] = includeDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes users searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListInventoryAllocationSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/inventory-allocations/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists inventory allocation history for a given product in the org context
         * @summary Lists inventory allocation history for a given product in the org context
         * @param {string} orgId ID of the Organization
         * @param {string} productId Id of Product
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListProductInventoryAllocationHistory: async (orgId: string, productId: string, offset?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('adminListProductInventoryAllocationHistory', 'orgId', orgId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('adminListProductInventoryAllocationHistory', 'productId', productId)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/products/{productId}/inventory-allocation-history`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryAllocationApi - functional programming interface
 * @export
 */
export const InventoryAllocationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryAllocationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Creates an inventory allocation
         * @param {AdminCreateInventoryAllocationRequest} adminCreateInventoryAllocationRequest Inventory allocation object that needs to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateInventoryAllocation(adminCreateInventoryAllocationRequest: AdminCreateInventoryAllocationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInventoryAllocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateInventoryAllocation(adminCreateInventoryAllocationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download a CSV of all inventory allocation
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {boolean} [includeDeleted] include deleted, no longer applicable allocations in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDownloadInventoryAllocations(sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, includeDeleted?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDownloadInventoryAllocations(sortBy, sortDirection, search, searchField, advancedSearch, includeDeleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all inventory allocation
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {boolean} [includeDeleted] include deleted, no longer applicable allocations in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetInventoryAllocations(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, includeDeleted?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInventoryAllocationCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetInventoryAllocations(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, includeDeleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes users searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListInventoryAllocationSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListInventoryAllocationSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Lists inventory allocation history for a given product in the org context
         * @summary Lists inventory allocation history for a given product in the org context
         * @param {string} orgId ID of the Organization
         * @param {string} productId Id of Product
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListProductInventoryAllocationHistory(orgId: string, productId: string, offset?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInventoryAllocationHistoryCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListProductInventoryAllocationHistory(orgId, productId, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InventoryAllocationApi - factory interface
 * @export
 */
export const InventoryAllocationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryAllocationApiFp(configuration)
    return {
        /**
         * 
         * @summary Creates an inventory allocation
         * @param {AdminCreateInventoryAllocationRequest} adminCreateInventoryAllocationRequest Inventory allocation object that needs to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateInventoryAllocation(adminCreateInventoryAllocationRequest: AdminCreateInventoryAllocationRequest, options?: any): AxiosPromise<AdminInventoryAllocationResponse> {
            return localVarFp.adminCreateInventoryAllocation(adminCreateInventoryAllocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download a CSV of all inventory allocation
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {boolean} [includeDeleted] include deleted, no longer applicable allocations in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDownloadInventoryAllocations(sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, includeDeleted?: boolean, options?: any): AxiosPromise<string> {
            return localVarFp.adminDownloadInventoryAllocations(sortBy, sortDirection, search, searchField, advancedSearch, includeDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all inventory allocation
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {boolean} [includeDeleted] include deleted, no longer applicable allocations in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetInventoryAllocations(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, includeDeleted?: boolean, options?: any): AxiosPromise<AdminInventoryAllocationCollectionResponse> {
            return localVarFp.adminGetInventoryAllocations(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, includeDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes users searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListInventoryAllocationSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.adminListInventoryAllocationSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * Lists inventory allocation history for a given product in the org context
         * @summary Lists inventory allocation history for a given product in the org context
         * @param {string} orgId ID of the Organization
         * @param {string} productId Id of Product
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListProductInventoryAllocationHistory(orgId: string, productId: string, offset?: number, limit?: number, options?: any): AxiosPromise<AdminInventoryAllocationHistoryCollectionResponse> {
            return localVarFp.adminListProductInventoryAllocationHistory(orgId, productId, offset, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryAllocationApi - object-oriented interface
 * @export
 * @class InventoryAllocationApi
 * @extends {BaseAPI}
 */
export class InventoryAllocationApi extends BaseAPI {
    /**
     * 
     * @summary Creates an inventory allocation
     * @param {AdminCreateInventoryAllocationRequest} adminCreateInventoryAllocationRequest Inventory allocation object that needs to be added
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryAllocationApi
     */
    public adminCreateInventoryAllocation(adminCreateInventoryAllocationRequest: AdminCreateInventoryAllocationRequest, options?: AxiosRequestConfig) {
        return InventoryAllocationApiFp(this.configuration).adminCreateInventoryAllocation(adminCreateInventoryAllocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download a CSV of all inventory allocation
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {boolean} [includeDeleted] include deleted, no longer applicable allocations in the response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryAllocationApi
     */
    public adminDownloadInventoryAllocations(sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, includeDeleted?: boolean, options?: AxiosRequestConfig) {
        return InventoryAllocationApiFp(this.configuration).adminDownloadInventoryAllocations(sortBy, sortDirection, search, searchField, advancedSearch, includeDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all inventory allocation
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {boolean} [includeDeleted] include deleted, no longer applicable allocations in the response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryAllocationApi
     */
    public adminGetInventoryAllocations(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, includeDeleted?: boolean, options?: AxiosRequestConfig) {
        return InventoryAllocationApiFp(this.configuration).adminGetInventoryAllocations(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, includeDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes users searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryAllocationApi
     */
    public adminListInventoryAllocationSearchDescription(options?: AxiosRequestConfig) {
        return InventoryAllocationApiFp(this.configuration).adminListInventoryAllocationSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists inventory allocation history for a given product in the org context
     * @summary Lists inventory allocation history for a given product in the org context
     * @param {string} orgId ID of the Organization
     * @param {string} productId Id of Product
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryAllocationApi
     */
    public adminListProductInventoryAllocationHistory(orgId: string, productId: string, offset?: number, limit?: number, options?: AxiosRequestConfig) {
        return InventoryAllocationApiFp(this.configuration).adminListProductInventoryAllocationHistory(orgId, productId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ItemsApi - axios parameter creator
 * @export
 */
export const ItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve an item by its netsuite id
         * @summary Retrieve an item by its netsuite id
         * @param {string} netsuiteId the netsuiteId to filter by
         * @param {boolean} [custom] Flag stating if the item should be a custom shippable item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemByNetsuiteID: async (netsuiteId: string, custom?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'netsuiteId' is not null or undefined
            assertParamExists('getItemByNetsuiteID', 'netsuiteId', netsuiteId)
            const localVarPath = `/v1/serviceadmin/items/{netsuiteId}`
                .replace(`{${"netsuiteId"}}`, encodeURIComponent(String(netsuiteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (custom !== undefined) {
                localVarQueryParameter['custom'] = custom;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ItemsApi - functional programming interface
 * @export
 */
export const ItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve an item by its netsuite id
         * @summary Retrieve an item by its netsuite id
         * @param {string} netsuiteId the netsuiteId to filter by
         * @param {boolean} [custom] Flag stating if the item should be a custom shippable item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemByNetsuiteID(netsuiteId: string, custom?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Item>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemByNetsuiteID(netsuiteId, custom, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ItemsApi - factory interface
 * @export
 */
export const ItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ItemsApiFp(configuration)
    return {
        /**
         * Retrieve an item by its netsuite id
         * @summary Retrieve an item by its netsuite id
         * @param {string} netsuiteId the netsuiteId to filter by
         * @param {boolean} [custom] Flag stating if the item should be a custom shippable item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemByNetsuiteID(netsuiteId: string, custom?: boolean, options?: any): AxiosPromise<Item> {
            return localVarFp.getItemByNetsuiteID(netsuiteId, custom, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ItemsApi - object-oriented interface
 * @export
 * @class ItemsApi
 * @extends {BaseAPI}
 */
export class ItemsApi extends BaseAPI {
    /**
     * Retrieve an item by its netsuite id
     * @summary Retrieve an item by its netsuite id
     * @param {string} netsuiteId the netsuiteId to filter by
     * @param {boolean} [custom] Flag stating if the item should be a custom shippable item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemsApi
     */
    public getItemByNetsuiteID(netsuiteId: string, custom?: boolean, options?: AxiosRequestConfig) {
        return ItemsApiFp(this.configuration).getItemByNetsuiteID(netsuiteId, custom, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MachineTokenApi - axios parameter creator
 * @export
 */
export const MachineTokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get an array of valid machine tokens
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMachineTokens: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/machine-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes machine tokens searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMachineTokensSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/machine-tokens/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MachineTokenApi - functional programming interface
 * @export
 */
export const MachineTokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MachineTokenApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get an array of valid machine tokens
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMachineTokens(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MachineTokenResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMachineTokens(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes machine tokens searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMachineTokensSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMachineTokensSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MachineTokenApi - factory interface
 * @export
 */
export const MachineTokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MachineTokenApiFp(configuration)
    return {
        /**
         * 
         * @summary Get an array of valid machine tokens
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMachineTokens(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<MachineTokenResultSet> {
            return localVarFp.getMachineTokens(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes machine tokens searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMachineTokensSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listMachineTokensSearchDescription(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MachineTokenApi - object-oriented interface
 * @export
 * @class MachineTokenApi
 * @extends {BaseAPI}
 */
export class MachineTokenApi extends BaseAPI {
    /**
     * 
     * @summary Get an array of valid machine tokens
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineTokenApi
     */
    public getMachineTokens(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return MachineTokenApiFp(this.configuration).getMachineTokens(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes machine tokens searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineTokenApi
     */
    public listMachineTokensSearchDescription(options?: AxiosRequestConfig) {
        return MachineTokenApiFp(this.configuration).listMachineTokensSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MachineTokensApi - axios parameter creator
 * @export
 */
export const MachineTokensApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns CSV containing all tokens expiring in next 30 days and related info
         * @summary Get all machine tokens expiring in the next 30 days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMachineTokensExpiringInTheNext30Days: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/machine-tokens/expiring`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MachineTokensApi - functional programming interface
 * @export
 */
export const MachineTokensApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MachineTokensApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns CSV containing all tokens expiring in next 30 days and related info
         * @summary Get all machine tokens expiring in the next 30 days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMachineTokensExpiringInTheNext30Days(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMachineTokensExpiringInTheNext30Days(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MachineTokensApi - factory interface
 * @export
 */
export const MachineTokensApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MachineTokensApiFp(configuration)
    return {
        /**
         * Returns CSV containing all tokens expiring in next 30 days and related info
         * @summary Get all machine tokens expiring in the next 30 days
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMachineTokensExpiringInTheNext30Days(options?: any): AxiosPromise<string> {
            return localVarFp.getAllMachineTokensExpiringInTheNext30Days(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MachineTokensApi - object-oriented interface
 * @export
 * @class MachineTokensApi
 * @extends {BaseAPI}
 */
export class MachineTokensApi extends BaseAPI {
    /**
     * Returns CSV containing all tokens expiring in next 30 days and related info
     * @summary Get all machine tokens expiring in the next 30 days
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineTokensApi
     */
    public getAllMachineTokensExpiringInTheNext30Days(options?: AxiosRequestConfig) {
        return MachineTokensApiFp(this.configuration).getAllMachineTokensExpiringInTheNext30Days(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ManualShipmentsApi - axios parameter creator
 * @export
 */
export const ManualShipmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a manual shipment
         * @param {ManualShipmentRequest} body A manual shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManualShipment: async (body: ManualShipmentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createManualShipment', 'body', body)
            const localVarPath = `/v1/serviceadmin/shipments-manual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a manual shipment
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManualShipmentById: async (shipmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('deleteManualShipmentById', 'shipmentId', shipmentId)
            const localVarPath = `/v1/serviceadmin/shipments-manual/{shipmentId}`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patch a manual shipment\'s address
         * @param {string} shipmentId Id of shipment
         * @param {ShipmentUpdateAddressRequest} body A shipment address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchManualShipmentAddress: async (shipmentId: string, body: ShipmentUpdateAddressRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('patchManualShipmentAddress', 'shipmentId', shipmentId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('patchManualShipmentAddress', 'body', body)
            const localVarPath = `/v1/serviceadmin/shipments-manual/{shipmentId}/address`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transition the state of a manual shipment
         * @summary Override shipment state on manual shipment
         * @param {string} shipmentId Id of shipment
         * @param {ManualShipmentDeliveryUpdateRequest} [manualShipmentDeliveryUpdateRequest] State ID to transition to and comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stateOverrideManual: async (shipmentId: string, manualShipmentDeliveryUpdateRequest?: ManualShipmentDeliveryUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('stateOverrideManual', 'shipmentId', shipmentId)
            const localVarPath = `/v1/serviceadmin/shipments-manual/{shipmentId}/state-override`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(manualShipmentDeliveryUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the delivery details of a manual shipment
         * @param {string} shipmentId Id of shipment
         * @param {ManualShipmentDeliveryUpdateRequest} [manualShipmentDeliveryUpdateRequest] State ID to transition to and comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateManualShipmentDeliveryDetails: async (shipmentId: string, manualShipmentDeliveryUpdateRequest?: ManualShipmentDeliveryUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('updateManualShipmentDeliveryDetails', 'shipmentId', shipmentId)
            const localVarPath = `/v1/serviceadmin/shipments-manual/{shipmentId}/delivery`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(manualShipmentDeliveryUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManualShipmentsApi - functional programming interface
 * @export
 */
export const ManualShipmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ManualShipmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a manual shipment
         * @param {ManualShipmentRequest} body A manual shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManualShipment(body: ManualShipmentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponseServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManualShipment(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a manual shipment
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteManualShipmentById(shipmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteManualShipmentById(shipmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Patch a manual shipment\'s address
         * @param {string} shipmentId Id of shipment
         * @param {ShipmentUpdateAddressRequest} body A shipment address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchManualShipmentAddress(shipmentId: string, body: ShipmentUpdateAddressRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponseServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchManualShipmentAddress(shipmentId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Transition the state of a manual shipment
         * @summary Override shipment state on manual shipment
         * @param {string} shipmentId Id of shipment
         * @param {ManualShipmentDeliveryUpdateRequest} [manualShipmentDeliveryUpdateRequest] State ID to transition to and comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stateOverrideManual(shipmentId: string, manualShipmentDeliveryUpdateRequest?: ManualShipmentDeliveryUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponseServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stateOverrideManual(shipmentId, manualShipmentDeliveryUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update the delivery details of a manual shipment
         * @param {string} shipmentId Id of shipment
         * @param {ManualShipmentDeliveryUpdateRequest} [manualShipmentDeliveryUpdateRequest] State ID to transition to and comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateManualShipmentDeliveryDetails(shipmentId: string, manualShipmentDeliveryUpdateRequest?: ManualShipmentDeliveryUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponseServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateManualShipmentDeliveryDetails(shipmentId, manualShipmentDeliveryUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ManualShipmentsApi - factory interface
 * @export
 */
export const ManualShipmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ManualShipmentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a manual shipment
         * @param {ManualShipmentRequest} body A manual shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManualShipment(body: ManualShipmentRequest, options?: any): AxiosPromise<ShipmentExactResponseServiceAdmin> {
            return localVarFp.createManualShipment(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a manual shipment
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManualShipmentById(shipmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteManualShipmentById(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patch a manual shipment\'s address
         * @param {string} shipmentId Id of shipment
         * @param {ShipmentUpdateAddressRequest} body A shipment address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchManualShipmentAddress(shipmentId: string, body: ShipmentUpdateAddressRequest, options?: any): AxiosPromise<ShipmentExactResponseServiceAdmin> {
            return localVarFp.patchManualShipmentAddress(shipmentId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Transition the state of a manual shipment
         * @summary Override shipment state on manual shipment
         * @param {string} shipmentId Id of shipment
         * @param {ManualShipmentDeliveryUpdateRequest} [manualShipmentDeliveryUpdateRequest] State ID to transition to and comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stateOverrideManual(shipmentId: string, manualShipmentDeliveryUpdateRequest?: ManualShipmentDeliveryUpdateRequest, options?: any): AxiosPromise<ShipmentExactResponseServiceAdmin> {
            return localVarFp.stateOverrideManual(shipmentId, manualShipmentDeliveryUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the delivery details of a manual shipment
         * @param {string} shipmentId Id of shipment
         * @param {ManualShipmentDeliveryUpdateRequest} [manualShipmentDeliveryUpdateRequest] State ID to transition to and comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateManualShipmentDeliveryDetails(shipmentId: string, manualShipmentDeliveryUpdateRequest?: ManualShipmentDeliveryUpdateRequest, options?: any): AxiosPromise<ShipmentExactResponseServiceAdmin> {
            return localVarFp.updateManualShipmentDeliveryDetails(shipmentId, manualShipmentDeliveryUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ManualShipmentsApi - object-oriented interface
 * @export
 * @class ManualShipmentsApi
 * @extends {BaseAPI}
 */
export class ManualShipmentsApi extends BaseAPI {
    /**
     * 
     * @summary Create a manual shipment
     * @param {ManualShipmentRequest} body A manual shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualShipmentsApi
     */
    public createManualShipment(body: ManualShipmentRequest, options?: AxiosRequestConfig) {
        return ManualShipmentsApiFp(this.configuration).createManualShipment(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a manual shipment
     * @param {string} shipmentId Id of shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualShipmentsApi
     */
    public deleteManualShipmentById(shipmentId: string, options?: AxiosRequestConfig) {
        return ManualShipmentsApiFp(this.configuration).deleteManualShipmentById(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patch a manual shipment\'s address
     * @param {string} shipmentId Id of shipment
     * @param {ShipmentUpdateAddressRequest} body A shipment address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualShipmentsApi
     */
    public patchManualShipmentAddress(shipmentId: string, body: ShipmentUpdateAddressRequest, options?: AxiosRequestConfig) {
        return ManualShipmentsApiFp(this.configuration).patchManualShipmentAddress(shipmentId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transition the state of a manual shipment
     * @summary Override shipment state on manual shipment
     * @param {string} shipmentId Id of shipment
     * @param {ManualShipmentDeliveryUpdateRequest} [manualShipmentDeliveryUpdateRequest] State ID to transition to and comment for override
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualShipmentsApi
     */
    public stateOverrideManual(shipmentId: string, manualShipmentDeliveryUpdateRequest?: ManualShipmentDeliveryUpdateRequest, options?: AxiosRequestConfig) {
        return ManualShipmentsApiFp(this.configuration).stateOverrideManual(shipmentId, manualShipmentDeliveryUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the delivery details of a manual shipment
     * @param {string} shipmentId Id of shipment
     * @param {ManualShipmentDeliveryUpdateRequest} [manualShipmentDeliveryUpdateRequest] State ID to transition to and comment for override
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualShipmentsApi
     */
    public updateManualShipmentDeliveryDetails(shipmentId: string, manualShipmentDeliveryUpdateRequest?: ManualShipmentDeliveryUpdateRequest, options?: AxiosRequestConfig) {
        return ManualShipmentsApiFp(this.configuration).updateManualShipmentDeliveryDetails(shipmentId, manualShipmentDeliveryUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NetsuiteApi - axios parameter creator
 * @export
 */
export const NetsuiteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get netsuite record
         * @param {RecordTypeEnum} recordType Record type name
         * @param {number} netsuiteId ID of the netsuite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetsuiteRecord: async (recordType: RecordTypeEnum, netsuiteId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordType' is not null or undefined
            assertParamExists('getNetsuiteRecord', 'recordType', recordType)
            // verify required parameter 'netsuiteId' is not null or undefined
            assertParamExists('getNetsuiteRecord', 'netsuiteId', netsuiteId)
            const localVarPath = `/v1/serviceadmin/netsuite/{recordType}/{netsuiteId}`
                .replace(`{${"recordType"}}`, encodeURIComponent(String(recordType)))
                .replace(`{${"netsuiteId"}}`, encodeURIComponent(String(netsuiteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NetsuiteApi - functional programming interface
 * @export
 */
export const NetsuiteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NetsuiteApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get netsuite record
         * @param {RecordTypeEnum} recordType Record type name
         * @param {number} netsuiteId ID of the netsuite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNetsuiteRecord(recordType: RecordTypeEnum, netsuiteId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNetsuiteRecord200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNetsuiteRecord(recordType, netsuiteId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NetsuiteApi - factory interface
 * @export
 */
export const NetsuiteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NetsuiteApiFp(configuration)
    return {
        /**
         * 
         * @summary Get netsuite record
         * @param {RecordTypeEnum} recordType Record type name
         * @param {number} netsuiteId ID of the netsuite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetsuiteRecord(recordType: RecordTypeEnum, netsuiteId: number, options?: any): AxiosPromise<GetNetsuiteRecord200Response> {
            return localVarFp.getNetsuiteRecord(recordType, netsuiteId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NetsuiteApi - object-oriented interface
 * @export
 * @class NetsuiteApi
 * @extends {BaseAPI}
 */
export class NetsuiteApi extends BaseAPI {
    /**
     * 
     * @summary Get netsuite record
     * @param {RecordTypeEnum} recordType Record type name
     * @param {number} netsuiteId ID of the netsuite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetsuiteApi
     */
    public getNetsuiteRecord(recordType: RecordTypeEnum, netsuiteId: number, options?: AxiosRequestConfig) {
        return NetsuiteApiFp(this.configuration).getNetsuiteRecord(recordType, netsuiteId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch a paginated list of notifications for the current user
         * @summary Fetches notifications
         * @param {NotificationView} [view] Which types of notifications to return
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (view?: NotificationView, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (view !== undefined) {
                localVarQueryParameter['view'] = view;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A map of notifications to what action should be performed
         * @summary Perform an action on a set of notifications
         * @param {NotificationActionRequest} [notificationActionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performActionOnNotifications: async (notificationActionRequest?: NotificationActionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch a paginated list of notifications for the current user
         * @summary Fetches notifications
         * @param {NotificationView} [view] Which types of notifications to return
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(view?: NotificationView, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(view, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * A map of notifications to what action should be performed
         * @summary Perform an action on a set of notifications
         * @param {NotificationActionRequest} [notificationActionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async performActionOnNotifications(notificationActionRequest?: NotificationActionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.performActionOnNotifications(notificationActionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * Fetch a paginated list of notifications for the current user
         * @summary Fetches notifications
         * @param {NotificationView} [view] Which types of notifications to return
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(view?: NotificationView, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<NotificationResultSet> {
            return localVarFp.getNotifications(view, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * A map of notifications to what action should be performed
         * @summary Perform an action on a set of notifications
         * @param {NotificationActionRequest} [notificationActionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performActionOnNotifications(notificationActionRequest?: NotificationActionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.performActionOnNotifications(notificationActionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * Fetch a paginated list of notifications for the current user
     * @summary Fetches notifications
     * @param {NotificationView} [view] Which types of notifications to return
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getNotifications(view?: NotificationView, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotifications(view, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A map of notifications to what action should be performed
     * @summary Perform an action on a set of notifications
     * @param {NotificationActionRequest} [notificationActionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public performActionOnNotifications(notificationActionRequest?: NotificationActionRequest, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).performActionOnNotifications(notificationActionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationsApi - axios parameter creator
 * @export
 */
export const OrganizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new organization to system
         * @param {OrganizationCreateParams} body Organization object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganization: async (body: OrganizationCreateParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addOrganization', 'body', body)
            const localVarPath = `/v1/serviceadmin/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a product to an organization
         * @param {string} orgId ID of the Organization
         * @param {OrganizationProductRequest} body Product IDs to be added to the list of known products for the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationProduct: async (orgId: string, body: OrganizationProductRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('addOrganizationProduct', 'orgId', orgId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addOrganizationProduct', 'body', body)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/products`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds a user to an organization
         * @param {string} orgId ID of the Organization
         * @param {InviteUserParams} body User to be invited. Roles[] is a new, experimental field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserToOrganization: async (orgId: string, body: InviteUserParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('addUserToOrganization', 'orgId', orgId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addUserToOrganization', 'body', body)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/users`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the channel partners for an organization
         * @summary Get all channel partners for an organization
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAllChannelPartnersForOrg: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('adminGetAllChannelPartnersForOrg', 'orgId', orgId)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/channelpartners`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the passkey compliance level for an organization
         * @summary Get passkey compliance level for an organization
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetOrganizationPasskeyComplianceLevel: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('adminGetOrganizationPasskeyComplianceLevel', 'orgId', orgId)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/passkey-compliance-level`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes an organization_product record, which controls whether an organization knows about a product
         * @param {string} orgId ID of the Organization
         * @param {string} productId Id of the Product that we want to remove from the set that Organization knows about.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationProduct: async (orgId: string, productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('deleteOrganizationProduct', 'orgId', orgId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('deleteOrganizationProduct', 'productId', productId)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/products/{productId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Match org by name, and returns an array of them.
         * @summary Finds organization, and returns an array of them
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrganizations: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a single organization
         * @summary Get an organization by its ID
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationById: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getOrganizationById', 'orgId', orgId)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set of all country permissions for an organization
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCountries: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getOrganizationCountries', 'orgId', orgId)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/countries`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns product information if an organization has access to the product
         * @summary Find a product by ID
         * @param {string} orgId ID of the Organization
         * @param {string} productId Id of the Product that we are checking if Organization has access to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationProduct: async (orgId: string, productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getOrganizationProduct', 'orgId', orgId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getOrganizationProduct', 'productId', productId)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/products/{productId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of products that an organization has access to.
         * @summary Get the list of products for an org
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationProducts: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getOrganizationProducts', 'orgId', orgId)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/products`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all purchase orders and purchase order products of an organization
         * @summary Get all purchase orders of an organization
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationPurchaseorders: async (orgId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getOrganizationPurchaseorders', 'orgId', orgId)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/purchaseorders`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a key value map of all organizations as \"organization_id\":\"organization_name\"
         * @summary Get all organizations as a map of org_id:org_name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllOrganizations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/organizations/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes organizations searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationsSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/organizations/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an organization by its ID
         * @param {string} orgId ID of the Organization
         * @param {OrganizationUpdateParams} organizationUpdateParams Organization object that needs to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationById: async (orgId: string, organizationUpdateParams: OrganizationUpdateParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updateOrganizationById', 'orgId', orgId)
            // verify required parameter 'organizationUpdateParams' is not null or undefined
            assertParamExists('updateOrganizationById', 'organizationUpdateParams', organizationUpdateParams)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationUpdateParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace enabled countries for an organization
         * @param {string} orgId ID of the Organization
         * @param {OrganizationCountryRequestBulk} body Country IDs of all countries to be enabled for the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationCountries: async (orgId: string, body: OrganizationCountryRequestBulk, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updateOrganizationCountries', 'orgId', orgId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateOrganizationCountries', 'body', body)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/countries`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace enabled standard products for an organization
         * @param {string} orgId ID of the Organization
         * @param {OrganizationProductRequest} body Product IDs of all standard products to be enabled for the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationProduct: async (orgId: string, body: OrganizationProductRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updateOrganizationProduct', 'orgId', orgId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateOrganizationProduct', 'body', body)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/products`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationsApi - functional programming interface
 * @export
 */
export const OrganizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a new organization to system
         * @param {OrganizationCreateParams} body Organization object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrganization(body: OrganizationCreateParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrganization(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add a product to an organization
         * @param {string} orgId ID of the Organization
         * @param {OrganizationProductRequest} body Product IDs to be added to the list of known products for the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrganizationProduct(orgId: string, body: OrganizationProductRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationProductResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrganizationProduct(orgId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Adds a user to an organization
         * @param {string} orgId ID of the Organization
         * @param {InviteUserParams} body User to be invited. Roles[] is a new, experimental field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUserToOrganization(orgId: string, body: InviteUserParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUserToOrganization(orgId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the channel partners for an organization
         * @summary Get all channel partners for an organization
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetAllChannelPartnersForOrg(orgId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChannelPartnerResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetAllChannelPartnersForOrg(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the passkey compliance level for an organization
         * @summary Get passkey compliance level for an organization
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetOrganizationPasskeyComplianceLevel(orgId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasskeyComplianceLevel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetOrganizationPasskeyComplianceLevel(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes an organization_product record, which controls whether an organization knows about a product
         * @param {string} orgId ID of the Organization
         * @param {string} productId Id of the Product that we want to remove from the set that Organization knows about.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganizationProduct(orgId: string, productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganizationProduct(orgId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Match org by name, and returns an array of them.
         * @summary Finds organization, and returns an array of them
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllOrganizations(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationsResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllOrganizations(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a single organization
         * @summary Get an organization by its ID
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationById(orgId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationById(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set of all country permissions for an organization
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationCountries(orgId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationCountryResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationCountries(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns product information if an organization has access to the product
         * @summary Find a product by ID
         * @param {string} orgId ID of the Organization
         * @param {string} productId Id of the Product that we are checking if Organization has access to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationProduct(orgId: string, productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationProductResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationProduct(orgId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of products that an organization has access to.
         * @summary Get the list of products for an org
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationProducts(orgId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationProductResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationProducts(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all purchase orders and purchase order products of an organization
         * @summary Get all purchase orders of an organization
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationPurchaseorders(orgId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationPurchaseordersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationPurchaseorders(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a key value map of all organizations as \"organization_id\":\"organization_name\"
         * @summary Get all organizations as a map of org_id:org_name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllOrganizations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: OrgNameAndNetsuiteID; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAllOrganizations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes organizations searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrganizationsSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrganizationsSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an organization by its ID
         * @param {string} orgId ID of the Organization
         * @param {OrganizationUpdateParams} organizationUpdateParams Organization object that needs to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationById(orgId: string, organizationUpdateParams: OrganizationUpdateParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationById(orgId, organizationUpdateParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace enabled countries for an organization
         * @param {string} orgId ID of the Organization
         * @param {OrganizationCountryRequestBulk} body Country IDs of all countries to be enabled for the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationCountries(orgId: string, body: OrganizationCountryRequestBulk, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationCountryResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationCountries(orgId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace enabled standard products for an organization
         * @param {string} orgId ID of the Organization
         * @param {OrganizationProductRequest} body Product IDs of all standard products to be enabled for the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationProduct(orgId: string, body: OrganizationProductRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationProductResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationProduct(orgId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationsApi - factory interface
 * @export
 */
export const OrganizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a new organization to system
         * @param {OrganizationCreateParams} body Organization object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganization(body: OrganizationCreateParams, options?: any): AxiosPromise<Organization> {
            return localVarFp.addOrganization(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a product to an organization
         * @param {string} orgId ID of the Organization
         * @param {OrganizationProductRequest} body Product IDs to be added to the list of known products for the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationProduct(orgId: string, body: OrganizationProductRequest, options?: any): AxiosPromise<OrganizationProductResultSet> {
            return localVarFp.addOrganizationProduct(orgId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds a user to an organization
         * @param {string} orgId ID of the Organization
         * @param {InviteUserParams} body User to be invited. Roles[] is a new, experimental field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserToOrganization(orgId: string, body: InviteUserParams, options?: any): AxiosPromise<boolean> {
            return localVarFp.addUserToOrganization(orgId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the channel partners for an organization
         * @summary Get all channel partners for an organization
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAllChannelPartnersForOrg(orgId: string, options?: any): AxiosPromise<ChannelPartnerResultSet> {
            return localVarFp.adminGetAllChannelPartnersForOrg(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the passkey compliance level for an organization
         * @summary Get passkey compliance level for an organization
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetOrganizationPasskeyComplianceLevel(orgId: string, options?: any): AxiosPromise<PasskeyComplianceLevel> {
            return localVarFp.adminGetOrganizationPasskeyComplianceLevel(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes an organization_product record, which controls whether an organization knows about a product
         * @param {string} orgId ID of the Organization
         * @param {string} productId Id of the Product that we want to remove from the set that Organization knows about.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationProduct(orgId: string, productId: string, options?: any): AxiosPromise<APIResponse> {
            return localVarFp.deleteOrganizationProduct(orgId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Match org by name, and returns an array of them.
         * @summary Finds organization, and returns an array of them
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrganizations(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<OrganizationsResultSet> {
            return localVarFp.getAllOrganizations(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a single organization
         * @summary Get an organization by its ID
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationById(orgId: string, options?: any): AxiosPromise<Organization> {
            return localVarFp.getOrganizationById(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set of all country permissions for an organization
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCountries(orgId: string, options?: any): AxiosPromise<OrganizationCountryResultSet> {
            return localVarFp.getOrganizationCountries(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns product information if an organization has access to the product
         * @summary Find a product by ID
         * @param {string} orgId ID of the Organization
         * @param {string} productId Id of the Product that we are checking if Organization has access to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationProduct(orgId: string, productId: string, options?: any): AxiosPromise<OrganizationProductResult> {
            return localVarFp.getOrganizationProduct(orgId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of products that an organization has access to.
         * @summary Get the list of products for an org
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationProducts(orgId: string, options?: any): AxiosPromise<OrganizationProductResultSet> {
            return localVarFp.getOrganizationProducts(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all purchase orders and purchase order products of an organization
         * @summary Get all purchase orders of an organization
         * @param {string} orgId ID of the Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationPurchaseorders(orgId: string, options?: any): AxiosPromise<AdminOrganizationPurchaseordersResponse> {
            return localVarFp.getOrganizationPurchaseorders(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a key value map of all organizations as \"organization_id\":\"organization_name\"
         * @summary Get all organizations as a map of org_id:org_name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllOrganizations(options?: any): AxiosPromise<{ [key: string]: OrgNameAndNetsuiteID; }> {
            return localVarFp.listAllOrganizations(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes organizations searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationsSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listOrganizationsSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an organization by its ID
         * @param {string} orgId ID of the Organization
         * @param {OrganizationUpdateParams} organizationUpdateParams Organization object that needs to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationById(orgId: string, organizationUpdateParams: OrganizationUpdateParams, options?: any): AxiosPromise<APIResponse> {
            return localVarFp.updateOrganizationById(orgId, organizationUpdateParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace enabled countries for an organization
         * @param {string} orgId ID of the Organization
         * @param {OrganizationCountryRequestBulk} body Country IDs of all countries to be enabled for the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationCountries(orgId: string, body: OrganizationCountryRequestBulk, options?: any): AxiosPromise<OrganizationCountryResultSet> {
            return localVarFp.updateOrganizationCountries(orgId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace enabled standard products for an organization
         * @param {string} orgId ID of the Organization
         * @param {OrganizationProductRequest} body Product IDs of all standard products to be enabled for the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationProduct(orgId: string, body: OrganizationProductRequest, options?: any): AxiosPromise<OrganizationProductResultSet> {
            return localVarFp.updateOrganizationProduct(orgId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationsApi - object-oriented interface
 * @export
 * @class OrganizationsApi
 * @extends {BaseAPI}
 */
export class OrganizationsApi extends BaseAPI {
    /**
     * 
     * @summary Add a new organization to system
     * @param {OrganizationCreateParams} body Organization object that needs to be added to the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public addOrganization(body: OrganizationCreateParams, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).addOrganization(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a product to an organization
     * @param {string} orgId ID of the Organization
     * @param {OrganizationProductRequest} body Product IDs to be added to the list of known products for the organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public addOrganizationProduct(orgId: string, body: OrganizationProductRequest, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).addOrganizationProduct(orgId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds a user to an organization
     * @param {string} orgId ID of the Organization
     * @param {InviteUserParams} body User to be invited. Roles[] is a new, experimental field.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public addUserToOrganization(orgId: string, body: InviteUserParams, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).addUserToOrganization(orgId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the channel partners for an organization
     * @summary Get all channel partners for an organization
     * @param {string} orgId ID of the Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public adminGetAllChannelPartnersForOrg(orgId: string, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).adminGetAllChannelPartnersForOrg(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the passkey compliance level for an organization
     * @summary Get passkey compliance level for an organization
     * @param {string} orgId ID of the Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public adminGetOrganizationPasskeyComplianceLevel(orgId: string, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).adminGetOrganizationPasskeyComplianceLevel(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes an organization_product record, which controls whether an organization knows about a product
     * @param {string} orgId ID of the Organization
     * @param {string} productId Id of the Product that we want to remove from the set that Organization knows about.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public deleteOrganizationProduct(orgId: string, productId: string, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).deleteOrganizationProduct(orgId, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Match org by name, and returns an array of them.
     * @summary Finds organization, and returns an array of them
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getAllOrganizations(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getAllOrganizations(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a single organization
     * @summary Get an organization by its ID
     * @param {string} orgId ID of the Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationById(orgId: string, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationById(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set of all country permissions for an organization
     * @param {string} orgId ID of the Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationCountries(orgId: string, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationCountries(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns product information if an organization has access to the product
     * @summary Find a product by ID
     * @param {string} orgId ID of the Organization
     * @param {string} productId Id of the Product that we are checking if Organization has access to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationProduct(orgId: string, productId: string, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationProduct(orgId, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of products that an organization has access to.
     * @summary Get the list of products for an org
     * @param {string} orgId ID of the Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationProducts(orgId: string, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationProducts(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all purchase orders and purchase order products of an organization
     * @summary Get all purchase orders of an organization
     * @param {string} orgId ID of the Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationPurchaseorders(orgId: string, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationPurchaseorders(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a key value map of all organizations as \"organization_id\":\"organization_name\"
     * @summary Get all organizations as a map of org_id:org_name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public listAllOrganizations(options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).listAllOrganizations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes organizations searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public listOrganizationsSearchDescription(options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).listOrganizationsSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an organization by its ID
     * @param {string} orgId ID of the Organization
     * @param {OrganizationUpdateParams} organizationUpdateParams Organization object that needs to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateOrganizationById(orgId: string, organizationUpdateParams: OrganizationUpdateParams, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).updateOrganizationById(orgId, organizationUpdateParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace enabled countries for an organization
     * @param {string} orgId ID of the Organization
     * @param {OrganizationCountryRequestBulk} body Country IDs of all countries to be enabled for the organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateOrganizationCountries(orgId: string, body: OrganizationCountryRequestBulk, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).updateOrganizationCountries(orgId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace enabled standard products for an organization
     * @param {string} orgId ID of the Organization
     * @param {OrganizationProductRequest} body Product IDs of all standard products to be enabled for the organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateOrganizationProduct(orgId: string, body: OrganizationProductRequest, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).updateOrganizationProduct(orgId, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new product to system
         * @param {ProductCreateParams} body Organization products that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProduct: async (body: ProductCreateParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addProduct', 'body', body)
            const localVarPath = `/v1/serviceadmin/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new legacy custom product based on a base standard physical product
         * @summary Creates a new legacy custom product
         * @param {LegacyCustomProductRequest} [legacyCustomProductRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateLegacyCustomProduct: async (legacyCustomProductRequest?: LegacyCustomProductRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/products/legacy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(legacyCustomProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single product by product ID
         * @summary Get a single product
         * @param {string} productId Id of Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProductByID: async (productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('adminGetProductByID', 'productId', productId)
            const localVarPath = `/v2/serviceadmin/products/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all products in the system
         * @summary Get products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProducts: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/serviceadmin/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a product that has not been used.
         * @summary Deletes a product
         * @param {number} productId Product id to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductById: async (productId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('deleteProductById', 'productId', productId)
            const localVarPath = `/v1/serviceadmin/products/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns list of all products
         * @summary List products
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductsByName: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a single product
         * @summary Find product by ID
         * @param {number} productId ID of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductById: async (productId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductById', 'productId', productId)
            const localVarPath = `/v1/serviceadmin/products/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes products searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminProductsSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/products/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a single product
         * @summary Update an existing product
         * @param {number} productId ID of Product
         * @param {ProductUpdateParams} body Product obejct needs to be updated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductById: async (productId: number, body: ProductUpdateParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('updateProductById', 'productId', productId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateProductById', 'body', body)
            const localVarPath = `/v1/serviceadmin/products/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a new product to system
         * @param {ProductCreateParams} body Organization products that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProduct(body: ProductCreateParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductCreateResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProduct(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new legacy custom product based on a base standard physical product
         * @summary Creates a new legacy custom product
         * @param {LegacyCustomProductRequest} [legacyCustomProductRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateLegacyCustomProduct(legacyCustomProductRequest?: LegacyCustomProductRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductCreateResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateLegacyCustomProduct(legacyCustomProductRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a single product by product ID
         * @summary Get a single product
         * @param {string} productId Id of Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetProductByID(productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetProductByID(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all products in the system
         * @summary Get products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetProducts(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductV2ResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetProducts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a product that has not been used.
         * @summary Deletes a product
         * @param {number} productId Product id to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProductById(productId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProductById(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns list of all products
         * @summary List products
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProductsByName(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProductsByName(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a single product
         * @summary Find product by ID
         * @param {number} productId ID of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductById(productId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductById(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes products searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAdminProductsSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAdminProductsSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a single product
         * @summary Update an existing product
         * @param {number} productId ID of Product
         * @param {ProductUpdateParams} body Product obejct needs to be updated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductById(productId: number, body: ProductUpdateParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductCreateResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductById(productId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a new product to system
         * @param {ProductCreateParams} body Organization products that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProduct(body: ProductCreateParams, options?: any): AxiosPromise<ProductCreateResult> {
            return localVarFp.addProduct(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new legacy custom product based on a base standard physical product
         * @summary Creates a new legacy custom product
         * @param {LegacyCustomProductRequest} [legacyCustomProductRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateLegacyCustomProduct(legacyCustomProductRequest?: LegacyCustomProductRequest, options?: any): AxiosPromise<ProductCreateResult> {
            return localVarFp.adminCreateLegacyCustomProduct(legacyCustomProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single product by product ID
         * @summary Get a single product
         * @param {string} productId Id of Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProductByID(productId: string, options?: any): AxiosPromise<ProductV2> {
            return localVarFp.adminGetProductByID(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all products in the system
         * @summary Get products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProducts(options?: any): AxiosPromise<ProductV2ResultSet> {
            return localVarFp.adminGetProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a product that has not been used.
         * @summary Deletes a product
         * @param {number} productId Product id to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductById(productId: number, options?: any): AxiosPromise<APIResponse> {
            return localVarFp.deleteProductById(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns list of all products
         * @summary List products
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductsByName(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<ProductResultSet> {
            return localVarFp.getAllProductsByName(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a single product
         * @summary Find product by ID
         * @param {number} productId ID of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductById(productId: number, options?: any): AxiosPromise<ProductDetails> {
            return localVarFp.getProductById(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes products searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminProductsSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listAdminProductsSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a single product
         * @summary Update an existing product
         * @param {number} productId ID of Product
         * @param {ProductUpdateParams} body Product obejct needs to be updated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductById(productId: number, body: ProductUpdateParams, options?: any): AxiosPromise<ProductCreateResult> {
            return localVarFp.updateProductById(productId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * 
     * @summary Add a new product to system
     * @param {ProductCreateParams} body Organization products that needs to be added to the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public addProduct(body: ProductCreateParams, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).addProduct(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new legacy custom product based on a base standard physical product
     * @summary Creates a new legacy custom product
     * @param {LegacyCustomProductRequest} [legacyCustomProductRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public adminCreateLegacyCustomProduct(legacyCustomProductRequest?: LegacyCustomProductRequest, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).adminCreateLegacyCustomProduct(legacyCustomProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single product by product ID
     * @summary Get a single product
     * @param {string} productId Id of Product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public adminGetProductByID(productId: string, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).adminGetProductByID(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all products in the system
     * @summary Get products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public adminGetProducts(options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).adminGetProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a product that has not been used.
     * @summary Deletes a product
     * @param {number} productId Product id to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public deleteProductById(productId: number, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).deleteProductById(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns list of all products
     * @summary List products
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getAllProductsByName(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getAllProductsByName(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a single product
     * @summary Find product by ID
     * @param {number} productId ID of the product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductById(productId: number, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProductById(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes products searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public listAdminProductsSearchDescription(options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).listAdminProductsSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a single product
     * @summary Update an existing product
     * @param {number} productId ID of Product
     * @param {ProductUpdateParams} body Product obejct needs to be updated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public updateProductById(productId: number, body: ProductUpdateParams, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).updateProductById(productId, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PurchaseOrdersApi - axios parameter creator
 * @export
 */
export const PurchaseOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Place an order to add inventory to an organization.  This is restricted to users with serviceAdmin roles in the Service Organization.
         * @param {PurchaseOrderCreateRequest} body add purchase order to organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPurchaseOrder: async (body: PurchaseOrderCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addPurchaseOrder', 'body', body)
            const localVarPath = `/v1/serviceadmin/purchaseorders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For valid response try integer IDs with positive integer value.Negative or non-integer values will generate API errors
         * @summary Delete purchase order by ID
         * @param {string} purchaseorderId ID of the order that needs to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrder: async (purchaseorderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseorderId' is not null or undefined
            assertParamExists('deletePurchaseOrder', 'purchaseorderId', purchaseorderId)
            const localVarPath = `/v1/serviceadmin/purchaseorders/{purchaseorderId}`
                .replace(`{${"purchaseorderId"}}`, encodeURIComponent(String(purchaseorderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns purchase order object with ID
         * @summary Find purchaseorder by ID
         * @param {string} purchaseorderId ID of purchaseorder that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderById: async (purchaseorderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseorderId' is not null or undefined
            assertParamExists('getPurchaseOrderById', 'purchaseorderId', purchaseorderId)
            const localVarPath = `/v1/serviceadmin/purchaseorders/{purchaseorderId}`
                .replace(`{${"purchaseorderId"}}`, encodeURIComponent(String(purchaseorderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is restricted to users with serviceAdmin roles in the Service Organization.
         * @summary Get an array of purchaseorders
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrders: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/purchaseorders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes purchaseorders searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPurchaseOrdersSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/purchaseorders/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is restricted to users with serviceAdmin roles in the Service Organization.
         * @summary Update a purchase order to add inventory to an organization.
         * @param {string} purchaseorderId ID of purchaseorder that is going to be updated
         * @param {PurchaseOrderUpdateRequest} body add purchase order to organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrder: async (purchaseorderId: string, body: PurchaseOrderUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseorderId' is not null or undefined
            assertParamExists('updatePurchaseOrder', 'purchaseorderId', purchaseorderId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updatePurchaseOrder', 'body', body)
            const localVarPath = `/v1/serviceadmin/purchaseorders/{purchaseorderId}`
                .replace(`{${"purchaseorderId"}}`, encodeURIComponent(String(purchaseorderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PurchaseOrdersApi - functional programming interface
 * @export
 */
export const PurchaseOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PurchaseOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Place an order to add inventory to an organization.  This is restricted to users with serviceAdmin roles in the Service Organization.
         * @param {PurchaseOrderCreateRequest} body add purchase order to organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPurchaseOrder(body: PurchaseOrderCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPurchaseOrder(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * For valid response try integer IDs with positive integer value.Negative or non-integer values will generate API errors
         * @summary Delete purchase order by ID
         * @param {string} purchaseorderId ID of the order that needs to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePurchaseOrder(purchaseorderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePurchaseOrder(purchaseorderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns purchase order object with ID
         * @summary Find purchaseorder by ID
         * @param {string} purchaseorderId ID of purchaseorder that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseOrderById(purchaseorderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseOrderById(purchaseorderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This is restricted to users with serviceAdmin roles in the Service Organization.
         * @summary Get an array of purchaseorders
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseOrders(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrderResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseOrders(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes purchaseorders searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPurchaseOrdersSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPurchaseOrdersSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This is restricted to users with serviceAdmin roles in the Service Organization.
         * @summary Update a purchase order to add inventory to an organization.
         * @param {string} purchaseorderId ID of purchaseorder that is going to be updated
         * @param {PurchaseOrderUpdateRequest} body add purchase order to organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePurchaseOrder(purchaseorderId: string, body: PurchaseOrderUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePurchaseOrder(purchaseorderId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PurchaseOrdersApi - factory interface
 * @export
 */
export const PurchaseOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PurchaseOrdersApiFp(configuration)
    return {
        /**
         * 
         * @summary Place an order to add inventory to an organization.  This is restricted to users with serviceAdmin roles in the Service Organization.
         * @param {PurchaseOrderCreateRequest} body add purchase order to organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPurchaseOrder(body: PurchaseOrderCreateRequest, options?: any): AxiosPromise<PurchaseOrder> {
            return localVarFp.addPurchaseOrder(body, options).then((request) => request(axios, basePath));
        },
        /**
         * For valid response try integer IDs with positive integer value.Negative or non-integer values will generate API errors
         * @summary Delete purchase order by ID
         * @param {string} purchaseorderId ID of the order that needs to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrder(purchaseorderId: string, options?: any): AxiosPromise<APIResponse> {
            return localVarFp.deletePurchaseOrder(purchaseorderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns purchase order object with ID
         * @summary Find purchaseorder by ID
         * @param {string} purchaseorderId ID of purchaseorder that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderById(purchaseorderId: string, options?: any): AxiosPromise<PurchaseOrder> {
            return localVarFp.getPurchaseOrderById(purchaseorderId, options).then((request) => request(axios, basePath));
        },
        /**
         * This is restricted to users with serviceAdmin roles in the Service Organization.
         * @summary Get an array of purchaseorders
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrders(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<PurchaseOrderResultSet> {
            return localVarFp.getPurchaseOrders(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes purchaseorders searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPurchaseOrdersSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listPurchaseOrdersSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * This is restricted to users with serviceAdmin roles in the Service Organization.
         * @summary Update a purchase order to add inventory to an organization.
         * @param {string} purchaseorderId ID of purchaseorder that is going to be updated
         * @param {PurchaseOrderUpdateRequest} body add purchase order to organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrder(purchaseorderId: string, body: PurchaseOrderUpdateRequest, options?: any): AxiosPromise<PurchaseOrder> {
            return localVarFp.updatePurchaseOrder(purchaseorderId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PurchaseOrdersApi - object-oriented interface
 * @export
 * @class PurchaseOrdersApi
 * @extends {BaseAPI}
 */
export class PurchaseOrdersApi extends BaseAPI {
    /**
     * 
     * @summary Place an order to add inventory to an organization.  This is restricted to users with serviceAdmin roles in the Service Organization.
     * @param {PurchaseOrderCreateRequest} body add purchase order to organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public addPurchaseOrder(body: PurchaseOrderCreateRequest, options?: AxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).addPurchaseOrder(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For valid response try integer IDs with positive integer value.Negative or non-integer values will generate API errors
     * @summary Delete purchase order by ID
     * @param {string} purchaseorderId ID of the order that needs to be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public deletePurchaseOrder(purchaseorderId: string, options?: AxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).deletePurchaseOrder(purchaseorderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns purchase order object with ID
     * @summary Find purchaseorder by ID
     * @param {string} purchaseorderId ID of purchaseorder that needs to be fetched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public getPurchaseOrderById(purchaseorderId: string, options?: AxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).getPurchaseOrderById(purchaseorderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This is restricted to users with serviceAdmin roles in the Service Organization.
     * @summary Get an array of purchaseorders
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public getPurchaseOrders(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).getPurchaseOrders(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes purchaseorders searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public listPurchaseOrdersSearchDescription(options?: AxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).listPurchaseOrdersSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This is restricted to users with serviceAdmin roles in the Service Organization.
     * @summary Update a purchase order to add inventory to an organization.
     * @param {string} purchaseorderId ID of purchaseorder that is going to be updated
     * @param {PurchaseOrderUpdateRequest} body add purchase order to organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public updatePurchaseOrder(purchaseorderId: string, body: PurchaseOrderUpdateRequest, options?: AxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).updatePurchaseOrder(purchaseorderId, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PurchaseorderProductsApi - axios parameter creator
 * @export
 */
export const PurchaseorderProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Override the dates of a purchaseoder subscription product
         * @summary Override the dates of a purchaseoder subscription product
         * @param {string} purchaseorderSubscriptionProductId ID of purchaseorder subscription product to override the dates
         * @param {SubscriptionDateOverrideRequest} subscriptionDateOverrideRequest override dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionDateOverride: async (purchaseorderSubscriptionProductId: string, subscriptionDateOverrideRequest: SubscriptionDateOverrideRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseorderSubscriptionProductId' is not null or undefined
            assertParamExists('createSubscriptionDateOverride', 'purchaseorderSubscriptionProductId', purchaseorderSubscriptionProductId)
            // verify required parameter 'subscriptionDateOverrideRequest' is not null or undefined
            assertParamExists('createSubscriptionDateOverride', 'subscriptionDateOverrideRequest', subscriptionDateOverrideRequest)
            const localVarPath = `/v1/serviceadmin/purchaseorders/products/{purchaseorder_subscription_product_id}/subscription_dates_override`
                .replace(`{${"purchaseorder_subscription_product_id"}}`, encodeURIComponent(String(purchaseorderSubscriptionProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionDateOverrideRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PurchaseorderProductsApi - functional programming interface
 * @export
 */
export const PurchaseorderProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PurchaseorderProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * Override the dates of a purchaseoder subscription product
         * @summary Override the dates of a purchaseoder subscription product
         * @param {string} purchaseorderSubscriptionProductId ID of purchaseorder subscription product to override the dates
         * @param {SubscriptionDateOverrideRequest} subscriptionDateOverrideRequest override dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubscriptionDateOverride(purchaseorderSubscriptionProductId: string, subscriptionDateOverrideRequest: SubscriptionDateOverrideRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionDateOverrideResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSubscriptionDateOverride(purchaseorderSubscriptionProductId, subscriptionDateOverrideRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PurchaseorderProductsApi - factory interface
 * @export
 */
export const PurchaseorderProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PurchaseorderProductsApiFp(configuration)
    return {
        /**
         * Override the dates of a purchaseoder subscription product
         * @summary Override the dates of a purchaseoder subscription product
         * @param {string} purchaseorderSubscriptionProductId ID of purchaseorder subscription product to override the dates
         * @param {SubscriptionDateOverrideRequest} subscriptionDateOverrideRequest override dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionDateOverride(purchaseorderSubscriptionProductId: string, subscriptionDateOverrideRequest: SubscriptionDateOverrideRequest, options?: any): AxiosPromise<SubscriptionDateOverrideResponse> {
            return localVarFp.createSubscriptionDateOverride(purchaseorderSubscriptionProductId, subscriptionDateOverrideRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PurchaseorderProductsApi - object-oriented interface
 * @export
 * @class PurchaseorderProductsApi
 * @extends {BaseAPI}
 */
export class PurchaseorderProductsApi extends BaseAPI {
    /**
     * Override the dates of a purchaseoder subscription product
     * @summary Override the dates of a purchaseoder subscription product
     * @param {string} purchaseorderSubscriptionProductId ID of purchaseorder subscription product to override the dates
     * @param {SubscriptionDateOverrideRequest} subscriptionDateOverrideRequest override dates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseorderProductsApi
     */
    public createSubscriptionDateOverride(purchaseorderSubscriptionProductId: string, subscriptionDateOverrideRequest: SubscriptionDateOverrideRequest, options?: AxiosRequestConfig) {
        return PurchaseorderProductsApiFp(this.configuration).createSubscriptionDateOverride(purchaseorderSubscriptionProductId, subscriptionDateOverrideRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RefundsApi - axios parameter creator
 * @export
 */
export const RefundsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download a CSV of all shipment refunds
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDownloadRefunds: async (limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/refunds/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RefundsApi - functional programming interface
 * @export
 */
export const RefundsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RefundsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Download a CSV of all shipment refunds
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDownloadRefunds(limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDownloadRefunds(limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RefundsApi - factory interface
 * @export
 */
export const RefundsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RefundsApiFp(configuration)
    return {
        /**
         * 
         * @summary Download a CSV of all shipment refunds
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDownloadRefunds(limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<string> {
            return localVarFp.adminDownloadRefunds(limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RefundsApi - object-oriented interface
 * @export
 * @class RefundsApi
 * @extends {BaseAPI}
 */
export class RefundsApi extends BaseAPI {
    /**
     * 
     * @summary Download a CSV of all shipment refunds
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefundsApi
     */
    public adminDownloadRefunds(limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return RefundsApiFp(this.configuration).adminDownloadRefunds(limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RelationshipsApi - axios parameter creator
 * @export
 */
export const RelationshipsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the list of visibility granting from a distributor to its resellers
         * @summary Get relationships of a distributor organization as admin
         * @param {string} distributorOrganizationId distributor organization id
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDistributorRelationships: async (distributorOrganizationId: string, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'distributorOrganizationId' is not null or undefined
            assertParamExists('adminGetDistributorRelationships', 'distributorOrganizationId', distributorOrganizationId)
            const localVarPath = `/v1/serviceadmin/distributors/{distributorOrganizationId}/relationships`
                .replace(`{${"distributorOrganizationId"}}`, encodeURIComponent(String(distributorOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the list of visibility granting from a reseller to its customers
         * @summary Get relationships of a reseller organization as admin
         * @param {string} resellerOrganizationId reseller organization id
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetResellerRelationships: async (resellerOrganizationId: string, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resellerOrganizationId' is not null or undefined
            assertParamExists('adminGetResellerRelationships', 'resellerOrganizationId', resellerOrganizationId)
            const localVarPath = `/v1/serviceadmin/resellers/{resellerOrganizationId}/relationships`
                .replace(`{${"resellerOrganizationId"}}`, encodeURIComponent(String(resellerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Grant visibility of inventory from a distributor to a reseller.
         * @summary Grant visibility of inventory from a distributor to a reseller
         * @param {string} distributorOrganizationId distributor organization id
         * @param {AdminOrgRelationshipCreateRequest} [adminOrgRelationshipCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGrantDistributorVisibilityToReseller: async (distributorOrganizationId: string, adminOrgRelationshipCreateRequest?: AdminOrgRelationshipCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'distributorOrganizationId' is not null or undefined
            assertParamExists('adminGrantDistributorVisibilityToReseller', 'distributorOrganizationId', distributorOrganizationId)
            const localVarPath = `/v1/serviceadmin/distributors/{distributorOrganizationId}/relationships`
                .replace(`{${"distributorOrganizationId"}}`, encodeURIComponent(String(distributorOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminOrgRelationshipCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Grant visibility of inventory from a reseller to an end customer.
         * @summary Grant visibility of inventory from a reseller to an end customer
         * @param {string} resellerOrganizationId reseller organization id
         * @param {AdminOrgRelationshipCreateRequest} [adminOrgRelationshipCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGrantResellerVisibilityToCustomer: async (resellerOrganizationId: string, adminOrgRelationshipCreateRequest?: AdminOrgRelationshipCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resellerOrganizationId' is not null or undefined
            assertParamExists('adminGrantResellerVisibilityToCustomer', 'resellerOrganizationId', resellerOrganizationId)
            const localVarPath = `/v1/serviceadmin/resellers/{resellerOrganizationId}/relationships`
                .replace(`{${"resellerOrganizationId"}}`, encodeURIComponent(String(resellerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminOrgRelationshipCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke visibility of inventory from a distributor of a reseller.
         * @param {string} distributorOrganizationId distributor organization id
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRevokeDistributorVisibilityOfReseller: async (distributorOrganizationId: string, resellerOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'distributorOrganizationId' is not null or undefined
            assertParamExists('adminRevokeDistributorVisibilityOfReseller', 'distributorOrganizationId', distributorOrganizationId)
            // verify required parameter 'resellerOrganizationId' is not null or undefined
            assertParamExists('adminRevokeDistributorVisibilityOfReseller', 'resellerOrganizationId', resellerOrganizationId)
            const localVarPath = `/v1/serviceadmin/distributors/{distributorOrganizationId}/relationships/{resellerOrganizationId}`
                .replace(`{${"distributorOrganizationId"}}`, encodeURIComponent(String(distributorOrganizationId)))
                .replace(`{${"resellerOrganizationId"}}`, encodeURIComponent(String(resellerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke visibility of inventory from a reseller of a customer.
         * @param {string} resellerOrganizationId reseller organization id
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRevokeResellerVisibilityOfCustomer: async (resellerOrganizationId: string, customerOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resellerOrganizationId' is not null or undefined
            assertParamExists('adminRevokeResellerVisibilityOfCustomer', 'resellerOrganizationId', resellerOrganizationId)
            // verify required parameter 'customerOrganizationId' is not null or undefined
            assertParamExists('adminRevokeResellerVisibilityOfCustomer', 'customerOrganizationId', customerOrganizationId)
            const localVarPath = `/v1/serviceadmin/resellers/{resellerOrganizationId}/relationships/{customerOrganizationId}`
                .replace(`{${"resellerOrganizationId"}}`, encodeURIComponent(String(resellerOrganizationId)))
                .replace(`{${"customerOrganizationId"}}`, encodeURIComponent(String(customerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes distributor relationships searchable fields
         * @summary Lists searchable fields
         * @param {string} distributorOrganizationId distributor organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminDistributorRelationshipsSearchDescription: async (distributorOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'distributorOrganizationId' is not null or undefined
            assertParamExists('listAdminDistributorRelationshipsSearchDescription', 'distributorOrganizationId', distributorOrganizationId)
            const localVarPath = `/v1/serviceadmin/distributors/{distributorOrganizationId}/relationships/search-description`
                .replace(`{${"distributorOrganizationId"}}`, encodeURIComponent(String(distributorOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes reseller relationships searchable fields
         * @summary Lists searchable fields
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminResellerRelationshipsSearchDescription: async (resellerOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resellerOrganizationId' is not null or undefined
            assertParamExists('listAdminResellerRelationshipsSearchDescription', 'resellerOrganizationId', resellerOrganizationId)
            const localVarPath = `/v1/serviceadmin/resellers/{resellerOrganizationId}/relationships/search-description`
                .replace(`{${"resellerOrganizationId"}}`, encodeURIComponent(String(resellerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RelationshipsApi - functional programming interface
 * @export
 */
export const RelationshipsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RelationshipsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the list of visibility granting from a distributor to its resellers
         * @summary Get relationships of a distributor organization as admin
         * @param {string} distributorOrganizationId distributor organization id
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetDistributorRelationships(distributorOrganizationId: string, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrgRelationshipsResponseSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetDistributorRelationships(distributorOrganizationId, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the list of visibility granting from a reseller to its customers
         * @summary Get relationships of a reseller organization as admin
         * @param {string} resellerOrganizationId reseller organization id
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetResellerRelationships(resellerOrganizationId: string, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrgRelationshipsResponseSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetResellerRelationships(resellerOrganizationId, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Grant visibility of inventory from a distributor to a reseller.
         * @summary Grant visibility of inventory from a distributor to a reseller
         * @param {string} distributorOrganizationId distributor organization id
         * @param {AdminOrgRelationshipCreateRequest} [adminOrgRelationshipCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGrantDistributorVisibilityToReseller(distributorOrganizationId: string, adminOrgRelationshipCreateRequest?: AdminOrgRelationshipCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrgRelationshipsCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGrantDistributorVisibilityToReseller(distributorOrganizationId, adminOrgRelationshipCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Grant visibility of inventory from a reseller to an end customer.
         * @summary Grant visibility of inventory from a reseller to an end customer
         * @param {string} resellerOrganizationId reseller organization id
         * @param {AdminOrgRelationshipCreateRequest} [adminOrgRelationshipCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGrantResellerVisibilityToCustomer(resellerOrganizationId: string, adminOrgRelationshipCreateRequest?: AdminOrgRelationshipCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrgRelationshipsCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGrantResellerVisibilityToCustomer(resellerOrganizationId, adminOrgRelationshipCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Revoke visibility of inventory from a distributor of a reseller.
         * @param {string} distributorOrganizationId distributor organization id
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRevokeDistributorVisibilityOfReseller(distributorOrganizationId: string, resellerOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRevokeDistributorVisibilityOfReseller(distributorOrganizationId, resellerOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Revoke visibility of inventory from a reseller of a customer.
         * @param {string} resellerOrganizationId reseller organization id
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRevokeResellerVisibilityOfCustomer(resellerOrganizationId: string, customerOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRevokeResellerVisibilityOfCustomer(resellerOrganizationId, customerOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes distributor relationships searchable fields
         * @summary Lists searchable fields
         * @param {string} distributorOrganizationId distributor organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAdminDistributorRelationshipsSearchDescription(distributorOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAdminDistributorRelationshipsSearchDescription(distributorOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes reseller relationships searchable fields
         * @summary Lists searchable fields
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAdminResellerRelationshipsSearchDescription(resellerOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAdminResellerRelationshipsSearchDescription(resellerOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RelationshipsApi - factory interface
 * @export
 */
export const RelationshipsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RelationshipsApiFp(configuration)
    return {
        /**
         * Get the list of visibility granting from a distributor to its resellers
         * @summary Get relationships of a distributor organization as admin
         * @param {string} distributorOrganizationId distributor organization id
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDistributorRelationships(distributorOrganizationId: string, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<AdminOrgRelationshipsResponseSet> {
            return localVarFp.adminGetDistributorRelationships(distributorOrganizationId, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of visibility granting from a reseller to its customers
         * @summary Get relationships of a reseller organization as admin
         * @param {string} resellerOrganizationId reseller organization id
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetResellerRelationships(resellerOrganizationId: string, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<AdminOrgRelationshipsResponseSet> {
            return localVarFp.adminGetResellerRelationships(resellerOrganizationId, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Grant visibility of inventory from a distributor to a reseller.
         * @summary Grant visibility of inventory from a distributor to a reseller
         * @param {string} distributorOrganizationId distributor organization id
         * @param {AdminOrgRelationshipCreateRequest} [adminOrgRelationshipCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGrantDistributorVisibilityToReseller(distributorOrganizationId: string, adminOrgRelationshipCreateRequest?: AdminOrgRelationshipCreateRequest, options?: any): AxiosPromise<AdminOrgRelationshipsCreateResponse> {
            return localVarFp.adminGrantDistributorVisibilityToReseller(distributorOrganizationId, adminOrgRelationshipCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Grant visibility of inventory from a reseller to an end customer.
         * @summary Grant visibility of inventory from a reseller to an end customer
         * @param {string} resellerOrganizationId reseller organization id
         * @param {AdminOrgRelationshipCreateRequest} [adminOrgRelationshipCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGrantResellerVisibilityToCustomer(resellerOrganizationId: string, adminOrgRelationshipCreateRequest?: AdminOrgRelationshipCreateRequest, options?: any): AxiosPromise<AdminOrgRelationshipsCreateResponse> {
            return localVarFp.adminGrantResellerVisibilityToCustomer(resellerOrganizationId, adminOrgRelationshipCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke visibility of inventory from a distributor of a reseller.
         * @param {string} distributorOrganizationId distributor organization id
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRevokeDistributorVisibilityOfReseller(distributorOrganizationId: string, resellerOrganizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminRevokeDistributorVisibilityOfReseller(distributorOrganizationId, resellerOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke visibility of inventory from a reseller of a customer.
         * @param {string} resellerOrganizationId reseller organization id
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRevokeResellerVisibilityOfCustomer(resellerOrganizationId: string, customerOrganizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminRevokeResellerVisibilityOfCustomer(resellerOrganizationId, customerOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes distributor relationships searchable fields
         * @summary Lists searchable fields
         * @param {string} distributorOrganizationId distributor organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminDistributorRelationshipsSearchDescription(distributorOrganizationId: string, options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listAdminDistributorRelationshipsSearchDescription(distributorOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes reseller relationships searchable fields
         * @summary Lists searchable fields
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminResellerRelationshipsSearchDescription(resellerOrganizationId: string, options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listAdminResellerRelationshipsSearchDescription(resellerOrganizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RelationshipsApi - object-oriented interface
 * @export
 * @class RelationshipsApi
 * @extends {BaseAPI}
 */
export class RelationshipsApi extends BaseAPI {
    /**
     * Get the list of visibility granting from a distributor to its resellers
     * @summary Get relationships of a distributor organization as admin
     * @param {string} distributorOrganizationId distributor organization id
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipsApi
     */
    public adminGetDistributorRelationships(distributorOrganizationId: string, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return RelationshipsApiFp(this.configuration).adminGetDistributorRelationships(distributorOrganizationId, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the list of visibility granting from a reseller to its customers
     * @summary Get relationships of a reseller organization as admin
     * @param {string} resellerOrganizationId reseller organization id
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipsApi
     */
    public adminGetResellerRelationships(resellerOrganizationId: string, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return RelationshipsApiFp(this.configuration).adminGetResellerRelationships(resellerOrganizationId, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Grant visibility of inventory from a distributor to a reseller.
     * @summary Grant visibility of inventory from a distributor to a reseller
     * @param {string} distributorOrganizationId distributor organization id
     * @param {AdminOrgRelationshipCreateRequest} [adminOrgRelationshipCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipsApi
     */
    public adminGrantDistributorVisibilityToReseller(distributorOrganizationId: string, adminOrgRelationshipCreateRequest?: AdminOrgRelationshipCreateRequest, options?: AxiosRequestConfig) {
        return RelationshipsApiFp(this.configuration).adminGrantDistributorVisibilityToReseller(distributorOrganizationId, adminOrgRelationshipCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Grant visibility of inventory from a reseller to an end customer.
     * @summary Grant visibility of inventory from a reseller to an end customer
     * @param {string} resellerOrganizationId reseller organization id
     * @param {AdminOrgRelationshipCreateRequest} [adminOrgRelationshipCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipsApi
     */
    public adminGrantResellerVisibilityToCustomer(resellerOrganizationId: string, adminOrgRelationshipCreateRequest?: AdminOrgRelationshipCreateRequest, options?: AxiosRequestConfig) {
        return RelationshipsApiFp(this.configuration).adminGrantResellerVisibilityToCustomer(resellerOrganizationId, adminOrgRelationshipCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke visibility of inventory from a distributor of a reseller.
     * @param {string} distributorOrganizationId distributor organization id
     * @param {string} resellerOrganizationId reseller organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipsApi
     */
    public adminRevokeDistributorVisibilityOfReseller(distributorOrganizationId: string, resellerOrganizationId: string, options?: AxiosRequestConfig) {
        return RelationshipsApiFp(this.configuration).adminRevokeDistributorVisibilityOfReseller(distributorOrganizationId, resellerOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke visibility of inventory from a reseller of a customer.
     * @param {string} resellerOrganizationId reseller organization id
     * @param {string} customerOrganizationId end customer organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipsApi
     */
    public adminRevokeResellerVisibilityOfCustomer(resellerOrganizationId: string, customerOrganizationId: string, options?: AxiosRequestConfig) {
        return RelationshipsApiFp(this.configuration).adminRevokeResellerVisibilityOfCustomer(resellerOrganizationId, customerOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes distributor relationships searchable fields
     * @summary Lists searchable fields
     * @param {string} distributorOrganizationId distributor organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipsApi
     */
    public listAdminDistributorRelationshipsSearchDescription(distributorOrganizationId: string, options?: AxiosRequestConfig) {
        return RelationshipsApiFp(this.configuration).listAdminDistributorRelationshipsSearchDescription(distributorOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes reseller relationships searchable fields
     * @summary Lists searchable fields
     * @param {string} resellerOrganizationId reseller organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipsApi
     */
    public listAdminResellerRelationshipsSearchDescription(resellerOrganizationId: string, options?: AxiosRequestConfig) {
        return RelationshipsApiFp(this.configuration).listAdminResellerRelationshipsSearchDescription(resellerOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResellersApi - axios parameter creator
 * @export
 */
export const ResellersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the list of visibility granting from a reseller to its customers
         * @summary Get relationships of a reseller organization as admin
         * @param {string} resellerOrganizationId reseller organization id
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetResellerRelationships: async (resellerOrganizationId: string, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resellerOrganizationId' is not null or undefined
            assertParamExists('adminGetResellerRelationships', 'resellerOrganizationId', resellerOrganizationId)
            const localVarPath = `/v1/serviceadmin/resellers/{resellerOrganizationId}/relationships`
                .replace(`{${"resellerOrganizationId"}}`, encodeURIComponent(String(resellerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the list of all resellers from existing purchaseorders
         * @summary Get all reseller organizations
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetResellers: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/resellers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Grant visibility of inventory from a reseller to an end customer.
         * @summary Grant visibility of inventory from a reseller to an end customer
         * @param {string} resellerOrganizationId reseller organization id
         * @param {AdminOrgRelationshipCreateRequest} [adminOrgRelationshipCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGrantResellerVisibilityToCustomer: async (resellerOrganizationId: string, adminOrgRelationshipCreateRequest?: AdminOrgRelationshipCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resellerOrganizationId' is not null or undefined
            assertParamExists('adminGrantResellerVisibilityToCustomer', 'resellerOrganizationId', resellerOrganizationId)
            const localVarPath = `/v1/serviceadmin/resellers/{resellerOrganizationId}/relationships`
                .replace(`{${"resellerOrganizationId"}}`, encodeURIComponent(String(resellerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminOrgRelationshipCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke visibility of inventory from a reseller of a customer.
         * @param {string} resellerOrganizationId reseller organization id
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRevokeResellerVisibilityOfCustomer: async (resellerOrganizationId: string, customerOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resellerOrganizationId' is not null or undefined
            assertParamExists('adminRevokeResellerVisibilityOfCustomer', 'resellerOrganizationId', resellerOrganizationId)
            // verify required parameter 'customerOrganizationId' is not null or undefined
            assertParamExists('adminRevokeResellerVisibilityOfCustomer', 'customerOrganizationId', customerOrganizationId)
            const localVarPath = `/v1/serviceadmin/resellers/{resellerOrganizationId}/relationships/{customerOrganizationId}`
                .replace(`{${"resellerOrganizationId"}}`, encodeURIComponent(String(resellerOrganizationId)))
                .replace(`{${"customerOrganizationId"}}`, encodeURIComponent(String(customerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes reseller relationships searchable fields
         * @summary Lists searchable fields
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminResellerRelationshipsSearchDescription: async (resellerOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resellerOrganizationId' is not null or undefined
            assertParamExists('listAdminResellerRelationshipsSearchDescription', 'resellerOrganizationId', resellerOrganizationId)
            const localVarPath = `/v1/serviceadmin/resellers/{resellerOrganizationId}/relationships/search-description`
                .replace(`{${"resellerOrganizationId"}}`, encodeURIComponent(String(resellerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes resellers searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminResellersSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/resellers/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResellersApi - functional programming interface
 * @export
 */
export const ResellersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResellersApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the list of visibility granting from a reseller to its customers
         * @summary Get relationships of a reseller organization as admin
         * @param {string} resellerOrganizationId reseller organization id
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetResellerRelationships(resellerOrganizationId: string, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrgRelationshipsResponseSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetResellerRelationships(resellerOrganizationId, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the list of all resellers from existing purchaseorders
         * @summary Get all reseller organizations
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetResellers(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminHigherTierOrganizationResponseSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetResellers(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Grant visibility of inventory from a reseller to an end customer.
         * @summary Grant visibility of inventory from a reseller to an end customer
         * @param {string} resellerOrganizationId reseller organization id
         * @param {AdminOrgRelationshipCreateRequest} [adminOrgRelationshipCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGrantResellerVisibilityToCustomer(resellerOrganizationId: string, adminOrgRelationshipCreateRequest?: AdminOrgRelationshipCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrgRelationshipsCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGrantResellerVisibilityToCustomer(resellerOrganizationId, adminOrgRelationshipCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Revoke visibility of inventory from a reseller of a customer.
         * @param {string} resellerOrganizationId reseller organization id
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRevokeResellerVisibilityOfCustomer(resellerOrganizationId: string, customerOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRevokeResellerVisibilityOfCustomer(resellerOrganizationId, customerOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes reseller relationships searchable fields
         * @summary Lists searchable fields
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAdminResellerRelationshipsSearchDescription(resellerOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAdminResellerRelationshipsSearchDescription(resellerOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes resellers searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAdminResellersSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAdminResellersSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResellersApi - factory interface
 * @export
 */
export const ResellersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResellersApiFp(configuration)
    return {
        /**
         * Get the list of visibility granting from a reseller to its customers
         * @summary Get relationships of a reseller organization as admin
         * @param {string} resellerOrganizationId reseller organization id
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetResellerRelationships(resellerOrganizationId: string, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<AdminOrgRelationshipsResponseSet> {
            return localVarFp.adminGetResellerRelationships(resellerOrganizationId, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of all resellers from existing purchaseorders
         * @summary Get all reseller organizations
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetResellers(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<AdminHigherTierOrganizationResponseSet> {
            return localVarFp.adminGetResellers(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Grant visibility of inventory from a reseller to an end customer.
         * @summary Grant visibility of inventory from a reseller to an end customer
         * @param {string} resellerOrganizationId reseller organization id
         * @param {AdminOrgRelationshipCreateRequest} [adminOrgRelationshipCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGrantResellerVisibilityToCustomer(resellerOrganizationId: string, adminOrgRelationshipCreateRequest?: AdminOrgRelationshipCreateRequest, options?: any): AxiosPromise<AdminOrgRelationshipsCreateResponse> {
            return localVarFp.adminGrantResellerVisibilityToCustomer(resellerOrganizationId, adminOrgRelationshipCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke visibility of inventory from a reseller of a customer.
         * @param {string} resellerOrganizationId reseller organization id
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRevokeResellerVisibilityOfCustomer(resellerOrganizationId: string, customerOrganizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminRevokeResellerVisibilityOfCustomer(resellerOrganizationId, customerOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes reseller relationships searchable fields
         * @summary Lists searchable fields
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminResellerRelationshipsSearchDescription(resellerOrganizationId: string, options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listAdminResellerRelationshipsSearchDescription(resellerOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes resellers searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminResellersSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listAdminResellersSearchDescription(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResellersApi - object-oriented interface
 * @export
 * @class ResellersApi
 * @extends {BaseAPI}
 */
export class ResellersApi extends BaseAPI {
    /**
     * Get the list of visibility granting from a reseller to its customers
     * @summary Get relationships of a reseller organization as admin
     * @param {string} resellerOrganizationId reseller organization id
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellersApi
     */
    public adminGetResellerRelationships(resellerOrganizationId: string, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return ResellersApiFp(this.configuration).adminGetResellerRelationships(resellerOrganizationId, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the list of all resellers from existing purchaseorders
     * @summary Get all reseller organizations
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellersApi
     */
    public adminGetResellers(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return ResellersApiFp(this.configuration).adminGetResellers(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Grant visibility of inventory from a reseller to an end customer.
     * @summary Grant visibility of inventory from a reseller to an end customer
     * @param {string} resellerOrganizationId reseller organization id
     * @param {AdminOrgRelationshipCreateRequest} [adminOrgRelationshipCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellersApi
     */
    public adminGrantResellerVisibilityToCustomer(resellerOrganizationId: string, adminOrgRelationshipCreateRequest?: AdminOrgRelationshipCreateRequest, options?: AxiosRequestConfig) {
        return ResellersApiFp(this.configuration).adminGrantResellerVisibilityToCustomer(resellerOrganizationId, adminOrgRelationshipCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke visibility of inventory from a reseller of a customer.
     * @param {string} resellerOrganizationId reseller organization id
     * @param {string} customerOrganizationId end customer organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellersApi
     */
    public adminRevokeResellerVisibilityOfCustomer(resellerOrganizationId: string, customerOrganizationId: string, options?: AxiosRequestConfig) {
        return ResellersApiFp(this.configuration).adminRevokeResellerVisibilityOfCustomer(resellerOrganizationId, customerOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes reseller relationships searchable fields
     * @summary Lists searchable fields
     * @param {string} resellerOrganizationId reseller organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellersApi
     */
    public listAdminResellerRelationshipsSearchDescription(resellerOrganizationId: string, options?: AxiosRequestConfig) {
        return ResellersApiFp(this.configuration).listAdminResellerRelationshipsSearchDescription(resellerOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes resellers searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellersApi
     */
    public listAdminResellersSearchDescription(options?: AxiosRequestConfig) {
        return ResellersApiFp(this.configuration).listAdminResellersSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RolesApi - axios parameter creator
 * @export
 */
export const RolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a single role
         * @summary Find role by ID
         * @param {number} roleId ID of Role to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleById: async (roleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('getRoleById', 'roleId', roleId)
            const localVarPath = `/v1/serviceadmin/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finds roles by name, returns role objects as JSON array.  Results are not restrict by org.
         * @summary Finds roles by name available to users
         * @param {string} [name] Name to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesByName: async (name?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RolesApi - functional programming interface
 * @export
 */
export const RolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a single role
         * @summary Find role by ID
         * @param {number} roleId ID of Role to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoleById(roleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Role>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoleById(roleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Finds roles by name, returns role objects as JSON array.  Results are not restrict by org.
         * @summary Finds roles by name available to users
         * @param {string} [name] Name to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRolesByName(name?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Organization>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRolesByName(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RolesApi - factory interface
 * @export
 */
export const RolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RolesApiFp(configuration)
    return {
        /**
         * Returns a single role
         * @summary Find role by ID
         * @param {number} roleId ID of Role to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleById(roleId: number, options?: any): AxiosPromise<Role> {
            return localVarFp.getRoleById(roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Finds roles by name, returns role objects as JSON array.  Results are not restrict by org.
         * @summary Finds roles by name available to users
         * @param {string} [name] Name to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesByName(name?: string, options?: any): AxiosPromise<Array<Organization>> {
            return localVarFp.getRolesByName(name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
export class RolesApi extends BaseAPI {
    /**
     * Returns a single role
     * @summary Find role by ID
     * @param {number} roleId ID of Role to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public getRoleById(roleId: number, options?: AxiosRequestConfig) {
        return RolesApiFp(this.configuration).getRoleById(roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Finds roles by name, returns role objects as JSON array.  Results are not restrict by org.
     * @summary Finds roles by name available to users
     * @param {string} [name] Name to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public getRolesByName(name?: string, options?: AxiosRequestConfig) {
        return RolesApiFp(this.configuration).getRolesByName(name, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShipmentsApi - axios parameter creator
 * @export
 */
export const ShipmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Override a shipment state invalid address or address fail
         * @summary Override invalid address
         * @param {string} shipmentId Id of shipment
         * @param {AddressOverride} [addressOverride] Comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddressOverride: async (shipmentId: string, addressOverride?: AddressOverride, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('adminAddressOverride', 'shipmentId', shipmentId)
            const localVarPath = `/v1/serviceadmin/shipments/{shipmentId}/address-override`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addressOverride, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Override multiple shipments in state \"invalid address\" or \"address fail\", thus confirming that the addresses are valid.
         * @summary Override invalid address of multiple shipments
         * @param {BulkAddressOverride} [bulkAddressOverride] A non-empty list of shipment IDs to override and a comment to be attached to all overrides.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBulkAddressOverride: async (bulkAddressOverride?: BulkAddressOverride, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/shipments/address-override`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkAddressOverride, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Place a request for a shipment on behalf of an org. This is restricted to service admin users.
         * @summary Create a new shipment
         * @param {AdminShipmentRequest} [body] ShipmentRequest to be added to the requesting user\&#39;s organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateShipment: async (body?: AdminShipmentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/shipments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a shipment by its ID
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteShipmentById: async (shipmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('adminDeleteShipmentById', 'shipmentId', shipmentId)
            const localVarPath = `/v1/serviceadmin/shipments/{shipmentId}`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all shipping and product refunds
         * @summary Get all refund information
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAllShipmentRefunds: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/refunds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns shipment object with ID
         * @summary Find shipment by ID
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetShipmentExactById: async (shipmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('adminGetShipmentExactById', 'shipmentId', shipmentId)
            const localVarPath = `/v1/serviceadmin/shipments/{shipmentId}`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes shipment refunds searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetShipmentRefundSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/refunds/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all shipping and product refund information for a shipment
         * @summary Get refund information for a shipment
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetShipmentRefunds: async (shipmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('adminGetShipmentRefunds', 'shipmentId', shipmentId)
            const localVarPath = `/v1/serviceadmin/shipments/{shipmentId}/refunds`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets shipments, returns them in a JSON array
         * @summary Get shipments
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetShipments: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/shipments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update shipment details for the given shipment ID.
         * @summary Update an existing shipment
         * @param {string} shipmentId Id of shipment
         * @param {AdminShipmentUpdateParams} adminShipmentUpdateParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateShipmentById: async (shipmentId: string, adminShipmentUpdateParams: AdminShipmentUpdateParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('adminUpdateShipmentById', 'shipmentId', shipmentId)
            // verify required parameter 'adminShipmentUpdateParams' is not null or undefined
            assertParamExists('adminUpdateShipmentById', 'adminShipmentUpdateParams', adminShipmentUpdateParams)
            const localVarPath = `/v1/serviceadmin/shipments/{shipmentId}`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminShipmentUpdateParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a replacement shipment for a given shipment
         * @summary Create replacement shipment
         * @param {string} shipmentId Id of shipment
         * @param {CreateReplacementShipmentRequest} [createReplacementShipmentRequest] Replacement shipment request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReplacementShipment: async (shipmentId: string, createReplacementShipmentRequest?: CreateReplacementShipmentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('createReplacementShipment', 'shipmentId', shipmentId)
            const localVarPath = `/v1/serviceadmin/shipments/{shipmentId}/replacements`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReplacementShipmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a shipping and/or product refund for a shipment
         * @summary Create a refund for a shipment
         * @param {string} shipmentId Id of shipment
         * @param {ShipmentRefundRequest} [shipmentRefundRequest] Details of what parts of the shipment need to be refunded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentRefund: async (shipmentId: string, shipmentRefundRequest?: ShipmentRefundRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('createShipmentRefund', 'shipmentId', shipmentId)
            const localVarPath = `/v1/serviceadmin/shipments/{shipmentId}/refunds`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shipmentRefundRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm or override a shipment in state DPLMatch
         * @summary Confirm or override a DPL match
         * @param {string} shipmentId Id of shipment that needs an address override
         * @param {DPLOverride} [dPLOverride] Override decision and comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dPLOverride: async (shipmentId: string, dPLOverride?: DPLOverride, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('dPLOverride', 'shipmentId', shipmentId)
            const localVarPath = `/v1/serviceadmin/shipments/{shipmentId}/dpl-override`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dPLOverride, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Place a request for bulk deletion of shipments
         * @param {Array<string>} [requestBody] A JSON list of shipment Ids to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBulkShipment: async (requestBody?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/shipments/bulkdelete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download a CSV with shipments
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {AdminGetDistributorsSearchParameter} [excludedCols] Column names to be excluded from the downloaded CSV file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadShipments: async (limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, excludedCols?: AdminGetDistributorsSearchParameter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/shipments/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }

            if (excludedCols !== undefined) {
                localVarQueryParameter['excluded_cols'] = excludedCols;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all matching names and addresses found on DPL for a shipment
         * @summary Get dpl information for a shipment
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDPLMatches: async (shipmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('getDPLMatches', 'shipmentId', shipmentId)
            const localVarPath = `/v1/serviceadmin/shipments/{shipmentId}/dpl`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a shipment\'s Debit to Allocation records by its ShipmentId
         * @param {string} shipmentId ID of shipment to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentDebitAllocationsByShipmentId: async (shipmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('getShipmentDebitAllocationsByShipmentId', 'shipmentId', shipmentId)
            const localVarPath = `/v1/serviceadmin/shipments/{shipmentId}/allocation-details`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Link a shipment with one of its replacement shipments
         * @summary Link a replacement shipment
         * @param {string} shipmentId Id of shipment
         * @param {ReplacementShipmentLink} [replacementShipmentLink] Replacement shipment to link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkShipments: async (shipmentId: string, replacementShipmentLink?: ReplacementShipmentLink, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('linkShipments', 'shipmentId', shipmentId)
            const localVarPath = `/v1/serviceadmin/shipments/{shipmentId}/link-replacement`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replacementShipmentLink, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes shipments searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShipmentsSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/shipments/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Run process and deduct on a single shipment
         * @summary Single shipment process and deduct
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAndDeductSingleShipment: async (shipmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('processAndDeductSingleShipment', 'shipmentId', shipmentId)
            const localVarPath = `/v1/serviceadmin/shipments/{shipmentId}/process-deduct`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Shipments that fail rush order end up in ShipmentStateError.  An api call is needed to put them back into StateFulfillmentReady to try again.
         * @summary Recover a shipment that has not shipped from ShipmentStateError
         * @param {string} shipmentId Id of shipment that needs to be recovered
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverShipmentError: async (shipmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('recoverShipmentError', 'shipmentId', shipmentId)
            const localVarPath = `/v1/serviceadmin/shipments/{shipmentId}/recovershipmenterror`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Forcibly transition the state of a shipment that has been shipped
         * @summary Override shipment state
         * @param {string} shipmentId Id of shipment
         * @param {StateOverride} [stateOverride] State ID to transition to and comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stateOverride: async (shipmentId: string, stateOverride?: StateOverride, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('stateOverride', 'shipmentId', shipmentId)
            const localVarPath = `/v1/serviceadmin/shipments/{shipmentId}/state-override`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stateOverride, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set a new tracking number, carrier, and tracking link for a shipment
         * @summary Update shipment tracking info
         * @param {string} shipmentId Id of shipment
         * @param {TrackingInfoUpdateParams} [trackingInfoUpdateParams] Tracking number and carrier to update and comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingInfoUpdate: async (shipmentId: string, trackingInfoUpdateParams?: TrackingInfoUpdateParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('trackingInfoUpdate', 'shipmentId', shipmentId)
            const localVarPath = `/v1/serviceadmin/shipments/{shipmentId}/tracking`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackingInfoUpdateParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a link between a shipment and it\'s replacement
         * @summary Unlink a replacement shipment
         * @param {string} shipmentId Id of shipment
         * @param {string} replacementShipmentId Id of replacement shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkShipments: async (shipmentId: string, replacementShipmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('unlinkShipments', 'shipmentId', shipmentId)
            // verify required parameter 'replacementShipmentId' is not null or undefined
            assertParamExists('unlinkShipments', 'replacementShipmentId', replacementShipmentId)
            const localVarPath = `/v1/serviceadmin/shipments/{shipmentId}/replacements/{replacementShipmentId}`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)))
                .replace(`{${"replacementShipmentId"}}`, encodeURIComponent(String(replacementShipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShipmentsApi - functional programming interface
 * @export
 */
export const ShipmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShipmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Override a shipment state invalid address or address fail
         * @summary Override invalid address
         * @param {string} shipmentId Id of shipment
         * @param {AddressOverride} [addressOverride] Comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAddressOverride(shipmentId: string, addressOverride?: AddressOverride, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponseServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAddressOverride(shipmentId, addressOverride, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Override multiple shipments in state \"invalid address\" or \"address fail\", thus confirming that the addresses are valid.
         * @summary Override invalid address of multiple shipments
         * @param {BulkAddressOverride} [bulkAddressOverride] A non-empty list of shipment IDs to override and a comment to be attached to all overrides.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBulkAddressOverride(bulkAddressOverride?: BulkAddressOverride, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentAddressBulkOverrideResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBulkAddressOverride(bulkAddressOverride, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Place a request for a shipment on behalf of an org. This is restricted to service admin users.
         * @summary Create a new shipment
         * @param {AdminShipmentRequest} [body] ShipmentRequest to be added to the requesting user\&#39;s organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateShipment(body?: AdminShipmentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponseServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateShipment(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a shipment by its ID
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteShipmentById(shipmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteShipmentById(shipmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all shipping and product refunds
         * @summary Get all refund information
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetAllShipmentRefunds(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminRefundResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetAllShipmentRefunds(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns shipment object with ID
         * @summary Find shipment by ID
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetShipmentExactById(shipmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponseServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetShipmentExactById(shipmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes shipment refunds searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetShipmentRefundSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetShipmentRefundSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all shipping and product refund information for a shipment
         * @summary Get refund information for a shipment
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetShipmentRefunds(shipmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminShipmentRefundResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetShipmentRefunds(shipmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets shipments, returns them in a JSON array
         * @summary Get shipments
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetShipments(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResultSetServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetShipments(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update shipment details for the given shipment ID.
         * @summary Update an existing shipment
         * @param {string} shipmentId Id of shipment
         * @param {AdminShipmentUpdateParams} adminShipmentUpdateParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateShipmentById(shipmentId: string, adminShipmentUpdateParams: AdminShipmentUpdateParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateShipmentById(shipmentId, adminShipmentUpdateParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a replacement shipment for a given shipment
         * @summary Create replacement shipment
         * @param {string} shipmentId Id of shipment
         * @param {CreateReplacementShipmentRequest} [createReplacementShipmentRequest] Replacement shipment request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReplacementShipment(shipmentId: string, createReplacementShipmentRequest?: CreateReplacementShipmentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponseServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReplacementShipment(shipmentId, createReplacementShipmentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a shipping and/or product refund for a shipment
         * @summary Create a refund for a shipment
         * @param {string} shipmentId Id of shipment
         * @param {ShipmentRefundRequest} [shipmentRefundRequest] Details of what parts of the shipment need to be refunded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createShipmentRefund(shipmentId: string, shipmentRefundRequest?: ShipmentRefundRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminShipmentRefundResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createShipmentRefund(shipmentId, shipmentRefundRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Confirm or override a shipment in state DPLMatch
         * @summary Confirm or override a DPL match
         * @param {string} shipmentId Id of shipment that needs an address override
         * @param {DPLOverride} [dPLOverride] Override decision and comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dPLOverride(shipmentId: string, dPLOverride?: DPLOverride, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponseServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dPLOverride(shipmentId, dPLOverride, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Place a request for bulk deletion of shipments
         * @param {Array<string>} [requestBody] A JSON list of shipment Ids to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBulkShipment(requestBody?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentBulkDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBulkShipment(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download a CSV with shipments
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {AdminGetDistributorsSearchParameter} [excludedCols] Column names to be excluded from the downloaded CSV file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadShipments(limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, excludedCols?: AdminGetDistributorsSearchParameter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadShipments(limit, sortBy, sortDirection, search, searchField, advancedSearch, excludedCols, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all matching names and addresses found on DPL for a shipment
         * @summary Get dpl information for a shipment
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDPLMatches(shipmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDPLMatches200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDPLMatches(shipmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a shipment\'s Debit to Allocation records by its ShipmentId
         * @param {string} shipmentId ID of shipment to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShipmentDebitAllocationsByShipmentId(shipmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminShipmentDebitAllocationResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShipmentDebitAllocationsByShipmentId(shipmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Link a shipment with one of its replacement shipments
         * @summary Link a replacement shipment
         * @param {string} shipmentId Id of shipment
         * @param {ReplacementShipmentLink} [replacementShipmentLink] Replacement shipment to link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkShipments(shipmentId: string, replacementShipmentLink?: ReplacementShipmentLink, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponseServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkShipments(shipmentId, replacementShipmentLink, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes shipments searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listShipmentsSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listShipmentsSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Run process and deduct on a single shipment
         * @summary Single shipment process and deduct
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processAndDeductSingleShipment(shipmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processAndDeductSingleShipment(shipmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Shipments that fail rush order end up in ShipmentStateError.  An api call is needed to put them back into StateFulfillmentReady to try again.
         * @summary Recover a shipment that has not shipped from ShipmentStateError
         * @param {string} shipmentId Id of shipment that needs to be recovered
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recoverShipmentError(shipmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponseServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recoverShipmentError(shipmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Forcibly transition the state of a shipment that has been shipped
         * @summary Override shipment state
         * @param {string} shipmentId Id of shipment
         * @param {StateOverride} [stateOverride] State ID to transition to and comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stateOverride(shipmentId: string, stateOverride?: StateOverride, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponseServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stateOverride(shipmentId, stateOverride, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set a new tracking number, carrier, and tracking link for a shipment
         * @summary Update shipment tracking info
         * @param {string} shipmentId Id of shipment
         * @param {TrackingInfoUpdateParams} [trackingInfoUpdateParams] Tracking number and carrier to update and comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackingInfoUpdate(shipmentId: string, trackingInfoUpdateParams?: TrackingInfoUpdateParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponseServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackingInfoUpdate(shipmentId, trackingInfoUpdateParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Remove a link between a shipment and it\'s replacement
         * @summary Unlink a replacement shipment
         * @param {string} shipmentId Id of shipment
         * @param {string} replacementShipmentId Id of replacement shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkShipments(shipmentId: string, replacementShipmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponseServiceAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkShipments(shipmentId, replacementShipmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShipmentsApi - factory interface
 * @export
 */
export const ShipmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShipmentsApiFp(configuration)
    return {
        /**
         * Override a shipment state invalid address or address fail
         * @summary Override invalid address
         * @param {string} shipmentId Id of shipment
         * @param {AddressOverride} [addressOverride] Comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddressOverride(shipmentId: string, addressOverride?: AddressOverride, options?: any): AxiosPromise<ShipmentExactResponseServiceAdmin> {
            return localVarFp.adminAddressOverride(shipmentId, addressOverride, options).then((request) => request(axios, basePath));
        },
        /**
         * Override multiple shipments in state \"invalid address\" or \"address fail\", thus confirming that the addresses are valid.
         * @summary Override invalid address of multiple shipments
         * @param {BulkAddressOverride} [bulkAddressOverride] A non-empty list of shipment IDs to override and a comment to be attached to all overrides.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBulkAddressOverride(bulkAddressOverride?: BulkAddressOverride, options?: any): AxiosPromise<ShipmentAddressBulkOverrideResponse> {
            return localVarFp.adminBulkAddressOverride(bulkAddressOverride, options).then((request) => request(axios, basePath));
        },
        /**
         * Place a request for a shipment on behalf of an org. This is restricted to service admin users.
         * @summary Create a new shipment
         * @param {AdminShipmentRequest} [body] ShipmentRequest to be added to the requesting user\&#39;s organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateShipment(body?: AdminShipmentRequest, options?: any): AxiosPromise<ShipmentExactResponseServiceAdmin> {
            return localVarFp.adminCreateShipment(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a shipment by its ID
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteShipmentById(shipmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminDeleteShipmentById(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all shipping and product refunds
         * @summary Get all refund information
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAllShipmentRefunds(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<AdminRefundResultSet> {
            return localVarFp.adminGetAllShipmentRefunds(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns shipment object with ID
         * @summary Find shipment by ID
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetShipmentExactById(shipmentId: string, options?: any): AxiosPromise<ShipmentExactResponseServiceAdmin> {
            return localVarFp.adminGetShipmentExactById(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes shipment refunds searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetShipmentRefundSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.adminGetShipmentRefundSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all shipping and product refund information for a shipment
         * @summary Get refund information for a shipment
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetShipmentRefunds(shipmentId: string, options?: any): AxiosPromise<AdminShipmentRefundResponse> {
            return localVarFp.adminGetShipmentRefunds(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets shipments, returns them in a JSON array
         * @summary Get shipments
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetShipments(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<ShipmentExactResultSetServiceAdmin> {
            return localVarFp.adminGetShipments(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Update shipment details for the given shipment ID.
         * @summary Update an existing shipment
         * @param {string} shipmentId Id of shipment
         * @param {AdminShipmentUpdateParams} adminShipmentUpdateParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateShipmentById(shipmentId: string, adminShipmentUpdateParams: AdminShipmentUpdateParams, options?: any): AxiosPromise<void> {
            return localVarFp.adminUpdateShipmentById(shipmentId, adminShipmentUpdateParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a replacement shipment for a given shipment
         * @summary Create replacement shipment
         * @param {string} shipmentId Id of shipment
         * @param {CreateReplacementShipmentRequest} [createReplacementShipmentRequest] Replacement shipment request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReplacementShipment(shipmentId: string, createReplacementShipmentRequest?: CreateReplacementShipmentRequest, options?: any): AxiosPromise<ShipmentExactResponseServiceAdmin> {
            return localVarFp.createReplacementShipment(shipmentId, createReplacementShipmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a shipping and/or product refund for a shipment
         * @summary Create a refund for a shipment
         * @param {string} shipmentId Id of shipment
         * @param {ShipmentRefundRequest} [shipmentRefundRequest] Details of what parts of the shipment need to be refunded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentRefund(shipmentId: string, shipmentRefundRequest?: ShipmentRefundRequest, options?: any): AxiosPromise<AdminShipmentRefundResponse> {
            return localVarFp.createShipmentRefund(shipmentId, shipmentRefundRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm or override a shipment in state DPLMatch
         * @summary Confirm or override a DPL match
         * @param {string} shipmentId Id of shipment that needs an address override
         * @param {DPLOverride} [dPLOverride] Override decision and comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dPLOverride(shipmentId: string, dPLOverride?: DPLOverride, options?: any): AxiosPromise<ShipmentExactResponseServiceAdmin> {
            return localVarFp.dPLOverride(shipmentId, dPLOverride, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Place a request for bulk deletion of shipments
         * @param {Array<string>} [requestBody] A JSON list of shipment Ids to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBulkShipment(requestBody?: Array<string>, options?: any): AxiosPromise<ShipmentBulkDeleteResponse> {
            return localVarFp.deleteBulkShipment(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download a CSV with shipments
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {AdminGetDistributorsSearchParameter} [excludedCols] Column names to be excluded from the downloaded CSV file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadShipments(limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, excludedCols?: AdminGetDistributorsSearchParameter, options?: any): AxiosPromise<string> {
            return localVarFp.downloadShipments(limit, sortBy, sortDirection, search, searchField, advancedSearch, excludedCols, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all matching names and addresses found on DPL for a shipment
         * @summary Get dpl information for a shipment
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDPLMatches(shipmentId: string, options?: any): AxiosPromise<GetDPLMatches200Response> {
            return localVarFp.getDPLMatches(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a shipment\'s Debit to Allocation records by its ShipmentId
         * @param {string} shipmentId ID of shipment to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentDebitAllocationsByShipmentId(shipmentId: string, options?: any): AxiosPromise<AdminShipmentDebitAllocationResultSet> {
            return localVarFp.getShipmentDebitAllocationsByShipmentId(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Link a shipment with one of its replacement shipments
         * @summary Link a replacement shipment
         * @param {string} shipmentId Id of shipment
         * @param {ReplacementShipmentLink} [replacementShipmentLink] Replacement shipment to link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkShipments(shipmentId: string, replacementShipmentLink?: ReplacementShipmentLink, options?: any): AxiosPromise<ShipmentExactResponseServiceAdmin> {
            return localVarFp.linkShipments(shipmentId, replacementShipmentLink, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes shipments searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShipmentsSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listShipmentsSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * Run process and deduct on a single shipment
         * @summary Single shipment process and deduct
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAndDeductSingleShipment(shipmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.processAndDeductSingleShipment(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Shipments that fail rush order end up in ShipmentStateError.  An api call is needed to put them back into StateFulfillmentReady to try again.
         * @summary Recover a shipment that has not shipped from ShipmentStateError
         * @param {string} shipmentId Id of shipment that needs to be recovered
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoverShipmentError(shipmentId: string, options?: any): AxiosPromise<ShipmentExactResponseServiceAdmin> {
            return localVarFp.recoverShipmentError(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Forcibly transition the state of a shipment that has been shipped
         * @summary Override shipment state
         * @param {string} shipmentId Id of shipment
         * @param {StateOverride} [stateOverride] State ID to transition to and comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stateOverride(shipmentId: string, stateOverride?: StateOverride, options?: any): AxiosPromise<ShipmentExactResponseServiceAdmin> {
            return localVarFp.stateOverride(shipmentId, stateOverride, options).then((request) => request(axios, basePath));
        },
        /**
         * Set a new tracking number, carrier, and tracking link for a shipment
         * @summary Update shipment tracking info
         * @param {string} shipmentId Id of shipment
         * @param {TrackingInfoUpdateParams} [trackingInfoUpdateParams] Tracking number and carrier to update and comment for override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingInfoUpdate(shipmentId: string, trackingInfoUpdateParams?: TrackingInfoUpdateParams, options?: any): AxiosPromise<ShipmentExactResponseServiceAdmin> {
            return localVarFp.trackingInfoUpdate(shipmentId, trackingInfoUpdateParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a link between a shipment and it\'s replacement
         * @summary Unlink a replacement shipment
         * @param {string} shipmentId Id of shipment
         * @param {string} replacementShipmentId Id of replacement shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkShipments(shipmentId: string, replacementShipmentId: string, options?: any): AxiosPromise<ShipmentExactResponseServiceAdmin> {
            return localVarFp.unlinkShipments(shipmentId, replacementShipmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShipmentsApi - object-oriented interface
 * @export
 * @class ShipmentsApi
 * @extends {BaseAPI}
 */
export class ShipmentsApi extends BaseAPI {
    /**
     * Override a shipment state invalid address or address fail
     * @summary Override invalid address
     * @param {string} shipmentId Id of shipment
     * @param {AddressOverride} [addressOverride] Comment for override
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public adminAddressOverride(shipmentId: string, addressOverride?: AddressOverride, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).adminAddressOverride(shipmentId, addressOverride, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Override multiple shipments in state \"invalid address\" or \"address fail\", thus confirming that the addresses are valid.
     * @summary Override invalid address of multiple shipments
     * @param {BulkAddressOverride} [bulkAddressOverride] A non-empty list of shipment IDs to override and a comment to be attached to all overrides.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public adminBulkAddressOverride(bulkAddressOverride?: BulkAddressOverride, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).adminBulkAddressOverride(bulkAddressOverride, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Place a request for a shipment on behalf of an org. This is restricted to service admin users.
     * @summary Create a new shipment
     * @param {AdminShipmentRequest} [body] ShipmentRequest to be added to the requesting user\&#39;s organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public adminCreateShipment(body?: AdminShipmentRequest, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).adminCreateShipment(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a shipment by its ID
     * @param {string} shipmentId Id of shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public adminDeleteShipmentById(shipmentId: string, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).adminDeleteShipmentById(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all shipping and product refunds
     * @summary Get all refund information
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public adminGetAllShipmentRefunds(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).adminGetAllShipmentRefunds(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns shipment object with ID
     * @summary Find shipment by ID
     * @param {string} shipmentId Id of shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public adminGetShipmentExactById(shipmentId: string, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).adminGetShipmentExactById(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes shipment refunds searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public adminGetShipmentRefundSearchDescription(options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).adminGetShipmentRefundSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all shipping and product refund information for a shipment
     * @summary Get refund information for a shipment
     * @param {string} shipmentId Id of shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public adminGetShipmentRefunds(shipmentId: string, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).adminGetShipmentRefunds(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets shipments, returns them in a JSON array
     * @summary Get shipments
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public adminGetShipments(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).adminGetShipments(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update shipment details for the given shipment ID.
     * @summary Update an existing shipment
     * @param {string} shipmentId Id of shipment
     * @param {AdminShipmentUpdateParams} adminShipmentUpdateParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public adminUpdateShipmentById(shipmentId: string, adminShipmentUpdateParams: AdminShipmentUpdateParams, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).adminUpdateShipmentById(shipmentId, adminShipmentUpdateParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a replacement shipment for a given shipment
     * @summary Create replacement shipment
     * @param {string} shipmentId Id of shipment
     * @param {CreateReplacementShipmentRequest} [createReplacementShipmentRequest] Replacement shipment request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public createReplacementShipment(shipmentId: string, createReplacementShipmentRequest?: CreateReplacementShipmentRequest, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).createReplacementShipment(shipmentId, createReplacementShipmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a shipping and/or product refund for a shipment
     * @summary Create a refund for a shipment
     * @param {string} shipmentId Id of shipment
     * @param {ShipmentRefundRequest} [shipmentRefundRequest] Details of what parts of the shipment need to be refunded
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public createShipmentRefund(shipmentId: string, shipmentRefundRequest?: ShipmentRefundRequest, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).createShipmentRefund(shipmentId, shipmentRefundRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm or override a shipment in state DPLMatch
     * @summary Confirm or override a DPL match
     * @param {string} shipmentId Id of shipment that needs an address override
     * @param {DPLOverride} [dPLOverride] Override decision and comment for override
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public dPLOverride(shipmentId: string, dPLOverride?: DPLOverride, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).dPLOverride(shipmentId, dPLOverride, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Place a request for bulk deletion of shipments
     * @param {Array<string>} [requestBody] A JSON list of shipment Ids to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public deleteBulkShipment(requestBody?: Array<string>, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).deleteBulkShipment(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download a CSV with shipments
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {AdminGetDistributorsSearchParameter} [excludedCols] Column names to be excluded from the downloaded CSV file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public downloadShipments(limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, excludedCols?: AdminGetDistributorsSearchParameter, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).downloadShipments(limit, sortBy, sortDirection, search, searchField, advancedSearch, excludedCols, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all matching names and addresses found on DPL for a shipment
     * @summary Get dpl information for a shipment
     * @param {string} shipmentId Id of shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public getDPLMatches(shipmentId: string, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).getDPLMatches(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a shipment\'s Debit to Allocation records by its ShipmentId
     * @param {string} shipmentId ID of shipment to be fetched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public getShipmentDebitAllocationsByShipmentId(shipmentId: string, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).getShipmentDebitAllocationsByShipmentId(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Link a shipment with one of its replacement shipments
     * @summary Link a replacement shipment
     * @param {string} shipmentId Id of shipment
     * @param {ReplacementShipmentLink} [replacementShipmentLink] Replacement shipment to link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public linkShipments(shipmentId: string, replacementShipmentLink?: ReplacementShipmentLink, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).linkShipments(shipmentId, replacementShipmentLink, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes shipments searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public listShipmentsSearchDescription(options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).listShipmentsSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Run process and deduct on a single shipment
     * @summary Single shipment process and deduct
     * @param {string} shipmentId Id of shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public processAndDeductSingleShipment(shipmentId: string, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).processAndDeductSingleShipment(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Shipments that fail rush order end up in ShipmentStateError.  An api call is needed to put them back into StateFulfillmentReady to try again.
     * @summary Recover a shipment that has not shipped from ShipmentStateError
     * @param {string} shipmentId Id of shipment that needs to be recovered
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public recoverShipmentError(shipmentId: string, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).recoverShipmentError(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Forcibly transition the state of a shipment that has been shipped
     * @summary Override shipment state
     * @param {string} shipmentId Id of shipment
     * @param {StateOverride} [stateOverride] State ID to transition to and comment for override
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public stateOverride(shipmentId: string, stateOverride?: StateOverride, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).stateOverride(shipmentId, stateOverride, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set a new tracking number, carrier, and tracking link for a shipment
     * @summary Update shipment tracking info
     * @param {string} shipmentId Id of shipment
     * @param {TrackingInfoUpdateParams} [trackingInfoUpdateParams] Tracking number and carrier to update and comment for override
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public trackingInfoUpdate(shipmentId: string, trackingInfoUpdateParams?: TrackingInfoUpdateParams, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).trackingInfoUpdate(shipmentId, trackingInfoUpdateParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a link between a shipment and it\'s replacement
     * @summary Unlink a replacement shipment
     * @param {string} shipmentId Id of shipment
     * @param {string} replacementShipmentId Id of replacement shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public unlinkShipments(shipmentId: string, replacementShipmentId: string, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).unlinkShipments(shipmentId, replacementShipmentId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TermsAndConditionsApi - axios parameter creator
 * @export
 */
export const TermsAndConditionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This is a destructive action, restricted to service owners, that will set all users\' T&C to default, so they can agree to the new T&C upon login to YED.
         * @summary Reset terms and conditions for all users.
         * @param {ResetTermsAndConditionsRequest} [resetTermsAndConditionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetAllTermsAndConditions: async (resetTermsAndConditionsRequest?: ResetTermsAndConditionsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/reset-all-terms-and-conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetTermsAndConditionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TermsAndConditionsApi - functional programming interface
 * @export
 */
export const TermsAndConditionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TermsAndConditionsApiAxiosParamCreator(configuration)
    return {
        /**
         * This is a destructive action, restricted to service owners, that will set all users\' T&C to default, so they can agree to the new T&C upon login to YED.
         * @summary Reset terms and conditions for all users.
         * @param {ResetTermsAndConditionsRequest} [resetTermsAndConditionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetAllTermsAndConditions(resetTermsAndConditionsRequest?: ResetTermsAndConditionsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetAllTermsAndConditions(resetTermsAndConditionsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TermsAndConditionsApi - factory interface
 * @export
 */
export const TermsAndConditionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TermsAndConditionsApiFp(configuration)
    return {
        /**
         * This is a destructive action, restricted to service owners, that will set all users\' T&C to default, so they can agree to the new T&C upon login to YED.
         * @summary Reset terms and conditions for all users.
         * @param {ResetTermsAndConditionsRequest} [resetTermsAndConditionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetAllTermsAndConditions(resetTermsAndConditionsRequest?: ResetTermsAndConditionsRequest, options?: any): AxiosPromise<void> {
            return localVarFp.resetAllTermsAndConditions(resetTermsAndConditionsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TermsAndConditionsApi - object-oriented interface
 * @export
 * @class TermsAndConditionsApi
 * @extends {BaseAPI}
 */
export class TermsAndConditionsApi extends BaseAPI {
    /**
     * This is a destructive action, restricted to service owners, that will set all users\' T&C to default, so they can agree to the new T&C upon login to YED.
     * @summary Reset terms and conditions for all users.
     * @param {ResetTermsAndConditionsRequest} [resetTermsAndConditionsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermsAndConditionsApi
     */
    public resetAllTermsAndConditions(resetTermsAndConditionsRequest?: ResetTermsAndConditionsRequest, options?: AxiosRequestConfig) {
        return TermsAndConditionsApiFp(this.configuration).resetAllTermsAndConditions(resetTermsAndConditionsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes both passwords and webauthn credentials from a users account
         * @summary Deletes credentials from a user\'s account
         * @param {string} userId ID of the user to delete credentials for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCredentials: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteCredentials', 'userId', userId)
            const localVarPath = `/v1/serviceadmin/users/{userId}/delete-credentials`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user by userId
         * @param {string} userId ID of User to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserById', 'userId', userId)
            const localVarPath = `/v1/serviceadmin/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finds users by name of all users, returns users objects as JSON array.  Results are not restrict by org.
         * @summary Finds users by name of all users
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes users searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/serviceadmin/users/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a user from an organization
         * @param {string} orgId ID of the Organization
         * @param {string} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromOrganization: async (orgId: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('removeUserFromOrganization', 'orgId', orgId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeUserFromOrganization', 'userId', userId)
            const localVarPath = `/v1/serviceadmin/organizations/{orgId}/users/{userId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset a user\'s account and send them an account reset email. Any open session the user has will be dropped.
         * @summary Reset a user\'s account and send them an account reset email
         * @param {string} userId ID of the user to reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUser: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('resetUser', 'userId', userId)
            const localVarPath = `/v1/serviceadmin/users/{userId}/reset`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset a user\'s password and send them a password reset email. Any open session the user has will remain active, but the user will not be able to log in again until they complete the password reset.
         * @summary Reset a user\'s password and send them a password reset email
         * @param {string} userId ID of the user whose password to reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('resetUserPassword', 'userId', userId)
            const localVarPath = `/v1/serviceadmin/users/{userId}/reset-password`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Suspend a user\'s account. Any open session the user has, and it\'s credentials will be dropped. The user will not be able to log in again.
         * @summary Suspends a user\'s account
         * @param {string} userId ID of the user to suspend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendUser: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('suspendUser', 'userId', userId)
            const localVarPath = `/v1/serviceadmin/users/{userId}/suspend`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unsuspend a user\'s account. The user is moved back to inactive status, and are still not permitted to login.
         * @summary Unsuspends a user\'s account
         * @param {string} userId ID of the user to unsuspend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsuspendUser: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('unsuspendUser', 'userId', userId)
            const localVarPath = `/v1/serviceadmin/users/{userId}/unsuspend`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user role by userId
         * @param {string} userId ID of the User
         * @param {UpdateUserParams} [updateUserParams] Update user role object. Roles[] is a new, experimental field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRoleInOrganization: async (userId: string, updateUserParams?: UpdateUserParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserRoleInOrganization', 'userId', userId)
            const localVarPath = `/v1/serviceadmin/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes both passwords and webauthn credentials from a users account
         * @summary Deletes credentials from a user\'s account
         * @param {string} userId ID of the user to delete credentials for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCredentials(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCredentials(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user by userId
         * @param {string} userId ID of User to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserById(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserById(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Finds users by name of all users, returns users objects as JSON array.  Results are not restrict by org.
         * @summary Finds users by name of all users
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes users searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsersSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsersSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove a user from an organization
         * @param {string} orgId ID of the Organization
         * @param {string} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeUserFromOrganization(orgId: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeUserFromOrganization(orgId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Reset a user\'s account and send them an account reset email. Any open session the user has will be dropped.
         * @summary Reset a user\'s account and send them an account reset email
         * @param {string} userId ID of the user to reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetUser(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Reset a user\'s password and send them a password reset email. Any open session the user has will remain active, but the user will not be able to log in again until they complete the password reset.
         * @summary Reset a user\'s password and send them a password reset email
         * @param {string} userId ID of the user whose password to reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetUserPassword(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetUserPassword(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Suspend a user\'s account. Any open session the user has, and it\'s credentials will be dropped. The user will not be able to log in again.
         * @summary Suspends a user\'s account
         * @param {string} userId ID of the user to suspend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suspendUser(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suspendUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Unsuspend a user\'s account. The user is moved back to inactive status, and are still not permitted to login.
         * @summary Unsuspends a user\'s account
         * @param {string} userId ID of the user to unsuspend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsuspendUser(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsuspendUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update user role by userId
         * @param {string} userId ID of the User
         * @param {UpdateUserParams} [updateUserParams] Update user role object. Roles[] is a new, experimental field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserRoleInOrganization(userId: string, updateUserParams?: UpdateUserParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserRoleInOrganization(userId, updateUserParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * Deletes both passwords and webauthn credentials from a users account
         * @summary Deletes credentials from a user\'s account
         * @param {string} userId ID of the user to delete credentials for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCredentials(userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCredentials(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user by userId
         * @param {string} userId ID of User to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(userId: string, options?: any): AxiosPromise<User> {
            return localVarFp.getUserById(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Finds users by name of all users, returns users objects as JSON array.  Results are not restrict by org.
         * @summary Finds users by name of all users
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<UserResultSet> {
            return localVarFp.getUsers(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes users searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listUsersSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a user from an organization
         * @param {string} orgId ID of the Organization
         * @param {string} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromOrganization(orgId: string, userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeUserFromOrganization(orgId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Reset a user\'s account and send them an account reset email. Any open session the user has will be dropped.
         * @summary Reset a user\'s account and send them an account reset email
         * @param {string} userId ID of the user to reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUser(userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.resetUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Reset a user\'s password and send them a password reset email. Any open session the user has will remain active, but the user will not be able to log in again until they complete the password reset.
         * @summary Reset a user\'s password and send them a password reset email
         * @param {string} userId ID of the user whose password to reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword(userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.resetUserPassword(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Suspend a user\'s account. Any open session the user has, and it\'s credentials will be dropped. The user will not be able to log in again.
         * @summary Suspends a user\'s account
         * @param {string} userId ID of the user to suspend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendUser(userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.suspendUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Unsuspend a user\'s account. The user is moved back to inactive status, and are still not permitted to login.
         * @summary Unsuspends a user\'s account
         * @param {string} userId ID of the user to unsuspend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsuspendUser(userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.unsuspendUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user role by userId
         * @param {string} userId ID of the User
         * @param {UpdateUserParams} [updateUserParams] Update user role object. Roles[] is a new, experimental field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRoleInOrganization(userId: string, updateUserParams?: UpdateUserParams, options?: any): AxiosPromise<void> {
            return localVarFp.updateUserRoleInOrganization(userId, updateUserParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * Deletes both passwords and webauthn credentials from a users account
     * @summary Deletes credentials from a user\'s account
     * @param {string} userId ID of the user to delete credentials for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public deleteCredentials(userId: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteCredentials(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user by userId
     * @param {string} userId ID of User to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserById(userId: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserById(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Finds users by name of all users, returns users objects as JSON array.  Results are not restrict by org.
     * @summary Finds users by name of all users
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {AdminGetDistributorsSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {AdminGetDistributorsSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUsers(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: AdminGetDistributorsSearchParameter, searchField?: AdminGetDistributorsSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUsers(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes users searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public listUsersSearchDescription(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).listUsersSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a user from an organization
     * @param {string} orgId ID of the Organization
     * @param {string} userId ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public removeUserFromOrganization(orgId: string, userId: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).removeUserFromOrganization(orgId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reset a user\'s account and send them an account reset email. Any open session the user has will be dropped.
     * @summary Reset a user\'s account and send them an account reset email
     * @param {string} userId ID of the user to reset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public resetUser(userId: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).resetUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reset a user\'s password and send them a password reset email. Any open session the user has will remain active, but the user will not be able to log in again until they complete the password reset.
     * @summary Reset a user\'s password and send them a password reset email
     * @param {string} userId ID of the user whose password to reset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public resetUserPassword(userId: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).resetUserPassword(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Suspend a user\'s account. Any open session the user has, and it\'s credentials will be dropped. The user will not be able to log in again.
     * @summary Suspends a user\'s account
     * @param {string} userId ID of the user to suspend
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public suspendUser(userId: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).suspendUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unsuspend a user\'s account. The user is moved back to inactive status, and are still not permitted to login.
     * @summary Unsuspends a user\'s account
     * @param {string} userId ID of the user to unsuspend
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public unsuspendUser(userId: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).unsuspendUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user role by userId
     * @param {string} userId ID of the User
     * @param {UpdateUserParams} [updateUserParams] Update user role object. Roles[] is a new, experimental field.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserRoleInOrganization(userId: string, updateUserParams?: UpdateUserParams, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUserRoleInOrganization(userId, updateUserParams, options).then((request) => request(this.axios, this.basePath));
    }
}


